import React, { useEffect, useState, useRef, useContext, Suspense, useCallback , useMemo} from 'react';
import { useNavigate } from "react-router-dom";

import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from "axios";
import TagManager from 'react-gtm-module';

import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Grow, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { KeyboardArrowDown, AccessTime, ExpandMore } from '@mui/icons-material';

import AccordionSidebar from "Components/AccordionSidebar/AccordionSidebar";
import Img from 'Components/Img';
import DeliveryInfo from '../DeliveryInfo';
import ModelNew from "Components/Model/ModelNew";
import CloseButton from "Components/CloseButton/index";
import Button from 'Components/Common/Button';
import ServicesDetails from "Components/Header/BottomHeader/ServicesDetails";
import InfoDetails from 'Components/Header/BottomHeader/InfoDetails';
import ColorPicker from '../ColorPicker';

import DomainContext from "Context/DomainContext";
import { ACTION_OPENCART, ACTION__MINICART__ITEMS, ACTION_GUESTKEY, ACTION_GUESTQUOTE__DETAILS, ACTION_OPEN__LOGIN, ACTION_WISHLISTPRODUCTID, ACTION_OPEN__FORGOTPASSWORD, ACTION_GET__URLTYPE,ACTION__CHARACTERISTICS } from 'Store/action';
import { APIQueryGet, APIQueryPost } from 'APIMethods/API';
import { addWishList, useWindowSize, getCartItems, SessionExpiredLogout, removeWishlist, triggerHotjarEvent, handleImage } from "Utilities";

import { TickIcon, ValidSuccesArrow, WishIcon, CopyUrl, FullWishlist, InfoPdpIcon } from 'Res/icons';
import { ReactComponent as RefundIcon } from "../../../../Res/images/icon-refund-money.svg"
import "./styles.scss";

const UploadImages = React.lazy(() => import("../UploadImages"));

const manualSizeUnitList = ["mm", "cm", "m"]

const euroCurrency = (val) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', symbol: "" }).format(val).replace(" ", "").replace("€", "");

const BlackTooltip = styled(({ className, ...props }) => (<Tooltip {...props} arrow classes={{ popper: className }} />))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: { color: theme.palette.common.black },
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.palette.common.black, font: "normal normal 300 13px/18px Poppins", padding: 16, borderRadius: 10 },
}));
const addArrayObj = (a, b) => a.map((a1, i) => {
  const ab = b.filter((b1) => b1.qty === a1.qty)
  return ab.length ? { ...a1, price: ((a1.price || 0) + (ab[0].price || 0)) } : { qty: a1.qty, price: a1.price, q: a1.qty, p: a1.price, hide: true }
}
);

const UpdateTextQty = (qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions) => {
  const option = getApiCartOptions();
  let qty = null;
  const tPrice = selectedDetailsFinal?.tier_prices;
  const increment = selectedDetailsFinal?.qty_increments || 1;

  const adjustedQtyTemp = Math.round(qtyTemp / increment) * increment;

  if (tPrice?.length) {
    qty = (adjustedQtyTemp >= tPrice[0].qty) ? adjustedQtyTemp : tPrice[0].qty;
  } else if (!tPrice?.length && (selectedDetailsFinal?.price > 0) && selectedDetailsFinal?.min_sale_qty) {
    qty = (adjustedQtyTemp >= selectedDetailsFinal.min_sale_qty) ? adjustedQtyTemp : selectedDetailsFinal.min_sale_qty;
  }

  if (qty !== null) {
    setTimeout(() => {
      getDeliveryDate(option, qty);
    }, 1000);
    setQty(qty);
    setQtyTemp(qty);
  }
};

const addHyphens = (text) => {
  return text || '';
};

// Calculating single qty tier price from total price based on the condition "one_time"
const getSingleTierPrice = (tp) => {
  const tier_prices = [...tp]
  tier_prices.forEach((item, index) => {
    const price =
      item?.price > 0 && item?.qty > 0 ? item.price / item.qty : 0;
    tier_prices[index] = {
      ...item,
      price,
    };
  });
  return tier_prices;
};

const InputNumber = ({ name, min = "0", max = "0", val, setVal }) => {
  const [value, setValue] = useState("");
  const [inputVal, setInputVal] = useState(0);
  const validateUpdate = (v) => parseInt(v > min ? v < max ? v : max : min);
  const updateBy = (i = 0) => setInputVal(validateUpdate(typeof (i) === "number" ? (parseInt(value) + i) : parseInt(i)));
  const update = (e) => setValue(e.target.value);

  useEffect(() => {
    const interval = setTimeout(() => {
      if (value !== inputVal) {
        const temp = validateUpdate(parseInt(value));
        if (temp === parseInt(inputVal)) setValue(temp);
        setInputVal(temp);
      }
    }, 2000);
    if (value === inputVal) setValue(`${validateUpdate(inputVal)}`);
    return () => clearInterval(interval);
  }, [value]);

  useEffect(() => {
    const temp = validateUpdate(inputVal);
    if (value !== temp) setValue(`${temp}`);
    if (val !== temp) setVal(temp);
  }, [inputVal]);

  useEffect(() => {
    const temp = validateUpdate(validateUpdate(parseInt(val)));
    setValue(`${temp}`); setInputVal(temp);
  }, []);

  return (
    <div className="flex col middle gap-2 numberButton">
      <div className="flex center">
        <h5>{name}</h5>
      </div>
      <div className="flex center" style={{ border: "1px solid #CCCCCC", borderRadius: 5, height: 42 }}>
        <button aria-label="button" disabled={inputVal <= min} onClick={() => updateBy(-1)} value="Decrease Value">-</button>
        <input style={{ width: max.length * 10 || 20 }} type="number" value={value} onChange={update} onBlur={() => updateBy(value)} />
        <button aria-label="button"
          disabled={inputVal >= max} onClick={() => updateBy(1)} value="Increase Value">+</button>
      </div>
    </div>
  );
}

const InputTextBox = ({
  setInputFieldExpand,
  selectedData,
  setSelectedData,
  keyName,
  placeholder,
  setInputManualSize,
  setExpanded,
  setStopNextNav,
  allData = { allData }
}) => {
  const [val, setVal] = useState("");
  const { t } = useTranslation();

  const act = () => {
    const trimmedValue = val.trim();
    const temp = { ...selectedData };

    if (trimmedValue) {
      temp[keyName] = [`${btoa(trimmedValue)}YYYY`];
    } else {
      delete temp[keyName];
    }
    const containsValidValue =
      temp[keyName] && temp[keyName].some((item) => item.includes("YYYY") && item.length > 4);

    if (containsValidValue) {
      setSelectedData(temp);
      setInputFieldExpand(false);
      return true;
    } else {
      setSelectedData(temp);
      setInputFieldExpand(true);
      return false;
    }
  };

  useEffect(() => {
    let v = selectedData[keyName];
    if (Array.isArray(v)) {
      v = v.join(", ");
    }
    if (v?.includes("YYYY")) {
      v = v.replace("YYYY", "");
    }

    const decodedValue = v ? atob(v) : "";

    if (decodedValue !== val) {
      setVal(decodedValue);
      setInputManualSize(decodedValue);
    } else if (!decodedValue) {
      setVal("");
      setInputManualSize("");
    }
  }, [selectedData[keyName]]);

  return (
    <>
      {allData[keyName]?.varientType === "area" ? (
        <textarea
          value={val}
          placeholder={placeholder}
          onChange={(e) => {
            setVal(e.target.value);
            setInputManualSize(e.target.value);
          }}
          style={{ height: "100px" }}
        />
      ) : (
        <input
          value={val}
          placeholder={placeholder}
          onChange={(e) => {
            setVal(e.target.value);
            setInputManualSize(e.target.value);
          }}
        />
      )}
      <div>
        <Button
  onClick={() => {
    const isValid = act();
    if (isValid) {
      setExpanded(true); 
      setStopNextNav(false); 
    } else {
      setExpanded(false); 
      setStopNextNav(true);
    }
  }}
  className="contained sm mt-4 py-2 px-4 r-9 primary"
>
  <span className='no-translate notranslate'>{t("volgende")}</span>
</Button>
      </div>
    </>
  );
};

const InputQtyBox = ({ data, keyName, setAllData, allData, index }) => {
  const [val, setVal] = useState("");
  const update = (v) => {
    const temp = { ...allData }
    if (val !== data.qty) {

      if (keyName)
        temp[keyName][index] = { ...temp[keyName][index], qty: v }
      else
        temp[index] = { ...temp[index], qty: v }
      setAllData(temp);
    }
  }
  const act = (v) => {
    const temp = (parseInt(val) > data.minQty) ? Math.round(val) : data.minQty;
    update(temp);
    setVal(temp)
  }
  useEffect(() => {
    if (data.qty && val === "") {
      setVal(data.qty >= data.minQty ? data.qty : data.minQty);
    }
  }, [data]);

  return (
    <input value={val} placeholder=' - '
      onKeyDown={(e) => (e.key === 'Enter') && act()}
      onBlur={() => act()}
      onChange={(e) => setVal(e.target.value)}
    />
  )
};

const InputQtyBoxArr = ({ data, setAllData, allData, index}) => {
  const [val, setVal] = useState(0);
  const update = (v) => {
    const temp = [...allData];
    if (parseFloat(data.qty) !== parseFloat(v)) {
      temp[index] = { ...temp[index], qty: v };
      setAllData(temp);
    }
  };

  const act = (v) => {
      const num = parseInt(v, 10);
      const temp = num === 0 ? 0 : Math.max(Math.round(num), data.allProMinQty);
      update(temp);
      setVal(temp.toString());
  };


  useEffect(() => {
    if (data?.qty && val === 0) {
      setVal(data.qty >= data.allProMinQty ? data?.qty?.toString() : data?.allProMinQty?.toString());
    } else if(data?.qty === 0 && val !== 0){
      setVal(0);
    }
  }, [data]);

  return (
    <div className="input__container flex center relative configure_input_section">
      {data?.enable_qty_increments == 1 ? 
      <button
       className='configure_decrement'
       title= {data?.enable_qty_increments == 1 && `stapsgewijze hoeveelheid door ${parseFloat(data?.qty_increments)}`} 
        onClick={() => {
          let qtyIncrement = parseFloat(data?.qty_increments);
          let newVal = parseFloat(val) - qtyIncrement;
          if (newVal < 0) newVal = 0;
          setVal(newVal.toString());
          act(newVal);
        }}
        aria-label="button"
        style={{
          position: "absolute",
          left: "15px",
          padding: "10px 12px",
        }}
      >
        -
      </button>
      :""}
     <input
     className='configure_input'
        title= {data?.allProMinQty && `Minimum bestelgrootte ${parseFloat(data?.allProMinQty)}`} 
        style={data?.enable_qty_increments == 1
        ? { height: "42px", textAlign: "center", padding: "8px 32px" }
        : undefined}
        value={val}
        placeholder="0"
        onKeyDown={(e) => e.key === "Enter" && act(val)}
                onBlur={(e) => {
          let inputValue = e.target.value.trim();
          let value = parseInt(inputValue, 10);
          if (isNaN(value)) value = 0;
          if (data?.enable_qty_increments == 1) {
            let qtyIncrement = parseFloat(data?.qty_increments);

            if (qtyIncrement) {
              value = Math.round(value / qtyIncrement) * qtyIncrement;
            }
            if (value < 0) value = 0;
            if (value > 50000) value = 50000;

            setVal(value.toString());
            act(value);
          } else {
            if (value < 0) value = 0;
            if (value > 50000) value = 50000;

            setVal(value.toString());
            act(value);
          }
        }}

        onChange={(e) => {
          const inputVal = e.target.value;
          const numericVal = inputVal.replace(/\D/g, ""); // Remove non-numeric characters
          let value = parseInt(numericVal, 10); // Convert to number
           if (isNaN(value)) value = "";
          else if (value > 50000) value = 50000;
          setVal(value.toString());
        }}
      />
       {data?.enable_qty_increments == 1 ? 
      <button
      className='configure_increment'
        title= {data?.enable_qty_increments == 1 && `stapsgewijze hoeveelheid door ${parseFloat(data?.qty_increments)}`} 
        onClick={() => {
          let qtyIncrement = parseFloat(data?.qty_increments);
          let newVal = parseFloat(val) + qtyIncrement;
          if (newVal > 50000) newVal = 50000;
          setVal(newVal.toString());
          act(newVal);
        }}
        style={{
          position: "absolute",
          right: "15px",
          padding: "10px 12px",
        }}
        aria-label="button"
      >
        +
      </button> : ""}
    </div>
  );
};

const ContentInputNumber = ({ name, min, max, val, setVal }) => (
  <div className='flex left middle gap-5'>
    <InputNumber name={name} min={min} max={max} val={val} setVal={setVal} />
  </div>
);

const ContentManualSize = ({ name, min, max, val, setVal, name1, min1, max1, val1, setVal1 }) => (
  <div className='flex col gap-4 w-1/1 manualSize'>
    <div>
    <p><span className='no-translate notranslate'>{t("Geef_de_gewenste_afmeting_op")}</span> <span>{` (min. ${min} / max. ${max})`}</span></p> 
   </div>
    <div className='flex left gap-5'>
      {name ? (
        <ContentInputNumber key={`${name}_1`} name={name} min={min} max={max} val={val} setVal={setVal} />
      ) : null}
      {name1 && setVal1 ? (
        <ContentInputNumber key={`${name}_2`} name={name1} min={min1} max={max1} val={val1} setVal={setVal1} />
      ) : null}
    </div>
  </div>
);

const VariantHeader = ({
  isError,
  id,
  additional,
  name,
  order = "1",
  expanded,
  completed = false,
  selectedItem,
  label,
  translate,
  showError,
  isValidTier,
  isRequiredError
}) => {
  const condition = React.useMemo(() => {
    if (!label || !label.length) return [];

    const getTranslated = (item) =>
      translate?.[`${item}`.toLowerCase()] || item;

    if (Array.isArray(label)) {
      const translated = label.map(getTranslated);
      return additional
        ? translated.filter((item) => item.trim().toLowerCase() !== "geen")
        : translated;
    } else {
      const parts = label
        .replace(/, /g, ",")
        .split(",");
      const translated = parts.map(getTranslated);
      return additional
        ? translated.filter((item) => item.trim().toLowerCase() !== "geen")
        : translated;
    }
  }, [label, additional, translate]);

  const Name = translate?.[`${name}`.toLowerCase()] || name;
  const showGeenSelectie = condition.length == 0  ;
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

     const handleClick = () => {
      if (isMobile) {
      setOpen(true);
      setTimeout(() => setOpen(false), 3000);
    }
     };

  return (
    <AccordionSummary 
    // aria-controls={`acc-content-${id}`} id={`acc_header-${id}`}
    >
      <div className='flex w-1/1 middle gap-2 variantHeader'>
        <span className={`status flex center middle ${Boolean(completed)}`}>
          {completed ? <TickIcon  role="presentation"  /> : order}
        </span>

        <span style={{display : "flex"}}  onClick={handleClick} role="heading"  aria-level="2" tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") {handleClick();}}}>{Name}{(condition.length || showGeenSelectie) ? <span role='heading' aria-level="2" style={{ display : showGeenSelectie ? 'none' : 'block'}}>{":"}</span> : ""}</span>

        <span className="flex-1 relative overflow-hidden nowarp">
           {
            isRequiredError?.value && name === isRequiredError?.key ?
           <>
            {
            isMobile ? (
                  <Tooltip
                    title="Onbedrukt niet mogelijk"
                    open={open}
                    onClose={() => setOpen(false)}
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                    placement="bottom"
                  >
                    <i
                      onClick={handleClick}
                      style={{ color: "red", cursor: "pointer" }}
                      className="md-inline absolute w-1/1"
                    >
                    {t("Onbedrukt_niet_mogelijk")}
                    </i>
                  </Tooltip>
                ) : (
                  <i
                    title="Onbedrukt niet mogelijk"
                    style={{ color: "red" }}
                    className="md-inline absolute w-1/1"
                  >
                   {t("Onbedrukt_niet_mogelijk")}
                  </i>
                )
              }
           </>
           
          : condition.length ? (
            <i className='hide md-inline absolute w-1/1' style={{paddingRight:expanded ? "78px" : 0}}>{condition.join(', ')}</i>
          ) : isError || showError ? (
            <i style={{ color: "red" }} className='hide md-inline absolute w-1/1'>
              {translate?.["kieseenoptie"] || "Kies een optie"}
            </i>
          ) : showGeenSelectie ? (
            <i className="translated-label no-translate notranslate">{t("Geenselectie")}</i>
          ) : null}
        </span>

        {!expanded && completed ? (
          <span className="flex center middle show"><EditIcon role="presentation" /></span>
        ) : null}
      </div>
    </AccordionSummary>
  );
};


const TooltipEle = ({ product }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [width] = useWindowSize();
  const tooltipRef = useRef(null);
  const isMobile = width < 992;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleTooltipToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
  };


const tooltipContent = (
    <div className='flex col gap-3' ref={tooltipRef}>
      <div className='flex col gap-1' >
        <b className='no-translate notranslate'>{t("Huidige_voorraad")}</b>
        <p className='no-translate notranslate'>{product?.qty} {product?.qty === 1 ? <span className='no-translate notranslate'>{t("stuk")}</span> : <span className='no-translate notranslate'>{t("stuks")}</span>}</p>
      </div>
      {product?.shipping_info && (
        <div className='lg-flex lg-col lg-gap-1'>
          <b className='no-translate notranslate'>{t("Nieuwe_voorraad_onderweg")}</b>
          <p dangerouslySetInnerHTML={{ __html: product?.shipping_info }}></p>
        </div>
      )}
    </div>
  );

  return (
    <BlackTooltip
      open={isOpen}
      onClose={() => setIsOpen(false)}
      disableFocusListener={isMobile}
      disableHoverListener={isMobile}
      disableTouchListener={isMobile}
      title={tooltipContent}
      enterTouchDelay={0}
      leaveTouchDelay={isMobile ? 9999999 : undefined}
    >
      <div
        className="time flex gap-1 middle center" style={{ color: "#FF8800", fontWeight: "normal", position: "relative", zIndex: "1", fontSize: "15px" }}
        onClick={handleTooltipToggle}
        onMouseEnter={() => !isMobile && setIsOpen(true)}
        onMouseLeave={() => !isMobile && setIsOpen(false)}
      >
        <div className="flex center middle icon"><AccessTime /></div>
       <div className='fs-12 no-translate notranslate'>{t(`voorraad_info`)}</div>      
      </div>
    </BlackTooltip>
  );

}; 

const VariantCard = ({setchangeCustomizeOption, qty, getApiCartOptions, getDeliveryDate, manualsizelabel, setmanualsizelabel, setmanualsizestr, selectedManualSizeData, setSelectedManualSizeData, selectedDetails, keyList, selected, setSelected, data, variantData, expandNext, setStopNextNav, isSample, translate , lastVariantKey, setsamplenextNav }) => {
  const variantKey = keyList[0], mutiSelect = isSample || variantData?.mutiSelect;
  const variantIndex = selectedDetails?.[variantKey]?.variantIndex || 0;
  const [sizeInit, setSizeInit] = useState("");
  const [sizeVar, setSizeVar] = useState(null);
  const [sizeVal, setSizeVal] = useState(null);
  const [prevKey, setPrevKey] = useState("");
  const [isValid, setIsValid] = useState(false);
  const sampleHandledRef = useRef(false);
  const unit = sizeVar?.manual_size_entity > -1 ? parseInt(sizeVar?.manual_size_entity) : 0;
  let v = { ...sizeVal };
  const getSize = (v, key) => {
    let size = 0;
    if (key === "circle") {
      const l = v[key]?.["diameter"] || 1;
      size = 22 / 7 * Math.pow((l / 2), 2)
    } else if (key === "square") {
      const l = v[key]?.["length"] || 1;
      size = Math.pow(l, 2)
    } else if (key === "standard") {
      const l = v[key]?.["length"] || 1, w = v[key]?.["width"] || 1;
      size = l * w;
    }
    return Math.round(size);
  }
  const getPrice = (manualSize, manual_size_tier_price) => {
    let price = 0;
    manual_size_tier_price.forEach((manualTier) => {
      if (parseFloat(manualSize) >= parseFloat(manualTier.manual_size)) {
        price = parseFloat(manualSize) * parseFloat(manualTier.price);
      }
    });
    return isNaN(parseFloat(price.toFixed(2))) ? 0 : parseFloat(price.toFixed(2));
  }
  const updateSizeVal = (key, val, key2) => {
    if (sizeInit) {
      if (key2) {
        if (!v[key]) {
          v = {}; v[key] = {};
        }
        v[key][key2] = val;
      } else v[key] = val;
      v[key]["size"] = getSize(v, key);
      v[key]["price"] = getPrice(v[key]["size"], sizeVar?.manual_size_tier_price?.length ? sizeVar.manual_size_tier_price : []);
      setSizeVal({ ...v });
    }
  }
  const checkValue = (v, min, max) => parseInt(v > min ? v < max ? v : max : min);

  //commeneted for purpose
  // useEffect(() => {
  //   let key = "", val = null;
  //   if (sizeVar && selectedManualSizeData && Object.keys(selectedManualSizeData).length) {
  //     val = {};
  //     Object.keys(selectedManualSizeData).map((k) => {
  //       if (k === "circle" && sizeVar?.manual_size_diameter_min && sizeVar?.manual_size_diameter_max) {
  //         val[k] = {}; key = k;
  //         const l = selectedManualSizeData[k]?.["diameter"] || 1;
  //         val[k]["diameter"] = checkValue(l, sizeVar.manual_size_diameter_min, sizeVar.manual_size_diameter_max);
  //       } else if (k === "square" && sizeVar?.manual_size_length_min && sizeVar?.manual_size_length_max) {
  //         val[k] = {}; key = k;
  //         const l = selectedManualSizeData[k]?.["length"] || 1;
  //         val[k]["length"] = checkValue(l, sizeVar.manual_size_length_min, sizeVar.manual_size_length_max);
  //       } else if (k === "standard" && sizeVar?.manual_size_length_min && sizeVar?.manual_size_length_max && sizeVar?.manual_size_length_min && sizeVar?.manual_size_length_max) {
  //         val[k] = {}; key = k;
  //         const l = selectedManualSizeData[k]?.["length"] || 1, w = selectedManualSizeData[k]?.["width"] || 1;
  //         val[k]["length"] = checkValue(l, sizeVar.manual_size_length_min, sizeVar.manual_size_length_max);
  //         val[k]["width"] = checkValue(w, sizeVar.manual_size_width_min, sizeVar.manual_size_width_max);
  //       }
  //     })
  //     if (key) val[key]["size"] = getSize(val, key);
  //     if (val?.[key]?.["size"]) val[key]["price"] = getPrice(val[key]["size"], sizeVar?.manual_size_tier_price?.length ? sizeVar.manual_size_tier_price : []);
  //     if (val?.[key]?.["price"] && val?.[key]?.["price"] !== sizeVal?.[key]?.["price"]) setSizeVal({ ...val }); else val = null;
  //   } else if ((sizeVar && sizeInit === "" && val === null) || (sizeInit !== "" && sizeVar && val === null)) {
  //     val = {};
  //     const k = sizeVar?.manual_size_from;
  //     if (k === "circle" && sizeVar?.manual_size_diameter_min) {
  //       val[k] = {}; key = k;
  //       val[k]["diameter"] = sizeVar?.manual_size_diameter_min;
  //     } else if (k === "square" && sizeVar?.manual_size_length_min) {
  //       val[k] = {}; key = k;
  //       val[k]["length"] = sizeVar?.manual_size_length_min;
  //     } else if (k === "standard" && sizeVar?.manual_size_length_min && sizeVar?.manual_size_width_min) {
  //       val[k] = {}; key = k;
  //       val[k]["length"] = sizeVar?.manual_size_length_min;
  //       val[k]["width"] = sizeVar?.manual_size_width_min;
  //     }
  //     if (key) val[key]["size"] = getSize(val, key);
  //     if (val?.[key]?.["size"]) val[key]["price"] = getPrice(val[key]["size"], sizeVar?.manual_size_tier_price?.length ? sizeVar.manual_size_tier_price : []);
  //     if (val?.[key]?.["price"] && val?.[key]?.["price"] !== sizeVal?.[key]?.["price"]) setSizeVal({ ...val });
  //   }
  //   if (selectedManualSizeData) {
  //     if (selectedManualSizeData?.standard) {
  //       const { length, width } = selectedManualSizeData?.standard;
  //        const unit = manualSizeUnitList[selectedManualSizeData.unit] || "mm";
  //       setmanualsizelabel(`Hoogte: ${length} ${unit},Breedte: ${width} ${unit}`);
  //       setmanualsizestr(`description: ${width}x${length}${unit},width: ${width}, price: ${"XXXXX"},length:${length}, display_value:Hoogte-${length} ${unit};Breedte-${width} ${unit}`);
  //     }
  //     if (selectedManualSizeData?.circle) {
  //       const { diameter, size } = selectedManualSizeData?.circle;

  //       const unit = manualSizeUnitList[selectedManualSizeData.unit] || "mm";

  //       setmanualsizelabel(`diameter: ${diameter} ${unit}`);
  //       setmanualsizestr(`description: ${diameter} ${unit}, diameter:${diameter}, size:${size}, price: ${"XXXXX"}, display_value:diameter-${diameter} ${unit}`);
  //     }
  //     if (selectedManualSizeData?.square) {
  //       const { length, size } = selectedManualSizeData?.square;
  //       const unit = manualSizeUnitList[selectedManualSizeData.unit] || "mm";

  //       setmanualsizelabel(`lengte: ${length} ${unit}`);
  //       setmanualsizestr(`description: ${length} ${unit},length:${length}, size:${size}, price: ${"XXXXX"},display_value:lengte-${length} ${unit}`);
  //     }
  //   }
  // }, [selectedManualSizeData, sizeVar]);


  useEffect(() => {
    let key = "", val = null;
    if (sizeVar && selectedManualSizeData && Object.keys(selectedManualSizeData).length) {
      val = {};
      Object.keys(selectedManualSizeData).forEach((k) => {
        if (k === "circle" && sizeVar.manual_size_diameter_min && sizeVar.manual_size_diameter_max) {
          val[k] = {};
          key = k;
          const l = selectedManualSizeData[k]?.diameter || 1;
          val[k].diameter = checkValue(l, sizeVar.manual_size_diameter_min, sizeVar.manual_size_diameter_max);
        } else if (k === "square" && sizeVar.manual_size_length_min && sizeVar.manual_size_length_max) {
          val[k] = {};
          key = k;
          const l = selectedManualSizeData[k]?.length || 1;
          val[k].length = checkValue(l, sizeVar.manual_size_length_min, sizeVar.manual_size_length_max);
        } else if (k === "standard" && sizeVar.manual_size_length_min && sizeVar.manual_size_length_max && sizeVar.manual_size_width_min && sizeVar.manual_size_width_max) {
          val[k] = {};
          key = k;
          const l = selectedManualSizeData[k]?.length || 1;
          const w = selectedManualSizeData[k]?.width || 1;
          val[k].length = checkValue(l, sizeVar.manual_size_length_min, sizeVar.manual_size_length_max);
          val[k].width = checkValue(w, sizeVar.manual_size_width_min, sizeVar.manual_size_width_max);
        }
      });

      if (key) val[key].size = getSize(val, key);
      if (val?.[key]?.size) {
        val[key].price = getPrice(val[key].size, sizeVar?.manual_size_tier_price?.length ? sizeVar.manual_size_tier_price : []);
      }

      if (val?.[key]?.price !== sizeVal?.[key]?.price || val?.[key]?.size !== sizeVal?.[key]?.size) {
        setSizeVal((prev) => ({ ...prev, ...val }));
      } else {
        val = null;
      }
    } else if ((sizeVar && sizeInit === "" && val === null) || (sizeInit !== "" && sizeVar && val === null)) {
      val = {};
      const k = sizeVar?.manual_size_from;

      if (k === "circle" && sizeVar.manual_size_diameter_min) {
        val[k] = {};
        key = k;
        val[k].diameter = sizeVar.manual_size_diameter_min;
      } else if (k === "square" && sizeVar.manual_size_length_min) {
        val[k] = {};
        key = k;
        val[k].length = sizeVar.manual_size_length_min;
      } else if (k === "standard" && sizeVar.manual_size_length_min && sizeVar.manual_size_width_min) {
        val[k] = {};
        key = k;
        val[k].length = sizeVar.manual_size_length_min;
        val[k].width = sizeVar.manual_size_width_min;
      }
      if (key) val[key].size = getSize(val, key);
      if (val?.[key]?.size) {
        val[key].price = getPrice(val[key].size, sizeVar?.manual_size_tier_price?.length ? sizeVar.manual_size_tier_price : []);
      }

      if (val?.[key]?.price !== sizeVal?.[key]?.price || val?.[key]?.size !== sizeVal?.[key]?.size) {
        setSizeVal((prev) => ({ ...prev, ...val }));
      }
    }
    if (selectedManualSizeData) {
      let label = "";
      let sizeStr = "";
      const unit = manualSizeUnitList[selectedManualSizeData.unit] || "mm";

      if (selectedManualSizeData?.standard) {
        const { length, width } = selectedManualSizeData.standard;
        label = `Hoogte: ${length} ${unit}, Breedte: ${width} ${unit}`;
        sizeStr = `description: ${width}x${length}${unit}, width: ${width}, price: XXXXX, length: ${length}, display_value: Hoogte-${length} ${unit}; Breedte-${width} ${unit}`;
      } else if (selectedManualSizeData?.circle) {
        const { diameter, size } = selectedManualSizeData.circle;
        label = `diameter: ${diameter} ${unit}`;
        sizeStr = `description: ${diameter} ${unit}, diameter: ${diameter}, size: ${size}, price: XXXXX, display_value: diameter-${diameter} ${unit}`;
      } else if (selectedManualSizeData?.square) {
        const { length, size } = selectedManualSizeData.square;
        label = `lengte: ${length} ${unit}`;
        sizeStr = `description: ${length} ${unit}, length: ${length}, size: ${size}, price: XXXXX, display_value: lengte-${length} ${unit}`;
      }

      setmanualsizelabel((prevLabel) => {
        if (prevLabel !== label) {
          localStorage.setItem("manualsizelabel", label);
          return label;
        }
        return prevLabel;
      });

      setmanualsizestr((prevStr) => {
        if (prevStr !== sizeStr) {
          localStorage.setItem("manualsizestr", sizeStr);
          return sizeStr;
        }
        return prevStr;
      });
    }

    const storedSizeFrom = localStorage.getItem("manual_size_from");
    if (sizeVar?.manual_size_from && storedSizeFrom !== sizeVar.manual_size_from) {
      localStorage.setItem("manual_size_from", sizeVar.manual_size_from);
      setSizeVal({});
    }

  }, [sizeVal, selectedManualSizeData, sizeVar, sizeVar?.manual_size_from]);


  const onChangeSelected = (key) => {
    setSelectedManualSizeData({ ...sizeVal, unit, key: variantKey, id: sizeVar?.id });
    if (variantKey && sizeVal?.[key] && Object.keys(sizeVal[key]).length) {
      const d = {}
      d["key"] = key;
      Object.keys(sizeVal[key]).map((k) => {
        if (!(k === "size" || k === "price")) d[k] = sizeVal[key][k]
      })
      const selectedData = { ...selected };
      selectedData[variantKey] = [JSON.stringify({ manualSize: { ...d } }), data?.id];
      setStopNextNav(true);
      setSelected({ ...selectedData });
    }
  }
 
useEffect(() => {
  if (sizeVal && Object.keys(sizeVal).length) {
    const alreadySelected = selectedManualSizeData?.key; 
    const firstKey = Object.keys(sizeVal)[0];

    if (!alreadySelected) {
      if (firstKey) onChangeSelected(firstKey);
    } else if (isSample === true && !sampleHandledRef.current) {
      sampleHandledRef.current = true;
      if (firstKey) onChangeSelected(firstKey);
    }
  }
  if (isSample === false) {
    sampleHandledRef.current = false;
  }
}, [sizeVal, isSample]);


  useEffect(() => {
    setPrevKey(selectedDetails?.[keyList?.[0]]?.prevKey ? selectedDetails[keyList[0]].prevKey : "");
  }, [selectedDetails]);
  
  useEffect(() => {
    const products = data?.products;
    if (data?.label === 'manual-size' && products?.length) {
      if (prevKey !== "") {
        const selList = selectedDetails?.[prevKey]?.selectedOptionProductList;
        if (selList?.length) {
          products.map((prod) => {
            if (selList?.includes(prod?.id)) {
              if (prod?.id && prod?.id !== selectedManualSizeData?.id) {
                setSelectedManualSizeData(null);
                setTimeout(() => {
                  setSizeVar(prod);
                }, 500)
              }
            }
          });
        }
      }
    }

    if (data?.label === 'manual-size' && !data?.selectedProducts && data?.products?.length) {
      setSizeVar(data.products[0])
    } else if (data?.label === 'manual-size' && data?.selectedProducts) {
      setSizeVar(data.selectedProducts)
    } else if (sizeVar !== null) {
      setSizeVar(null)
    }
  }, [prevKey, selectedDetails, selectedDetails?.size?.products]);

  useEffect(() => {
    if (sizeInit === "" && sizeVal) {
      setSizeInit("loaded");
    }
  }, [sizeVal]);

  const NewVariantData = data?.selectedProducts?.id ? [data.selectedProducts] : data?.products;
  const placeholderImage = useSelector(state => state?.getHeaderFooterData?.data?.footer?.[0]?.place_holder_image) || localStorage.getItem("placeholderImage");
  const imageSrc = NewVariantData?.[0]?.images
  const isValidImageUrl = (image_url) => {
    if (!image_url) return false; // URL is invalid if it's not provided

    let image_url_split;
    try {
      image_url_split = new URL(image_url); // Validate if the URL is well-formed
    } catch (e) {
      return false; // Return false if the URL is not valid
    }

    if (image_url_split?.pathname) {
      const validExtensions = ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'jp2', 'webp'];
      const urlExtension = image_url_split.pathname.split('.').pop().toLowerCase();
      return validExtensions.includes(urlExtension); // Check if the file extension is valid
    }

    return false; // URL is invalid if pathname doesn't exist
  };

  // Function to check if the image URL is accessible
  const isImageAccessible = (image_url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true); // Image loaded successfully
      img.onerror = () => resolve(false); // Error while loading image
      img.src = image_url;
    });
  };

  // Combined validation
  const validateImageUrl = async (image_url) => {
    if (!isValidImageUrl(image_url)) return false;
    const isAccessible = await isImageAccessible(image_url);
    return isAccessible;
  };

  useEffect(() => {
    const checkImage = async () => {
      const valid = await validateImageUrl(imageSrc);
      setIsValid(valid);
    };
    checkImage();
  }, [imageSrc]);

  return sizeVar?.manual_size_from ? (
    <React.Fragment>
      {sizeVar?.manual_size_from === "circle" ? (
        <ContentManualSize
          key={`circle_${sizeVar?.id}`} // Keep key stable
          name={`Diameter (${manualSizeUnitList[unit] || "mm"})`}
          min={sizeVar?.manual_size_diameter_min}
          max={sizeVar?.manual_size_diameter_max}
          val={sizeVal?.circle?.diameter}
          setVal={(v) => updateSizeVal("circle", v, "diameter")}
        />
      ) : sizeVar?.manual_size_from === "standard" ? (
        <ContentManualSize
          key={`standard_${sizeVar?.id}`}
          name={`Hoogte (${manualSizeUnitList[unit] || "mm"})`}
          min={sizeVar?.manual_size_length_min}
          max={sizeVar?.manual_size_length_max}
          val={sizeVal?.standard?.length}
          setVal={(v) => updateSizeVal("standard", v, "length")}
          name1={`Breedte (${manualSizeUnitList[unit] || "mm"})`}
          min1={sizeVar?.manual_size_width_min}
          max1={sizeVar?.manual_size_width_max}
          val1={sizeVal?.standard?.width}
          setVal1={(v) => updateSizeVal("standard", v, "width")}
        />
      ) : sizeVar?.manual_size_from === "square" ? (
        <ContentManualSize
          key={`square_${sizeVar?.id}`}
          name={`Lengte (${manualSizeUnitList[unit] || "mm"})`}
          min={sizeVar?.manual_size_length_min}
          max={sizeVar?.manual_size_length_max}
          val={sizeVal?.square?.length}
          setVal={(v) => updateSizeVal("square", v, "length")}
        />
      ) : null}
      <p></p>

    </React.Fragment>
  ) : (
    <div name={`variantCard_includes_${data.id}`} className="variantCard flex">
      <button
        aria-label="button"
        className={`content fillX flex col gap-2 ${variantKey && data?.id && selected?.[variantKey]?.length && selected?.[variantKey]?.includes(data.id) ? "active" : ""}`}
        onClick={() => {
          const ManualSize = Array.isArray(selected.size) && selected.size.some(val => typeof val === "string" && val.includes('"manualSize"'))
          if (variantKey) {
            const selectedData = { ...selected };
            const isAvailableVariant = variantData?.variantLength - 1 === variantData?.variantPosition;
            // if (!isSample && variantData?.variantLength -1 ==  variantData?.variantPosition && qty > 0) {
            if (!isSample && qty > 0) {
              setchangeCustomizeOption({
                customoption: "",
                qty: false,
                variant: data?.id
              })
            }
            if (isSample) {
              setchangeCustomizeOption({
                customoption: "",
                qty: false,
                variant: data?.id
              })
            }

            if (
              variantData?.variantDatas?.length &&
              variantData.variantDatas.every((variant) => selected[variant]?.length > 0)
            ) {
              const lastVariant = variantData.variantDatas[variantData.variantDatas.length - 1];
              if (selectedData[lastVariant]) {
                selectedData[lastVariant] = [];
              }
            }

            let selectedCard = [...selected[variantKey]];
            if (selectedCard.length === 0) {
                  setsamplenextNav(false);
                }
            if (data?.id && selectedCard.includes(data.id) && !isSample) {
              selectedCard.splice(selectedCard.indexOf(data.id), 1);
            } else if (data?.id) {
              if (!mutiSelect && !isSample) {
                selectedCard = []; // Single 
                expandNext(true);
              } else if (!isSample) {
                setStopNextNav(true);
              }
              if ( isSample && mutiSelect === true && isAvailableVariant) {
                      setStopNextNav(true);
                      expandNext(false);
                } else if (isSample && mutiSelect === true && !isAvailableVariant) {
                      expandNext(true);
                }
              // const manualSize = variantData?.isManualSize
              if (isSample  &&  !Array.isArray(selectedData.vorm)) {
                const totalVariantLength = variantData?.variantLength;
                const currentVariantIndex = selectedDetails?.[keyList?.[0]]?.variantIndex;
                const isAvailableVariant = variantData?.variantLength - 1 === variantData?.variantPosition;

                if(!isAvailableVariant && selectedCard?.length){
                  selectedCard = [];
                }
                if (selectedCard.includes(data.id)) {
                  selectedCard = selectedCard.filter(id => id !== data.id);
                  setStopNextNav(true);
                } else if (
                  totalVariantLength &&
                  currentVariantIndex > -1 &&
                  (
                    (currentVariantIndex < totalVariantLength - 1 && selectedCard.length < 1) ||
                    (currentVariantIndex === totalVariantLength - 1 && selectedCard.length < (["color", "size"].every(type => variantData?.variantDatas?.includes(type)) ? 5 : 3))
                  )
                ) {
                  selectedCard.push(data.id);
                  isAvailableVariant && expandNext(false);
                }
              } else if ( isSample && Array.isArray(selectedData.vorm) && ManualSize === true){
                selectedCard = [data.id];
                expandNext(false)
              }
               else if (isSample && Array.isArray(selectedData.vorm) && ManualSize === false) {
                 if (selectedCard.includes(data.id)) {
                  selectedCard = selectedCard.filter(id => id !== data.id);
                } else {
                  selectedCard.push(data.id);
                }     
                expandNext(false)           
              } 
              else {
                selectedCard.push(data.id);
              }              
            }
            selectedData[variantKey] = selectedCard;
            Object.keys(selectedData).forEach((key) => {
              const shouldKeep =
                key === "qty" || key === "upload" || key === "isSample" || variantData?.variantDatas?.includes(key);

              if (!shouldKeep) {
                selectedData[key] = [];
              }
            });
            setSelected(selectedData);
          }
        }}

      // disabled={!(data?.products?.[0]?.stock_status)} // Disable varient
      >
        {NewVariantData?.length ? NewVariantData.map((product, i) => i === 0 ? (
          <React.Fragment key={`product__${data.id}_${variantKey}_${keyList?.join(", ")}__${i}_0`}>

            {(variantIndex > -1 && (product?.product_gallery_images?.[variantIndex]?.image || product?.images)) ? (
              <div className={`w-1/1 flex col pt-2 px-2 ${!isValid ? 'imagehidden' : ''}`}>
                <div className="relative w-1/1 r-3 overflow-hidden">
                  <div className="imgInfo absolute w-1/1 h-1/1">
                    <Img src={handleImage((variantIndex > -1 && product?.product_gallery_images?.[variantIndex]?.image) ? product.product_gallery_images[variantIndex].image : product?.images ? product?.images : "", placeholderImage)} alt={''} type='img' style={{ objectFit: "contain", maxWidth: "100%" }} onError={(e) => {
                      e.target.src = placeholderImage
                    }} />
                  </div>
                  <div style={{ paddingTop: "100%" }}></div>
                </div>
              </div>
            ) : null}
            {!(variantIndex > -1 && (product?.product_gallery_images?.[0]?.image || product?.images)) ? (
              <div className=' w-1/1 flex col pt-2 px-2'>
                <div className="relative w-1/1 r-3 overflow-hidden">
                  <div className="txtInfo absolute w-1/1 h-1/1 flex center middle">
                    {/* <h5 className='tc' title={data.label ? data.label : "No name"}>{data.label ? addHyphens(data.label) : addHyphens("No name")}</h5> */}
                    <h5 className='tc' title={ data.label
                      ? translate?.[`${data.label}`.toLowerCase()] || data.label
                      : "No name"}>
                  {addHyphens(
                    data.label
                      ? translate?.[`${data.label}`.toLowerCase()] || data.label
                      : "No name"
                  )}
                </h5>

                  </div>
                  <div style={{ paddingTop: "100%" }}></div>
                  {product?.manage_stock > 0 && product?.stock_status ? (
                   <div className='w-1/1 py-2 flex col gap-1 middle'>
                     {product?.qty > 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                       <div className='qty'>{product?.qty} <span className='no-translate notranslate'>{product?.qty == 1 ? t("stuk") : t("stuks")}</span></div>
                     ) : product?.qty == 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                       <div className='qty no-translate notranslate' style={{ color: "#CE3030" }}>{t("nietopvoorraad")}</div>
                     ) : (
                       <div className='qty v-hide no-translate notranslate'  style={{ display:"none"}}>{t("stuks")}</div>
                     )}
                     {product?.next_day_delivery_qty !== null && product?.next_day_delivery_qty > 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                       <TooltipEle product={product} />
                     ) : (
                       <div className='time flex gap-1 middle center v-hide no-translate notranslate'  style={{ display:"none"}}>{t("Tooltip")}</div>
                     )}
                   </div>
                 ) : product?.manage_stock > 0 && !product?.stock_status && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                   <div className='w-1/1 mt-6 py-2 flex col gap-0 middle' style={{ color: "#CE3030" }}>
                     <div className='no-translate notranslate'>{t("nietop")}</div>
                     <div className='no-translate notranslate'>{t("voorraad")}</div>
                   </div>
                 ) : null}
                </div>
              </div>) : (
             <div className={`varientInfo relative w-1/1 flex col middle px-2 zindex-4 ${!isValid ? 'imagehiddenalign ' : ''}`}>
             {variantData?.hideStock ? (
               <h3 title={data?.label} className='labelOnly tc fw-bold pb-2'>{addHyphens(data?.label)}</h3>
             ) : (
               <React.Fragment>
                 {data?.label ? (
                   <h3 title={data?.label} className={`label ${product?.manage_stock > 0 ? "absolute" : "pb-2"} px-2 w-1/1 h-1/1 flex-1`}>
                     {translate?.[`${data?.label}`.toLowerCase()]
                       ? addHyphens(translate[`${data?.label}`.toLowerCase()])
                       : addHyphens(data?.label)}
                       
                   </h3>
                 ) : (
                   <h3 className={`label ${product?.manage_stock > 0 ? "absolute" : "pb-2"} px-2 w-1/1 h-1/1 flex-1 v-hide`}>
                     {addHyphens("Title")}
                   </h3>
                 )}
                 {product?.manage_stock > 0 && product?.stock_status ? (
                   <div className='w-1/1 mt-7 py-2 flex col gap-1 middle'>
                     {product?.qty > 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                     <div className='qty no-translate notranslate'>{product?.qty} {product?.qty == 1 ? <span className='no-translate notranslate'>{t("stuk")}</span> : <span className='no-translate notranslate'>{t("stuks")}</span>}</div>
                    ) : product?.qty == 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                       <div className='qty no-translate notranslate' style={{ color: "#CE3030" }}>{t("nietopvoorraad")}</div>
                     ) : (
                       <div className='qty v-hide no-translate notranslate' style={{display: "none"}}>{t("stuks")}</div>
                     )}
                     {product?.next_day_delivery_qty !== null && product?.next_day_delivery_qty > 0 && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                       <TooltipEle product={product} />
                     ) : (
                       <div className='time flex gap-1 middle center v-hide no-translate notranslate' style={{display: "none"}}>{t("Tooltip")}</div>
                     )}
                   </div>
                 ) : product?.manage_stock > 0 && !product?.stock_status && variantData?.variantLength == selectedDetails[keyList[0]]?.variantIndex + 1 ? (
                   <div className='w-1/1 mt-6 py-2 flex col gap-0 middle' style={{ color: "#CE3030" }}>
                     <div className='no-translate notranslate'>{t("nietop")}</div>
                     <div className='no-translate notranslate'>{t("voorraad")}</div>
                   </div>
                 ) : null}
               </React.Fragment>
             )}
           </div>
           
            )}
          </React.Fragment>
        ) : null) : null}
      </button>
    </div>
  )
}
const VariantQtyPicker = ({setInitialTierPricePopup,setErrorCart, productData, totalValueQty, setTotalValueQty, errorQty, setErrorQty, setOpenModelQty, setVariantQtyData, setReqExpanded, selectedData, keyList, variantData, setSelected, selectedDetails, setStopNextNav,translate }) => {
  const [tokenData, setTokenData] = useState("");
  const [data, setData] = useState([]);
  const [qtydata, setQtyData] = useState([]);
  const isValidedkey = selectedData[keyList[0]];
  const hasColon = isValidedkey?.length > 0 && isValidedkey[0]?.includes(":");
      useEffect(() => {
        if (!hasColon) {
          const resetQtyData = qtydata.map((item) => ({
            ...item,
            qty: 0,
          }));
          setQtyData(resetQtyData);
        }
      }, [hasColon]);

  const replaceSizeSymbols = (data) => {
    const updatedData = { ...data };
    if (updatedData.size && updatedData.size.length > 0) {
      updatedData.size = updatedData.size.map(size => {
        return decodeURIComponent(size).replace(/%3A/g, ':').replace(/%2C/g, ',');
      });
    }
    return updatedData;
  };
  useEffect(() => {
    const currentSelectedDetails = selectedDetails[keyList[0]];
    const updateDataList = [], tempQtyData = [];

    if (variantData?.multiOption && currentSelectedDetails?.prevKey !== "") {
      if (selectedDetails[currentSelectedDetails.prevKey]?.selectedOptionProductList?.length) {
        const selectedOptionProductList = [...selectedDetails[currentSelectedDetails.prevKey]?.selectedOptionProductList];
        if (variantData?.options?.length) {
          variantData.options.map((vData) => {
            let selectedProducts = null, selectedQty;
            if (vData.products.length) {
              vData.products.map((vDataProd) => {
                if (!selectedProducts && selectedOptionProductList.includes(vDataProd.id)) {
                  selectedProducts = vDataProd;
                  selectedQty = { id: vData?.id, sizeLabel: vData?.label, productId: vDataProd?.id,
                     allProMinQty: vDataProd?.min_sale_qty, minQty: 0, qty: 0
                      ,enable_qty_increments : vDataProd?.enable_qty_increments, qty_increments:vDataProd?.qty_increments}
                  selectedData[variantData.variantDatas.slice(-1)[0]].forEach(item => selectedQty.qty = item.includes(selectedQty.id) && item.split(":")?.[1] ? parseInt(item.split(":")[1]) : 0);
                }
                return null;
              });
              vData["selectedProducts"] = selectedProducts;
            }
            if (selectedProducts) {
              updateDataList.push(vData);
              tempQtyData.push(selectedQty);
            }
            selectedData[variantData.variantDatas.slice(-1)[0]]?.forEach(item => {
              const [id, qty] = item.split(":");
              const index = tempQtyData.findIndex(tempItem => tempItem.id === id);
              if (index !== -1) {
                tempQtyData[index].qty = parseInt(qty) || 0;
              }
            });

            return null;
          })
        }
      }
      setData([...updateDataList]);
      const hasNewItem = updateDataList.some(
        newItem => !qtydata?.some(existingItem => existingItem?.id === newItem?.id)
      );
      if (hasNewItem) {
        setQtyData([...tempQtyData])
      }
    }else  if (productData?.isTextileProduct === 1 && currentSelectedDetails?.prevKey === "") {
        if (variantData?.options?.length) {
          variantData.options.map((vData) => {
            let selectedProducts = null, selectedQty;
            if (vData.products.length) {
              vData.products.map((vDataProd) => {
                if (!selectedProducts) {
                  selectedProducts = vDataProd;
                  selectedQty = { id: vData?.id, sizeLabel: vData?.label, productId: vDataProd?.id, allProMinQty: vDataProd?.min_sale_qty, minQty: 0, qty: 0
                    ,enable_qty_increments : vDataProd?.enable_qty_increments, qty_increments:vDataProd?.qty_increments }
                  selectedData[variantData.variantDatas[0]]?.forEach(item => selectedQty.qty = item.includes(selectedQty.id) && item.split(":")?.[1] ? parseInt(item.split(":")[1]) : 0);
                }
                return null;
              });
              vData["selectedProducts"] = selectedProducts;
            }
            if (selectedProducts) {
              updateDataList.push(vData);
              tempQtyData.push(selectedQty);
            }
            selectedData[variantData.variantDatas[0]]?.forEach(item => {
              const [id, qty] = item.split(":");
              const index = tempQtyData.findIndex(tempItem => tempItem.id === id);
              if (index !== -1) {
                tempQtyData[index].qty = parseInt(qty) || 0;
              }
            });

            return null;
          })
        }
      setData([...updateDataList]);
      const hasNewItem = updateDataList.some(
        newItem => !qtydata?.some(existingItem => existingItem?.id === newItem?.id)
      );
      if (hasNewItem) {
        setQtyData([...tempQtyData]);
      }
    }
  }, [selectedDetails]);

  useEffect(() => {
    setVariantQtyData(qtydata)
    const temp = {};
    if (qtydata?.length) {
      temp[keyList[0]] = qtydata.filter(item => item.qty > 0).map(item => {
        return `${item.id}:${item.qty}`
      });
      // setReqExpanded(false);
      setStopNextNav(true)
      setSelected({ ...selectedData, ...temp })
    }
    const sumQty = Object.values(qtydata).reduce((acc, item) => acc + item.qty, 0);
    setTotalValueQty(sumQty)
    if (qtydata?.length && qtydata.some(item => item.qty > 0)) {
      if (sumQty >= productData?.settings?.min_sale_qty) {
        setErrorQty(true)
      }
      else if (sumQty <= productData?.settings?.min_sale_qty) {
        setErrorQty(false)
      }
    }
    setErrorCart("")
  }, [qtydata]);
  useEffect(() => {
    const updatedSelectedData = replaceSizeSymbols(selectedData);
    setSelected(updatedSelectedData);
  }, [])

  useEffect(() => {
    if (tokenData === "") setTokenData("loaded")
  }, []);

  useEffect(()=>{
    if(variantData?.options?.[0]?.products?.length){
      let initialTierPrice =variantData?.options?.[0]?.products?.find((item)=>item?.tier_prices?.length) 
      setInitialTierPricePopup(initialTierPrice)
    }
  },[])
  
  return (
    <React.Fragment>
      <div className='flex right absolute right-0' style={{ top: "-38px" }}>
        <a aria-label="Prijstabel" className='fs-15 text-underline no-translate notranslate' onClick={() => setOpenModelQty(true)}>{t("Prijstabel")}</a>
      </div>

      {qtydata && qtydata?.length ?
        <p className='fs-15 py-2 px-2'>
          Meerdere keuzes mogelijk, met een totaal van minimaal {Math.round(productData?.settings?.min_sale_qty)} stuks. </p>
        : ""}
         
      <div className="variantcolorPicker flex center col gap-6 w-1/1">
        <div className='flex col gap-2'>
          <div className="flex gap-6 w-1/1">
            <div className="flex w-1/1 py-1 px-2 Configure_qty_overall" style={{  maxWidth: "min-content", minWidth: "400px",}}>
              <div className='qtyChoose flex col gap-4'>
                <h4>{data?.[0]?.name && translate[`${data?.[0]?.name}`.toLowerCase()]}</h4>
              </div>
            </div>
            <div className="flex flex-1 col gap-4 py-1 px-2">
              <div className='qtyChoose flex col gap-4'>
                <h4 className='no-translate notranslate'>{t("Quantity")}</h4>
              </div>
            </div>
          </div>
          {data.map((d, index) => {
            const imageToUse = d?.selectedProducts?.product_gallery_images?.[1]?.image 
            || d?.selectedProducts?.product_gallery_images?.[0]?.image;
            return(
            <div className="flex gap-3 w-1/1 middle">
              <div className="flex w-1/1 py-1 px-2 middle Configure_qty_section" style={{ maxWidth: "min-content", minWidth: "400px" , maxWidth: "400px"}}>
              {imageToUse? 
                 <div className='product__img flex relative center' style={{marginRight:"24px"}}>
                   <Img src={handleImage(imageToUse)} alt="" width='80' height='80'/>
                 </div>
              :""}
                <h3 className='labelOnly tl fw-bold' style={{ maxWidth: "350", wordBreak: "break-word" }}>{d?.label}</h3>
              </div>
              <div className="flex flex-1 col gap-4">
                <div className="flex col gap-3 lg-flex lg-row lg-gap-6 w-1/1">
                  <div className='qtyChoose flex col gap-4'>
                    <div className="w-1/1 flex gap-2 middle">
                      <div className="flex-1">
                        <InputQtyBoxArr
                         data={qtydata[index]}
                         setAllData={setQtyData}
                         allData={qtydata}
                         index={index}/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )})}
        </div>
      </div>
      <div >
        <h2 className='fs-18 fw-bold pt-4 pb-2'><span className='no-translate notranslate'>{t("Totalquantity")} </span> <span className='no-translate notranslate'>{totalValueQty}</span></h2>
      </div>
      {!errorQty ?
        <p className='error py-2'>De minimale bestelhoeveelheid is nog niet bereikt.</p>
        :
        ""
      }
      <div className='variantCardList w-1/1'>
        <div className='variantCardList'>
          <Button onClick={() => {
            setStopNextNav(false)
            setReqExpanded(true);
            setSelected({ ...selectedData })
            if (qtydata?.length && totalValueQty >= productData?.settings?.min_sale_qty) {
              setErrorQty(true)
              setStopNextNav(false)
              setReqExpanded(true);

            }
            else if (totalValueQty <= productData?.settings?.min_sale_qty) {
              setErrorQty(false)
              setReqExpanded(false);
              setStopNextNav(true)
            }
          }} className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'>{t("volgende")}</Button>
        </div>
      </div>
    </React.Fragment>

  );
}
const VariantColorPicker = ({ cmsError, setCmsError, keyList, setStopNextNav, product, selected, setSelected, selectedColorData, setSelectedColorData, selectedColorItem, setSelectedColorItem, openColorModel, setOpenColorModel, colorDataList, isColorPickerTierPrices }) => {
  const [tokenData, setTokenData] = useState("");
  const [colorData, setColorData] = useState({});
  const [colorList, setColorList] = useState({});
    const addMoreColor = (proData, product) => {
    const obj = { ...colorList };
    if (proData?.id) {
      let qty = 1, tier_prices = [], pms_key = "", product_ids = "";
      const productsObj = proData.products;
      if (productsObj) {
        Object.keys(productsObj).map((productKey) => {
          product_ids = productsObj[productKey]?.id;
          pms_key = productsObj[productKey]?.pms_key;
          tier_prices = productsObj[productKey]?.["tier_prices"] || [];
          qty = tier_prices?.[0]?.["qty"] || 1;
          return null;
        })
      }
      obj[proData.id].push({ color: "", qty: qty, minQty: qty, tier_prices, pms_key, product_ids });
      setColorList(obj);
    }
  }
  const removeMoreColor = (id, index) => {
    const obj = { ...colorList };
    if (obj[id].length) {
      obj[id].splice(index, 1)
      setColorList(obj);
    }
  }
  useEffect(() => {
    if (selectedColorItem) {
      if (selectedColorItem?.isFromPannel) {
        const obj = { ...colorList };
        if (!(obj[selectedColorItem.key])) {
          obj[selectedColorItem.key] = []
        }
        obj[selectedColorItem.key][selectedColorItem.index] = { ...obj[selectedColorItem.key][selectedColorItem.index], color: selectedColorItem.id || 0 };
        setColorList(obj);
        setOpenColorModel(false)
      } else {
        setOpenColorModel(true)
      }
    }
  }, [selectedColorItem]);
  useEffect(() => {
    if (colorList && Object.keys(colorList)?.length > 0) {
      const cData = {}, cDataAll = {};
      Object.keys(colorList).map((key, i) => {
        cData[key] = [];
        cDataAll[key] = [];
        colorList[key]?.length && colorList[key].map((colorItem, i) => {
          cData[key].push({ color: colorItem.color, qty: colorItem.qty });
          if (colorItem.color || colorItem.color === 0) {
            const item = colorDataList[colorItem.color];
            cDataAll[key].push({ tier_prices: [...colorItem?.tier_prices], product_ids: colorItem.product_ids, minQty: colorItem.minQty, pms_key: colorItem.pms_key, qty: colorItem.qty, pms_id: item?.pms_id, hex: item?.hex, name: item?.search && JSON.parse(item.search)?.[0] ? JSON.parse(item.search)?.[0] : "" })
          } else {
            cDataAll[key].push(undefined);
          }
          return null;
        });
        return null;
      });
      setColorData(cData)
      setSelectedColorData(cDataAll)
      // commented for purpose
      // if (colorList) {
      //   const allColorsNotEmpty = Object.values(colorList).every(dataArray => {
      //     return dataArray.every(dataObj => dataObj.color !== "");
      //   });
      //   setCmsError(allColorsNotEmpty);
      // }
    }
  }, [colorList]);

  useEffect(() => {
    if (tokenData !== "")
      if (colorData && Object.keys(colorData)?.length > 0) {
        setStopNextNav(true);
        const selectedColorTemp = { ...selected }
        selectedColorTemp[keyList] = [colorData];
        setSelected(selectedColorTemp)
      }
    if (colorList) {
      const allColorsNotEmpty = Object.values(colorList).every(dataArray => {
        return dataArray.every(dataObj => dataObj.color !== "");
      });
       if (allColorsNotEmpty && cmsError === "false") {
      setCmsError("true");
    }
    }

  }, [colorData]);
  useEffect(() => {
    if (product.selected.length) {
      const obj = {}, selectedData = selected[keyList]?.length && (typeof selected[keyList][0] === "string") ? JSON.parse(selected[keyList]) : selected[keyList]?.length ? selected[keyList] : [];
      const colorListData = selectedData?.length ? selectedData[0] : {};
      Object.keys(product.data).map((key) => {
        if (product.selected.includes(product.data[key].id)) {
          let qty = 1, tier_prices = [], pms_key = "", product_ids = "";
          const productsObj = product.data[key].products;
          if (productsObj) {
            Object.keys(productsObj).map((productKey) => {
              product_ids = productsObj[productKey]?.id;
              pms_key = productsObj[productKey]?.pms_key;
              tier_prices = productsObj[productKey]?.["tier_prices"] || []
              qty = tier_prices?.[0]?.["qty"] || 1;
              return null;
            })
          }
          if (colorListData?.[product.data[key].id] && colorListData[product.data[key].id].length) {
            const tempOb = []
            colorListData[product.data[key].id].map((clc, item) => {
              tempOb.push({ color: clc.color ? clc.color : clc.color === 0 ? 0 : "", qty: clc.qty > qty ? clc.qty : qty, minQty: qty, tier_prices, pms_key, product_ids })
              return null;
            });
            obj[product.data[key].id] = tempOb;
          } else {
            obj[product.data[key].id] = [{ color: "", qty: qty, minQty: qty, tier_prices }]
          }
        }
        return null;
      });
      setColorList(obj)
    }
  }, [product.selected]);
  useEffect(() => {
    if (tokenData === "") setTokenData("loaded")
  }, []);

  const placeholderImage = useSelector(state => state?.getHeaderFooterData?.data?.footer?.[0]?.place_holder_image) || localStorage.getItem("placeholderImage");

  return (
    <div className="variantcolorPicker flex center col gap-6 w-1/1">
      <div className='flex col gap-6'>
        {Object.keys(product.data).map((key, index) => product.selected.includes(product.data[key].id) ? (
          <div className="flex gap-6 w-1/1" data-key={`variantcolorPicker_${keyList}`} key={`variantcolorPicker_${keyList}_${index}_${key}_${product.data[key].id}`}>
            <div className="variantCard flex">
              <button aria-label="button" className={`content flex col gap-2 ${product.data[key]?.products[Object.keys(product.data[key].products)[0]]?.product_gallery_images?.[0]?.image || product.data[key].products[Object.keys(product.data[key].products)[0]]?.images ? 'has-image' : 'no-image'}`}>
                {product.data[key]?.products && Object.keys(product.data[key].products).length ? Object.keys(product.data[key].products).map((key2, item2) => item2 === 0 ? (
                  <React.Fragment>
                    {product.data[key].products[key2]?.product_gallery_images?.[0]?.["image"] || product.data[key].products[key2]?.images ?
                      <div className='flex-1 w-1/1 flex col pt-4 px-4'>
                        <div className="relative w-1/1 r-3 overflow-hidden">
                          <div className="imgInfo absolute w-1/1 h-1/1">
                            <Img title={product.data[key].products[key2]?.product_name} src={handleImage(product.data[key].products[key2]?.product_gallery_images?.[0]?.["image"] || product.data[key].products[key2]?.images, placeholderImage)} alt={''} type='img' style={{ objectFit: "contain", maxWidth: "100%" }} onError={(e) => {
                              e.target.src = placeholderImage
                            }} />
                          </div>
                          <div style={{ paddingTop: "100%" }}></div>
                        </div>
                      </div>
                      : null
                    }

                    <div className='varientInfo w-1/1 flex col gap-2 middle pb-2 px-2 zindex-4'>
                      <h3 className='labelOnly tc fw-bold' title={addHyphens(product.data[key]?.label)}>{addHyphens(product.data[key]?.label)}</h3>
                    </div>
                  </React.Fragment>
                ) : null) : null}
              </button>
            </div>
            <div className="flex flex-1 col gap-4">
              <div className="hide lg-flex lg-gap-6 w-1/1">
                <div className='colorChoose flex col gap-4'>
                  <h4 className='no-translate notranslate'>{t("Color")}</h4>
                </div>
                {!isColorPickerTierPrices ?
                  <div className='qtyChoose flex col gap-4'>
                    <h4 className='no-translate notranslate'>{t("Quantity")}</h4>
                  </div> : null}
              </div>
              {colorList[product.data[key].id]?.length ? colorList[product.data[key].id].map((cData, ind) => (
                <div className="flex col gap-3 lg-flex lg-row lg-gap-6 w-1/1" key={`colorListProduct_${ind}_${key}_${product.data[key].id}`}>
                  <div className='colorChoose flex col gap-4'>
                    <div className="w-1/1 flex gap-2 middle" key={`cData${ind}_${index}`}>
                      <button aria-label="button" onClick={() => { setSelectedColorItem({ id: cData?.id, key: product.data[key].id, index: ind, isFromPannel: false }) }} className="flex-1 flex middle gap-2 colorInput">
                        {selectedColorData?.[product.data[key].id]?.[ind]?.hex ? <div className='colorBox' style={{ background: selectedColorData?.[product.data[key].id]?.[ind]?.hex }}></div> : <div className='colorBox noColor'></div>}
                        {selectedColorData?.[product.data[key].id]?.[ind]?.name ? <div className='colorName relative w-1/1 overflow-hidden' style={{ height: 20 }}><span className="absolute w-1/1 text-nowrap ellipsis overflow-hidden">{selectedColorData?.[product.data[key].id]?.[ind]?.name}</span></div> : <div className='colorName relative w-1/1 overflow-hidden no-translate notranslate'>{t("Kieseenkleur")}</div>}
                      </button>
                      <div className="flex-0">
                        <IconButton aria-label="edit" onClick={() => { setSelectedColorItem({ id: cData?.id, key: product.data[key].id, index: ind, isFromPannel: false }) }}>
                          <EditIcon role="presentation" />
                        </IconButton>
                      </div>
                    </div>
                  </div>
                  <div className='qtyChoose flex col gap-4'>
                    <div className="w-1/1 flex gap-2 middle" key={`colorInput${ind}_${index}`}>
                      {!isColorPickerTierPrices ?
                        <div className="flex-1">
                          <InputQtyBox data={cData} keyName={product.data[key].id} setAllData={setColorList} allData={colorList} index={ind} />
                        </div> : null}
                      <div className="flex-0">
                        {ind == 0 ? <div style={{ width: 24, height: 24 }} /> : (
                          <IconButton aria-label="delete" onClick={() => removeMoreColor(product.data[key].id, ind)}>
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )) : null}
              {!isColorPickerTierPrices ?
                <div className="flex gap-6 w-1/1 addColor">
                  <a aria-label="Voeg een kleur toe" onClick={() => addMoreColor(product.data[key], product)} className="flex left"><span className='no-translate notranslate'>{t("Voegeenkleurtoe")}</span></a>
                </div> : null}
            </div>
          </div>
        ) : null)}
      </div>
    </div>
  );
}
const VariantCardSeeMore = ({setchangeCustomizeOption, qty, getApiCartOptions, getDeliveryDate, translate, manualsizelabel, setmanualsizelabel, setmanualsizestr, selectedManualSizeData, setSelectedManualSizeData, keyList, setStopNextNav, selectedDetails, variantData, selected, setSelected, handleExpandNext, expandNext, isSample , lastVariantKey , setsamplenextNav}) => {
  const [width] = useWindowSize();
  const [expanded, setExpanded] = useState(false);
  const [data, setData] = useState([]);
  const name = variantData?.label;

  useEffect(() => {
    const currentSelectedDetails = selectedDetails[keyList[0]];
    const updateDataList = [];
    if (variantData?.multiOption && currentSelectedDetails?.prevKey !== "") {
      if (selectedDetails[currentSelectedDetails.prevKey]?.selectedOptionProductList?.length) {
        const selectedOptionProductList = [...selectedDetails[currentSelectedDetails.prevKey]?.selectedOptionProductList];
        if (variantData?.options?.length) {
          variantData.options.map((vData) => {
            let selectedProducts = null;
            // commented for purpose add to cart issue
            // const updatedProductList =[];

            if (vData.products.length) {
              vData.products.map((vDataProd) => {

                if (selectedOptionProductList.includes(vDataProd.id)) {
                  // updatedProductList.push(vDataProd)
                  if (!selectedProducts) {
                    selectedProducts = vDataProd;
                  }
                }

                return null;
              });
              vData["selectedProducts"] = selectedProducts;
              // vData["products"]=updatedProductList;
            }

            if (selectedProducts) updateDataList.push(vData);

            return null;
          })

        }
      }
      setData([...updateDataList]);
    } else if ((!variantData?.multiOption || (variantData?.multiOption && currentSelectedDetails?.prevKey === "")) && variantData?.options?.length) setData([...variantData?.options]);
  }, [selectedDetails]);
  return data.length ? (
    <React.Fragment>
      {width < 640 ? data.map((k1, i1) => i1 < 4 ? (
        <VariantCard setchangeCustomizeOption={setchangeCustomizeOption} qty={qty} key={`varCardOnly_low1_${name}_${i1}_${k1?.id}`} getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate} manualsizelabel={manualsizelabel} setmanualsizelabel={setmanualsizelabel} setmanualsizestr={setmanualsizestr} selectedManualSizeData={selectedManualSizeData} setSelectedManualSizeData={setSelectedManualSizeData} selectedDetails={selectedDetails} keyList={[...keyList, i1]} data={k1} selected={selected} setSelected={setSelected} variantData={variantData} expandNext={expandNext} isSample={isSample} setStopNextNav={setStopNextNav} translate={translate} lastVariantKey={lastVariantKey} setsamplenextNav={setsamplenextNav}/>
      ) : null) : data.map((k1, i1) => i1 < 6 ? (
        <VariantCard setchangeCustomizeOption={setchangeCustomizeOption} qty={qty} key={`varCardOnly_low2_${name}_${i1}_${k1?.id}`} getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate} manualsizelabel={manualsizelabel} setmanualsizelabel={setmanualsizelabel} setmanualsizestr={setmanualsizestr} selectedManualSizeData={selectedManualSizeData} setSelectedManualSizeData={setSelectedManualSizeData} selectedDetails={selectedDetails} keyList={[...keyList, i1]} data={k1} selected={selected} setSelected={setSelected} variantData={variantData} expandNext={expandNext} isSample={isSample} setStopNextNav={setStopNextNav} translate={translate} lastVariantKey={lastVariantKey} setsamplenextNav={setsamplenextNav} />
      ) : null)}
      {((width < 640 && data.length > 4) || (width >= 640 && data.length > 6)) ? (
        <React.Fragment>
          {expanded === "panelVarient" ? (
            <React.Fragment>
              {/* <Accordion expanded={expanded === 'panelVarient'} onChange={() => null}> */}
              {/* <AccordionSummary className='hide' aria-controls={`panelVarient_acc-content_${name}`} id={`panelVarient_acc-header_${name}`}> </AccordionSummary>
                <AccordionDetails>
                  <div className="flex left wrap gap-y-4 variantCardList"> */}
              {width < 640 ? data.map((k1, i1) => i1 > 3 ? (
                <VariantCard setchangeCustomizeOption={setchangeCustomizeOption} qty={qty} key={`varCardOnly_hig1_${name}_${i1}_${k1?.id}`} getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate} manualsizelabel={manualsizelabel} setmanualsizelabel={setmanualsizelabel} setmanualsizestr={setmanualsizestr} selectedManualSizeData={selectedManualSizeData} setSelectedManualSizeData={setSelectedManualSizeData} selectedDetails={selectedDetails} keyList={[...keyList, i1]} data={k1} selected={selected} setSelected={setSelected} variantData={variantData} expandNext={expandNext} isSample={isSample} setStopNextNav={setStopNextNav} translate={translate} lastVariantKey={lastVariantKey} setsamplenextNav={setsamplenextNav} />
              ) : null) : data.map((k1, i1) => i1 > 5 ? (
                <VariantCard setchangeCustomizeOption={setchangeCustomizeOption} qty={qty} key={`varCardOnly_hig2_${name}_${i1}_${k1?.id}`} getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate} manualsizelabel={manualsizelabel} setmanualsizelabel={setmanualsizelabel} setmanualsizestr={setmanualsizestr} selectedManualSizeData={selectedManualSizeData} setSelectedManualSizeData={setSelectedManualSizeData} selectedDetails={selectedDetails} keyList={[...keyList, i1]} data={k1} selected={selected} setSelected={setSelected} variantData={variantData} expandNext={expandNext} isSample={isSample} setStopNextNav={setStopNextNav} translate={translate} lastVariantKey={lastVariantKey} setsamplenextNav={setsamplenextNav} />
              ) : null)}
              {/* </div>
                  </AccordionDetails> */}
              {/* </Accordion>  */}
            </React.Fragment>
          ) : null}
          <div className="flex col w-1/1">
            <div className='flex center pt-4'>
              {/* purposely commented */}
              {/* <div className='flex center pt-4' style={{ maxWidth: 588 }}> */}
              <Button style={{ padding: "7px 13px 7px 23px", minWidth: 186, borderRadius: 999, fontSize: 16, fontWeight: "bold", borderColor: "#CCCCCC" }} className={`flex gap-2 meerButton ${expanded !== 'panelVarient' ? "toon" : "lees"}`} variant='outlineNoHover' onClick={() => { if (expanded === 'panelVarient') { setExpanded(false); handleExpandNext(1) } else setExpanded('panelVarient') }}>
                <span className='no-translate notranslate'>{expanded !== 'panelVarient' ? t("toonmeer") : t("toonminder")}</span>
                <KeyboardArrowDown />
              </Button>
            </div>
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  ) : null;
}
const CustomizeCardAction = ({setShowErrorAdditional, isImPrintRequired, wholeDataOfSubGroup, setIsRequiredError, storeId, selectedDetailsFinal, setQty, qtymatch, setchangeCustomizeOption, qty, getApiCartOptions, getDeliveryDate, keyList, selected, setSelected, data, setStopNextNav, expandNext, otherSettings, translate }) => {
  const customizeKey = keyList[0], mutiSelect = Boolean(otherSettings?.mutiSelect);
  const imgUrl = data?.product_gallery_images?.[0]?.["image"] ? data?.product_gallery_images?.[0]?.["image"] : data?.image ? data.image : false;

  const placeholderImage = useSelector(state => state?.getHeaderFooterData?.data?.footer?.[0]?.place_holder_image) || localStorage.getItem("placeholderImage");

  useEffect(()=>{
  //need to re-validate - setsate is happening for onclick and page load
    if( Object.keys(selected[customizeKey])?.length){
      //code for geen value imprintrequired
            const NONE_VALUES = ["geen", "nee", "no", "none"];
            let isValid = true;

            if (isImPrintRequired === "1") {
              isValid = Object.entries(wholeDataOfSubGroup).every(([key, options]) => {
                const selectedId = selected[customizeKey]?.[0];
                if (!selectedId) return false;

                const option = options?.[0]?.options?.find(opt => opt.id === selectedId);
                if (!option) return false;
                const lowerName = option.name.toLowerCase();
                return !NONE_VALUES.includes(lowerName);
              });
            }
            setIsRequiredError({key: Object.keys(wholeDataOfSubGroup)?.[0], value: !isValid , optionLength: Object.keys(selected[customizeKey])?.length})
    }

  },[selected])

  return (
    <div className="variantCard flex">
      <button
        aria-label="button"
        className={`content flex col gap-2 ${data?.id && selected[customizeKey]?.includes(data.id) ? "active" : ""}`}

        onClick={() => {
          const selectedData = { ...selected };
          let selectedCard = [...selected[customizeKey]];
          if (data?.id && selectedCard.includes(data.id)) {
            selectedCard.splice(selectedCard.indexOf(data.id), 1);
          } else if (data?.id) {
            if (!mutiSelect) {

              if ((data?.additional_delivery_days >= 0 || data?.additional_delivery_days <= 0 || customizeKey === "Verzendopties" || customizeKey === "Levertijd") && qty > 0) {
                setchangeCustomizeOption({
                  customoption: data?.id,
                  qty: true
                })
              }
              else {
                setchangeCustomizeOption({
                  customoption: "",
                  qty: true
                })
              }


              selectedCard = [];
              expandNext(true);
              setStopNextNav(false);
            } else {
              setStopNextNav(true);
            }
            selectedCard.push(data.id);
          }

          //code for geen value imprintrequired
          const NONE_VALUES = ["geen", "nee", "no", "none"];
          let isValid = true;

          if (isImPrintRequired === "1") {
            isValid = Object.entries(wholeDataOfSubGroup).every(([key, options]) => {
              const selectedId = selectedCard?.[0];
              if (!selectedId) return false;

              const option = options?.[0]?.options?.find(opt => opt.id === selectedId);
              if (!option) return false;

              const lowerName = option.name.toLowerCase();
              return !NONE_VALUES.includes(lowerName);
            });
          }
          setIsRequiredError({key: Object.keys(wholeDataOfSubGroup)?.[0], value: !isValid , optionLength: Object.keys(selectedData[customizeKey])?.length})

          selectedData[customizeKey] = selectedCard;
          setSelected({ ...selectedData });
          if(selectedData[customizeKey]?.length){
            setShowErrorAdditional(true);
          }
        }}
      >
        <React.Fragment>
          <div className='flex-1 w-1/1 flex col pt-2 px-2 customize_card'>
            <div className="relative w-1/1 r-3 overflow-hidden">
              {imgUrl ? (
                <div className="imgInfo absolute w-1/1 h-1/1">
                  <Img src={handleImage(imgUrl, placeholderImage)} alt={data.name ? data.name : "No name"} type='img' style={{ objectFit: "contain", maxWidth: "100%" }} onError={(e) => {
                    e.target.src = placeholderImage
                  }} />
                </div>) : (
                <div className="txtInfo absolute w-1/1 h-1/1 flex center middle">
                  {/* <h5 className='tc'title={data.name ? data.name : "No name"}>{data.name ? addHyphens(data.name) : addHyphens("No name")}</h5> */}
                  <h5 className='tc' title={data.name
                    ?translate?.[`${data.name}`.toLowerCase()] || data.name
                    : "No name"}>
                {addHyphens(
                  data.name
                    ?translate?.[`${data.name}`.toLowerCase()] || data.name
                    : "No name"
                )}
              </h5>

                </div>)}

              <div style={{ paddingTop: "100%" }}></div>

            </div>
          </div>
          {imgUrl ? (
            <div className='varientInfo auto w-1/1 flex col gap-2 middle pb-2 px-2' >
              <h3 className='label tc' lang="en" title={translate?.[`${data?.name}`.toLowerCase()]
            ? addHyphens(translate[`${data?.name}`.toLowerCase()])
            : addHyphens(data?.name)}>
                {translate?.[`${data?.name}`.toLowerCase()]
                  ? addHyphens(translate[`${data?.name}`.toLowerCase()])
                  : addHyphens(data?.name)}
              </h3>
              <React.Fragment>

              </React.Fragment>
            </div>
          ) : null}
          {storeId === 1 ?
            data?.tier_prices?.length && qty > 0 && qtymatch(qty, data.tier_prices) > 0 ? <h4 className='fs-14 fw-300 pb-4 no-translate notranslate' lang="en">+ {euroCurrency(qtymatch(qty, data.tier_prices))}</h4>
              : data?.price && qty > 0 && data?.price > 0 ? (
                <h4 className='fs-14 fw-300 pb-4 no-translate notranslate' lang="en">+ {euroCurrency(data?.price)}</h4>
              )
                : null
            :
            data?.tier_prices?.length && qtymatch(qty, data.tier_prices) > 0 ? <h4 className='fs-14 fw-300 pb-4 no-translate notranslate' lang="en">+ {euroCurrency(qtymatch(qty, data?.tier_prices))}</h4>
              : data?.price ? (
                <h4 className='fs-14 fw-300 pb-4 no-translate notranslate' lang="en">+ {euroCurrency(data?.price)}</h4>
              )
                : null}
        </React.Fragment>
      </button>
    </div>
  )
}
const CustomizeCardSingle = ({setShowErrorAdditional,isImPrintRequired, wholeDataOfSubGroup, setIsRequiredError, storeId, selectedDetailsFinal, setQty, qtymatch, setchangeCustomizeOption, qty, getApiCartOptions, getDeliveryDate, keyList, selected, setSelected, data, variantData, expandNext, setStopNextNav, handleExpandNext, translate }) => {
  const [width] = useWindowSize();
  const [expanded, setExpanded] = useState(false);
  const [optionsList, setOptionsList] = useState([]);
  useEffect(() => {
    if (data?.options?.length) {
      const tempOptions = [...data.options];
      if (tempOptions?.[0]?.sort_order) tempOptions.sort((i, j) => parseInt(i.sort_order || 0) - parseInt(j.sort_order || 0));
      setOptionsList(tempOptions);
    } else {
      if (optionsList.length) setOptionsList([]);
    }
  }, [data?.options])
  return optionsList?.length ? (
    <React.Fragment>
      {width < 640 ? optionsList.map((item, i) => i < 4 ? (
        <CustomizeCardAction
          storeId={storeId}
          key={`CustomizeCardAction${variantData.label}_${keyList[0]}_${keyList[1]}_${keyList[2]}_${i}`}
          keyList={[...keyList, i]}
          selectedDetailsFinal={selectedDetailsFinal}
          setQty={setQty}
          setchangeCustomizeOption={setchangeCustomizeOption}
          selected={selected}
          setSelected={setSelected}
          data={item}
          variantData={variantData}
          expandNext={expandNext}
          setStopNextNav={setStopNextNav}
          translate={translate}
          getApiCartOptions={getApiCartOptions}
          getDeliveryDate={getDeliveryDate}
          qty={qty}
          qtymatch={qtymatch}
          isImPrintRequired={isImPrintRequired}
          wholeDataOfSubGroup={wholeDataOfSubGroup}
          setIsRequiredError={setIsRequiredError}
          setShowErrorAdditional={setShowErrorAdditional}
        />
      ) : null) : optionsList.map((item, i) => i < 6 ? (
        <CustomizeCardAction
          storeId={storeId}
          selectedDetailsFinal={selectedDetailsFinal}
          setQty={setQty}
          key={`CustomizeCardAction${variantData.label}_${keyList[0]}_${keyList[1]}_${keyList[2]}_${i}`}
          keyList={[...keyList, i]}
          setchangeCustomizeOption={setchangeCustomizeOption}
          selected={selected}
          setSelected={setSelected}
          data={item}
          variantData={variantData}
          expandNext={expandNext}
          setStopNextNav={setStopNextNav}
          translate={translate}
          getApiCartOptions={getApiCartOptions}
          getDeliveryDate={getDeliveryDate}
          qty={qty}
          qtymatch={qtymatch}
          isImPrintRequired={isImPrintRequired}
          wholeDataOfSubGroup={wholeDataOfSubGroup}
          setIsRequiredError={setIsRequiredError}
          setShowErrorAdditional={setShowErrorAdditional}

        />
      ) : null)}
      {((width < 640 && optionsList.length > 4) || (width >= 640 && optionsList.length > 6)) ? (
        <React.Fragment key={`customizeCardAccordion_${variantData.label}`} >
          {expanded === 'panelVarient' ?
            <React.Fragment>
              {width < 640 ? optionsList.map((item, i) => i > 3 ? (
                <CustomizeCardAction
                  storeId={storeId}
                  selectedDetailsFinal={selectedDetailsFinal}
                  setQty={setQty}
                  setchangeCustomizeOption={setchangeCustomizeOption}
                  key={`CustomizeCardAction${variantData.label}_${keyList[0]}_${keyList[1]}_${keyList[2]}_${i}`}
                  keyList={[...keyList, i]}
                  selected={selected}
                  setSelected={setSelected}
                  data={item}
                  variantData={variantData}
                  expandNext={expandNext}
                  setStopNextNav={setStopNextNav}
                  translate={translate}
                  getApiCartOptions={getApiCartOptions}
                  getDeliveryDate={getDeliveryDate}
                  qty={qty}
                  qtymatch={qtymatch}
                  isImPrintRequired={isImPrintRequired}
                  wholeDataOfSubGroup={wholeDataOfSubGroup}
                  setIsRequiredError={setIsRequiredError}
                  setShowErrorAdditional={setShowErrorAdditional}

                />
              ) : null) : optionsList.map((item, i) => i > 5 ? (
                <CustomizeCardAction
                  storeId={storeId}
                  setchangeCustomizeOption={setchangeCustomizeOption}
                  selectedDetailsFinal={selectedDetailsFinal}
                  setQty={setQty}
                  key={`CustomizeCardAction${variantData.label}_${keyList[0]}_${keyList[1]}_${keyList[2]}_${i}`}
                  keyList={[...keyList, i]}
                  selected={selected}
                  setSelected={setSelected}
                  data={item}
                  variantData={variantData}
                  expandNext={expandNext}
                  setStopNextNav={setStopNextNav}
                  translate={translate}
                  getApiCartOptions={getApiCartOptions}
                  getDeliveryDate={getDeliveryDate}
                  qty={qty}
                  qtymatch={qtymatch}
                  isImPrintRequired={isImPrintRequired}
                  wholeDataOfSubGroup={wholeDataOfSubGroup}
                  setIsRequiredError={setIsRequiredError}
                  setShowErrorAdditional={setShowErrorAdditional}

                />
              ) : null)}
            </React.Fragment> : null}
          <div className='flex center pt-4' style={{ width: "100%" }}>
            {/* purposely commented */}
            {/* <div className='flex center pt-4' style={{ maxWidth: 588, width:"100%" }}> */}
            <Button style={{ padding: "7px 13px 7px 23px", minWidth: 186, borderRadius: 999, fontSize: 16, fontWeight: "bold", borderColor: "#CCCCCC" }} className={`flex gap-2 meerButton ${expanded !== 'panelVarient' ? "toon" : "lees"}`} variant='outlineNoHover' onClick={() => { if (expanded === 'panelVarient') { setExpanded(false); handleExpandNext(1) } else setExpanded('panelVarient') }}>
              <span className='no-translate notranslate'>{expanded !== 'panelVarient' ? t("toonmeer") : t("toonminder")}</span>
              <KeyboardArrowDown />
            </Button>
          </div>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  ) : null;
}
const CustomizeCardRoot = ({setShowErrorAdditional, isImPrintRequired, wholeDataOfSubGroup, setIsRequiredError, storeId, selectedDetailsFinal, setQty, qtymatch, setchangeCustomizeOption, qty, getDeliveryDate, getApiCartOptions, keyList, variantData, selected, setSelected, expandNext, handleExpandNext, setStopNextNav, translate }) => {
  return variantData?.options && Object.keys(variantData?.options).length ? Object.keys(variantData.options).length === 1 ? (
    <React.Fragment>
      {Object.keys(variantData.options).map((key, i) => variantData.options[key] && variantData.options[key]?.length ? (
        <div className="flex left wrap gap-2 w-1/1" key={`CustomizeCardRoot_${variantData.label}${i}`} >
          {variantData.options[key].map((item, i2) => (
            <CustomizeCardSingle
              key={`CustomizeCardSingle_${variantData.label}_${i}_${i2}`}
              keyList={[...keyList, key, i2]}
              setchangeCustomizeOption={setchangeCustomizeOption}
              selected={selected}
              storeId={storeId}
              setSelected={setSelected}
              data={item}
              selectedDetailsFinal={selectedDetailsFinal}
              setQty={setQty}
              variantData={variantData}
              expandNext={expandNext}
              setStopNextNav={setStopNextNav}
              handleExpandNext={handleExpandNext}
              translate={translate}
              getDeliveryDate={getDeliveryDate}
              getApiCartOptions={getApiCartOptions}
              qty={qty}
              qtymatch={qtymatch}
              isImPrintRequired={isImPrintRequired}
              wholeDataOfSubGroup={wholeDataOfSubGroup}
              setIsRequiredError={setIsRequiredError}
              setShowErrorAdditional={setShowErrorAdditional}
            />
          ))}
        </div>
      ) : null)}
    </React.Fragment>
  ) : (
    <React.Fragment>
    </React.Fragment>
  ) : null;
}
const SubGroupItem = ({ wholeDataOfSubGroup,isImPrintRequired,setIsRequiredError, setchangeCustomizeOption, setOpenModelInfo, getApiCartOptions, getDeliveryDate, keyList, data, selected, expandNext, stopNextNav, setStopNextNav, setSelected, sel, setSel, setServicesDetailsData, setOpenModel, qty, translate, dataMain }) => {
  const [exp, setExp] = useState("thisTab");
  const [optionList, setOptionList] = useState([]);
  const InfoImage = "/res/img/info.svg";
  const [imageSrc, setImageSrc] = useState("");
  const setcategoryDetails = () => {
    const categoryDetails = {
      category_name: data?.name,
      category_description: data?.description,
      hideVragen: true,
      option: {
        img: data?.optionImage,
        position: data?.name,
        positionVal: data?.subgrouplabel,
        maxi: data?.groupinfo,
        download_template_url: data?.download_template_url
      }
    }
    setServicesDetailsData({ content: { categoryDetails } })
  }
  const handleExp = () => {
    if (keyList?.[1] && selected?.[keyList[1]]?.length) {
      let temp = "thisTab"
      data.options.map((d, i) => {
        if (d?.id && selected[keyList[1]]?.includes(d.id)) temp = "";
        return null;
      })
      setExp(temp);
    }
  }
  // commented for purpose
  // const qtymatch = (qty, tier_prices) => {
  //   let price = 0;
  //   if (tier_prices?.length) {
  //     tier_prices.forEach((t, i) => price = t.qty <= qty ? t.price : t.price)
  //   }
  //   return price ? `+ ${euroCurrency(price)}` : ""
  // }
  const qtymatch = (qty, tier_prices) => {

    let price = 0;
    if (tier_prices?.length) {
      tier_prices.sort((a, b) => a.qty - b.qty);

      tier_prices.forEach(t => {
        if (t.qty <= qty) {
          price = t.price;
        }
      });
    }

    return price ? `+ ${euroCurrency(price)}` : "";
  };

  useEffect(() => {
    if (data?.options && data?.options?.length) {
      const tempData = [...data?.options];
      if (tempData?.[0]?.sortorder) tempData.sort((i, j) => parseInt(i.sortorder || 0) - parseInt(j.sortorder || 0));
      setOptionList(tempData);
      handleExp();
    }
  }, [data]);
  useEffect(() => {
    if (data?.options && data?.options?.length) {
      handleExp();
    }
  }, [selected]);

  useEffect(() => {
    if (data?.optionImage) {
      setImageSrc(data?.optionImage)
    }
  }, [data])

  useEffect(() => {
    if(Object.values(selected)?.[0]?.length){
      const data1 = { ...(wholeDataOfSubGroup?.[0] || wholeDataOfSubGroup) };
      const selectedData1 = { ...selected, [keyList?.[1]]: selected?.[keyList[1]] };
      const NONE_VALUES = ["geen", "nee", "no", "none"];
      let isValid = true;;
      if (isImPrintRequired === "1") {
        const hasValid = Object.entries(data1).some(([key, optionArray]) => {
          const selectedIds = selectedData1[key]; // e.g., ["22068547", "22068541"]
          if (!Array.isArray(selectedIds) || !Array.isArray(optionArray)) return false;
  
          // Flatten all options from all optionGroups
          const allOptions = optionArray.flatMap((group) => group?.options || []);
          // Check if any selectedId maps to a valid option (not in NONE_VALUES)
          return selectedIds.some((selectedId) => {
            const selectedOption = allOptions.find((opt) => opt.id === selectedId);
            return selectedOption && !NONE_VALUES.includes(selectedOption.name?.toLowerCase());
          });
        });
        isValid = hasValid;
      }
  
      setIsRequiredError({ key: data?.grouplabel, value: !isValid, optionLength: Object.keys(selected)?.length });
    }
  }, [selected]);

  return (
    <div className=' w-1/1 flex col gap-1 subGroupItem'>
      {data?.name ? (<h3 className='flex gap-1 middle'>
        <b>{"Drukmethode"}:</b>
        <span onClick={() => {
          if (data?.name || data?.description) {
            setOpenModelInfo(true);
            setcategoryDetails()
          }
        }}>{translate?.[`${data?.name}`.toLowerCase()] ? translate[`${data?.name}`.toLowerCase()] : data?.name}</span>
        <IconButton aria-label="info" onClick={() => {
          if (data?.name || data?.description) {
            setOpenModelInfo(true);
            setcategoryDetails()
          }
        }}><Img src={handleImage(InfoImage)} className="infoimg" width="19px" height="19px" /></IconButton>
      </h3>) : null}

      {data?.name ? <h4>{data?.groupinfo}</h4> : null}
      <div className={`w-1/1 ${data?.optionImage ? "flex gap-5" : ""} pt-2 wrap cardItem`}>
        <div className="flex-0 relative hide flex center ">
          {data?.optionImage ?
          <div className='imgCard pointer' 
          onClick={() => {
              setOpenModel(true);
              setcategoryDetails()
          }}>
            {data?.optionImage ?
              <Img animation={false} style={{ position: "absolute", objectFit: "contain" }} type="img"
                onError={() => {
                  setImageSrc(data?.optionImage)
                }}
                src={handleImage(imageSrc ? imageSrc : data?.optionImage)} alt={data?.name || "img"} title={data?.name || "img"} />
              : ""
            }
          </div>
          : "" }
        </div>
        <div className="flex-1 flex gap-2 wrap">
          {keyList?.[1] && optionList?.length ? optionList.map((d, i) => (

            <div key={`cardAction_flex${i}`} className="cardAction flex">
              {d?.max === "X" ? null :
                <button
                  aria-label="button"
                  className={`content flex col gap-2 ${(!d?.tier_prices?.length) && selected?.[keyList?.[1]]?.length && exp === "thisTab" ? "hidden-button" : ""} ${d?.id && selected?.[keyList[1]]?.includes(d.id) ? "active" : ""}`}
//                   className={`content flex col gap-2 ${
//   (!d?.tier_prices?.length && selected?.[keyList?.[1]]?.length && exp === "thisTab") ? "hidden-button" : ""
// } ${d?.id && selected?.[keyList[1]]?.includes(d.id) ? "active" : ""}`}

                  disabled={d?.id && selected?.[keyList[1]]?.includes(d.id)}
                  onClick={() => {
                    if ((d?.additional_delivery_days >= 0 || data?.additional_delivery_days <= 0) && qty > 0) {
                      setchangeCustomizeOption({
                        customoption: d?.id,
                        qty: true

                      })

                    }
                    else
                      setchangeCustomizeOption({
                        qty: true
                      })
                    expandNext(false)
                    const selectedData = { ...selected }, selectedMainData = { ...sel }, key0 = keyList?.[0], key1 = keyList?.[1];
                    if (key0 && key1 && d?.id) {
                      if (!selectedData[key1]) selectedData[key1] = [];
                      let cardSelected = [...selectedData[key1]], cardSelectedMain = [];
                      if (cardSelected.includes(d.id)) {
                        cardSelected = []
                      } else {
                        cardSelected = [d.id];
                      }
                  dataMain?.length && dataMain.forEach((opt) => {
                          if (opt?.id !== data?.id) {
                              const op = opt?.options?.[0];
                              if (op && op?.id && !op?.price && !op?.tier_prices?.length) {
                                  cardSelected.push(op.id);
                              }
                          }
                      });
                        
                      const objKey = Object.keys(selectedData)
                      if (objKey.length) objKey.map((k) => {
                        cardSelectedMain = [...cardSelectedMain, ...k !== key1 ? selectedData[k] : cardSelected];
                        return null;
                      });
                      selectedData[keyList?.[1]] = cardSelected;
                      selectedMainData[keyList?.[0]] = cardSelectedMain;
                      setSelected({ ...selectedData });
                      setSel({ ...selectedMainData });
                    }
                  }}
                >
                  <React.Fragment>
                    <div className='varientInfo auto w-1/1 flex col gap-2 middle'>
                      <React.Fragment>
                        {d?.max ? (
                          <h3 className='label' lang="en" title={translate?.[`${d.max}`.toLowerCase()]
                          ? addHyphens(translate[`${d.max}`.toLowerCase()])
                          : addHyphens(d.max)}>
                            {translate?.[`${d.max}`.toLowerCase()]
                              ? addHyphens(translate[`${d.max}`.toLowerCase()])
                              : addHyphens(d.max)}
                          </h3>
                        ) : d?.name ? (
                          <h3 className='label' lang="en" title={translate?.[`${d.name}`.toLowerCase()]
                          ? addHyphens(translate[`${d.name}`.toLowerCase()])
                          : addHyphens(d.name)}>
                            {translate?.[`${d.name}`.toLowerCase()]
                              ? addHyphens(translate[`${d.name}`.toLowerCase()])
                              : addHyphens(d.name)}
                          </h3>
                        ) : null}
 <h4 className={`${d?.tier_prices?.length && qtymatch(qty, d.tier_prices) ? "label" : "v-hide"} no-translate notranslate`} lang="en">{qtymatch(qty, d.tier_prices) || "0,00"}</h4>

                      </React.Fragment>
                    </div>
                  </React.Fragment>
                </button>
              }

            </div>)) : null}
        </div>
      </div>
    </div>
  )
}
const AdditionalSubGroupListDeails = ({wholeDataOfSubGroup,isImPrintRequired, setIsRequiredError,setchangeCustomizeOption, setOpenModelInfo, getApiCartOptions, getDeliveryDate, keyList, expandNext, stopNextNav, setStopNextNav, expAddData, setExpAddData, data, selected, setSelected, setServicesDetailsData, setOpenModel, qty, translate }) => {
  return (
    <div className="w-1/1 flex col gap-2 subGroupList py-6">
      {data?.length && data.map((item, index2) => (
        <React.Fragment key={`SubGroupList_options${keyList[1]}_${keyList[2]}_${index2}`}>
          <SubGroupItem wholeDataOfSubGroup={wholeDataOfSubGroup} isImPrintRequired={isImPrintRequired}setIsRequiredError={setIsRequiredError} setchangeCustomizeOption={setchangeCustomizeOption} setOpenModelInfo={setOpenModelInfo} getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate} expandNext={expandNext} stopNextNav={stopNextNav} setStopNextNav={setStopNextNav} keyList={[...keyList, index2]} selected={expAddData} setSelected={setExpAddData} sel={selected} setSel={setSelected} data={item} dataMain={data} setServicesDetailsData={setServicesDetailsData} setOpenModel={setOpenModel} qty={qty} translate={translate} />
        </React.Fragment>
      ))}
    </div>
  );
}

const AdditionalSubGroupList = ({
  variantId,
  setchangeCustomizeOption,
  setOpenModelInfo,
  getApiCartOptions,
  getDeliveryDate,
  keyList,
  setShowErrorAdditional,
  expandNext,
  stopNextNav,
  setStopNextNav,
  name,
  data,
  selected,
  setSelected,
  setServicesDetailsData,
  setOpenModel,
  translate,
  qty,
  setIsRequiredError,
  wholeDataOfSubGroup,
  isImPrintRequired
}) => {
  const [expanded, setExpanded] = useState("0");
  const [expAddData, setExpAddData] = useState({});

  const processExpAddData = useCallback(() => {

    const thisAddData = {};

    if (data && Object.keys(data).length) {
      Object.keys(data).forEach((key) => {
        thisAddData[key] = [];

        if (selected[keyList[0]]?.length && data[key]?.length) {
          data[key].forEach((item) => {
            item?.options?.forEach((i) => {
              if (selected[keyList[0]].includes(i?.id)) {
                thisAddData[key].push(i.id);
              }
            });
          });
        }
      });
    }


    setExpAddData((prevData) => {
      if (JSON.stringify(prevData) !== JSON.stringify(thisAddData)) {
        return thisAddData;
      }
      return prevData;
    });

    return thisAddData;
  }, [selected, keyList, data]);
  useEffect(() => {
    if (!data || !selected?.position || !selected["Kies de gewenste bewerking"]) return;
  
    const activeSegments = selected.position; 
  
    let allowedOptionIds = [];
  
    activeSegments.forEach((segmentKey) => {
      const segment = data[segmentKey];
      if (Array.isArray(segment)) {
        segment.forEach((group) => {
          if (Array.isArray(group.options)) {
            group.options.forEach((opt) => {
              allowedOptionIds.push(String(opt.id));
            });
          }
        });
      }
    });
  
    const currentOptions = selected["Kies de gewenste bewerking"].map(String);
  
    const updatedOptions = currentOptions.filter((id) => allowedOptionIds.includes(id));
  
    if (updatedOptions.length !== currentOptions.length) {
      setSelected((prev) => ({
        ...prev,
        "Kies de gewenste bewerking": updatedOptions,
      }));
    }
  }, [selected, data]);
  useEffect(() => {

  const dataKeys = Object.keys(data);
  

  if (dataKeys.length === 1) {
    setShowErrorAdditional(true);
    return;
  }

    if (!data || !selected?.position || !selected["Kies de gewenste bewerking"]) return;
    const activeSegments = selected.position;
  
    let allowedOptionIds = [];
    let totalTitles = 0;
  
    activeSegments.forEach((segmentKey) => {
      const segment = data[segmentKey];
      if (Array.isArray(segment)) {
        totalTitles += segment.length; 
        segment.forEach((group) => {
          if (Array.isArray(group.options)) {
            group.options.forEach((opt) => {
              allowedOptionIds.push(String(opt.id));
            });
          }
        });
      }
    });
  
    const currentOptions = selected["Kies de gewenste bewerking"].map(String);
    if (currentOptions.length < totalTitles) {
      setShowErrorAdditional(false);
    } else if(currentOptions.length >= totalTitles) {
      setShowErrorAdditional(true);
    }
  
    const updatedOptions = currentOptions.filter((id) => allowedOptionIds.includes(id));
  
    if (updatedOptions.length !== currentOptions.length) {
      setSelected((prev) => ({
        ...prev,
        "Kies de gewenste bewerking": updatedOptions,
      }));
    }
  }, [selected, data]);

  useEffect(() => {
    const thisAddData = processExpAddData();

    let opentab = -1;
    const thisAddDataKeys = Object.keys(thisAddData);

    if (thisAddDataKeys.length) {
      thisAddDataKeys.forEach((dKey, index) => {
        if (opentab === -1 && !thisAddData[dKey].length) {
          opentab = index;
        }
      });
    }

    if (expanded !== "" && parseInt(expanded) !== opentab) {
      const maxTab = Object.keys(data).length;
      opentab = maxTab > opentab ? opentab : 0;
      // setExpanded(`${opentab}`);

      // setTimeout(() => {
      //   if (maxTab > opentab) {
      //     const head = document.querySelector(`.subHeader`);
      //     const commEle = document.querySelector(`.additionalSubGroupListEle`);
      //     const top = commEle?.offsetTop + head?.clientHeight + 72 + opentab * 64;

      //     window.scrollTo({ top, left: 0, behavior: "smooth" });
      //   }
      // }, 600);
    }
  }, [selected, variantId, processExpAddData]);
  
  return data && Object.keys(data).length ? (
    <>
      {Object.keys(data).map((key, index) =>
        data[key]?.length ? (
          <React.Fragment key={`SubGroupList_Item${name}${key}${index}`}>
            <div className={`subAccordion${index}`} />
            <div className="flex col w-1/1">
              <Accordion
                // expanded={(expanded === "" && index === 0) || expanded === `${index}`}
                expanded
                // onChange={() => setExpanded(expanded === `${index}` ? "" : `${index}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls={`subGroupList_Item-content${index}`}
                  id={`subGroupList_Item-header${index}`}
                >
                  {translate?.[`${key}`.toLowerCase()] || key}
                </AccordionSummary>
                <AccordionDetails>
                  <AdditionalSubGroupListDeails
                    setIsRequiredError={setIsRequiredError}
                    setchangeCustomizeOption={setchangeCustomizeOption}
                    setOpenModelInfo={setOpenModelInfo}
                    getApiCartOptions={getApiCartOptions}
                    getDeliveryDate={getDeliveryDate}
                    key={`AdditionalSubGroupListDeails${keyList[0]}_${key}_${index}`}
                    expandNext={expandNext}
                    stopNextNav={stopNextNav}
                    setStopNextNav={setStopNextNav}
                    keyList={[...keyList, key, index]}
                    expAddData={expAddData}
                    setExpAddData={setExpAddData}
                    selected={selected}
                    setSelected={setSelected}
                    data={data[key]}
                    setServicesDetailsData={setServicesDetailsData}
                    setOpenModel={setOpenModel}
                    qty={qty}
                    translate={translate}
                    wholeDataOfSubGroup={wholeDataOfSubGroup}
                    isImPrintRequired={isImPrintRequired}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </React.Fragment>
        ) : null
      )}
    </>
  ) : null;
};
const ProductVariant = ({ tokenGetData, setTokenGetData, key, setMinPrice, data, setGallerySelected, setOpenCopyURLModel, urlGenData, generateNewUrl, stateUploadedPath, setStateUploadedPath, productDetailsStaticData, translateData, registerTrigger, setIsValidSampleAtLast, setIsClicked }) => {
  const { baseURL, defaultURL, storeId } = useContext(DomainContext);
  const qtyDataDefault = { isCustomQty: false, index: -1, price: 0, addOnPrice: 0 }
  const productId = data?.settings?.product_id;
  const productSku = data?.settings?.product_sku;
  const productName = data?.settings?.product_name;
  const hasFetchedDeliveryDate = useRef(false);
  const [tierPriceQty, setTierpriceQty] = useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [variantQtydata, setVariantQtyData] = useState([]);
  const [openModelQty, setOpenModelQty] = useState(false);
  const [showErrorAdditional, setShowErrorAdditional] = useState(false);
  const [customQty, setcustomQty] = useState(false);
  const [totalValueQty, setTotalValueQty] = useState(0);
  const [oneTimeValue, setOneTime] = useState("0");
  const [displayAfterRender, setDisplayAfterRender] = useState(false)
  const [textAreaData, setTextData] = useState("");
  const [customOptions, setCustomOptions] = useState(null);
  const [simpleProductIdUpdated, setSimpleProductIdUpdated] = useState(null);
  const [initialTierPricePopup,setInitialTierPricePopup]=useState([])
  const [reqExpandedUpload, setreqExpandedUpload] = useState(true);
  const [inputFieldExpand, setInputFieldExpand] = useState(false);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const lastOptionKeyRef = useRef("");
  const abortControllerRef = useRef(null);
  const debounceTimerRef = useRef(null);
  const [files, setFiles] = useState([]);

  const { t } = useTranslation();
  const [changeCustomizeOption,setchangeCustomizeOption] = useState({
    customoption:"",
    qty:false,
    variant:""
  });

  const {
    isLoggedUser, customerId, token, guestQuoteId, guestKey, customerQuoteId, isSessionExpired
  } = useSelector(state => {
    return {
      isLoggedUser: state?.isLoggedUser,
      customerId: state?.customerDetails?.id,
      token: state?.token,
      updateWishList: state?.updateWishList,
      updateCartItems: state?.updateCartItems,
      guestQuoteId: state?.guestQuoteDetails?.id,
      guestKey: state?.guestKey,
      customerQuoteId: state?.customerQuoteId,
      wilistProductId: state?.wilistProductId,
      isSessionExpired: state?.isSessionExpired,
    }
  });

  // wishlist
  const wishlistAddedData = useSelector((state) => state?.wishlistAddedData);
  const wishItem = wishlistAddedData?.filter(obj => obj?.sku === productSku);

  // Free sample details
  const [openFreeSample, setOpenFreeSample] = useState(false);
  const [isSampleCalled, setIsSampleCalled] = useState(false);

  // cart
  const [isNewUrlLoad, setIsNewUrlLoad] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessing1, setIsProcessing1] = useState(false);
  const [singleToken, setSingleToken] = useState("");
  const [allData, setAllData] = useState({});
  const [selectedColorData, setSelectedColorData] = useState(null);
  const [selectedManualSizeData, setSelectedManualSizeData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedDataNow, setSelectedDataNow] = useState(null);
  const [selectedDataBackup, setSelectedDataBackup] = useState(null);
  const [selectedDataDefault, setSelectedDataDefault] = useState(null);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [selectedDetailsDefault, setSelectedDetailsDefault] = useState({});
  const [isRequiredError, setIsRequiredError] = useState({key:"",value:false});
  // const [setupCostColor, setSetupCostColor] = useState(0);
  const [selectedDetailsFinal, setSelectedDetailsFinal] = useState({ tier_prices: [], price: 0, setup_costs: 0, product_vat: 0 });
  const [sampleProductPrice, setSampleProductPrice] = useState({
    highest_tier: 0,
    condtion_one: false,
    condition_two: false,
    condtion_three: false,
    tempTierPriceSmaple: ""
  })
  const [expanded, setExpanded] = useState(0);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const [reqExpanded, setReqExpanded] = useState(false);
  const [showError, setShowError] = useState(false);
  const [completed, setcompleted] = useState(false)
  const [qty, setQty] = useState(0);
  const [qtyUrl, setQtyUrl] = useState(-1);
  const [qtyTemp, setQtyTemp] = useState(0);
  const [qtyData, setQtyData] = useState({ ...qtyDataDefault });
  const [isCustomQty, setIsCustomQty] = useState(null);
  const [isSample, setIsSample] = useState(false); // For sample
  const [sampleCustomizeItem, setSampleCustomizeItem] = useState([]); // For sample
  const [sampleQty, setSampleQty] = useState([]); // For sample
  const [openModelUpload, setOpenModelUpload] = useState(false); // For uploadInfo
  const [openModelDelivery, setOpenModelDelivery] = useState(false); // For DeliveryInfo

  const [additionalOption, setAdditionalOption] = useState({ is: false, sku: "" });
  const [deliveryData, setDeliveryData] = useState(null);
  const [expandPrice, setExpandPrice] = useState(true);
  const [servicesDetailsData, setServicesDetailsData] = useState(null);
  const [selectedColorItem, setSelectedColorItem] = useState(null)
  const [openColorModel, setOpenColorModel] = useState(false)
  const [stopNextNav, setStopNextNav] = useState(false);
  const [samplenextNav, setsamplenextNav] = useState(false);
  // ups
  const [tagUrl, setTagUrl] = useState("");
  const [isUpsCalled, setIsUpsCalled] = useState(false);
  const [openModelUPS, setOpenModelUPS] = useState(false);
  const [openModelInfo, setOpenModelInfo] = useState(false);
  const [openModelUPSNew, setOpenModelUPSNew] = useState(false);
  const uspHandler = (url) => {
    setTagUrl(url);
    setIsUpsCalled(false);
    setOpenModelUPSNew(true);
  }
  const [imagesDropbox, setImagesDropbox] = useState([]);
  const [imageCanvasTemplate, setImageCanvasTemplate] = useState("");
  const [dropboxFiles, setDropboxFiles] = useState("");
  const [reloadScroll, setReloadScroll] = useState(false);
  const [disableAction, setdisableAction] = useState("");
  const [errorCart, setErrorCart] = useState("");
  const [errorOpenTab, setErrorOpenTab] = useState("");
  const [cmsError, setCmsError] = useState("");
  const [errorQty, setErrorQty] = useState(true);
  const [manualsizestr, setmanualsizestr] = useState(null);
  const [InputManualSize, setInputManualSize] = useState(null);
  const [manualsizelabel, setmanualsizelabel] = useState(null);
  const accordionRef = useRef(null);
  const scrollTargetRef = useRef(null);
  const startAccordionRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [width] = useWindowSize();

  useEffect(() => {
    if (data) {
      setTimeout(() => {
        setDisplayAfterRender(true);
      }, 500);
    }
  }, []);

  useEffect(() => {
  if (registerTrigger) {
    setIsClicked(isSample)
    registerTrigger(() => {
      setIsSample(prev => !prev);
    });
  }
}, [registerTrigger]);

  const getNextData = (fromCart, data, details) => {
    const selData = data ? data : selectedData;
    const selDetails = details ? details : selectedDetails;
    const isNotUpload = selDetails?.upload?.hide === true;
    const list = Object.keys(selDetails);
    const finalDatas = selectedDetailsFinal;
    let nextNo = -1, length = list?.length, isQty = "", movenext = true;
    if (selDetails?.isSample) length--;
    // On purpose
    // const c4 = key === "size" && (errorQty === false);
    // if(c4) movenext = false;
    list?.length && list.forEach((key, i) => {
      if (movenext) {
        const c1 = ((key === "upload") && list.includes("upload"));
        const c2 =  ((selDetails?.[key]?.thisType === "additional") && (selDetails?.[key]?.hide === true));
        const c3 = key === "cpker" && (i > parseInt(expanded) || cmsError === "false" || cmsError === "");
        const c4 = key === "size" && (i > parseInt(expanded) && allData?.size?.isManualSize == true);
        // const c4 = key === "size" && allData?.size?.isManualSize == true;
        if (c3 || c4) movenext = false;
        // if (c3) movenext = false;
        else if (!c1 && !c2) {
          const condition0 = key === "cpker";
          // const condition1 = !condition0 && key === "upload" && (selData?.upload?.length || imagesDropbox.length > 0 || textAreaData !== "");
          const condition1 = !condition0 && key === "upload";
          const condition2 = !condition1 && ( isRequiredError?.key === key ? !isRequiredError?.value && Boolean(selData[key]?.length) && (Boolean(finalDatas?.tier_prices?.length) || Boolean(finalDatas?.price > 0)) : Boolean(selData[key]?.length));
           if(isRequiredError?.key === key && !(Boolean(finalDatas?.tier_prices?.length) || Boolean(finalDatas?.price > 0))){
             setIsRequiredError((prev)=>({
              ...prev,
               value: !condition2}));
           }
          const conditionI1 = key === "qty";
          const conditionI2 = key === "Kies de gewenste bewerking";
          
          // const conditionI4 = key === "size" && allData?.size?.isManualSize == true;
          isQty = !condition2 && list[i] === 'qty' ? "now" : condition2 && list[i] === 'qty' ? (qty > 0 || isCustomQty === true ? "full" : "now") : "";
          if (conditionI1 ) {
            if (isCustomQty) {
              if (qty > 0 && customQty && isCustomQty) nextNo = nextNo + 1;
              else movenext = false
            }

            else if (!isCustomQty) {
              if (qty > 0 && customQty) nextNo = nextNo + 1;
              // else if(qty == 0 && !customQty ) nextNo = nextNo + 1;
              else movenext = false

            }

            //  if(qty > 0 && isCustomQty)nextNo = nextNo + 1;
            // if ((qty > 0 && (isCustomQty === true  && selectedDetailsFinal?.qty_increments > 1) )) nextNo = nextNo ;
            // else if (qty > 0 && isCustomQty ===false) nextNo = nextNo +1;
            //  else if ((qty > 0 && isCustomQty === true && selectedDetailsFinal?.qty_increments > 1)) nextNo = nextNo ;

            // else if (warningMessage!=="") nextNo = nextNo;
            //  else if ((qty > 0 && (isCustomQty === true && selectedDetailsFinal?.qty_increments > 1 && warningMessage !== ""))) nextNo = nextNo;
            // else if ((qty > 0 && (isCustomQty === true && selectedDetailsFinal?.qty_increments>1))) nextNo = nextNo;
            else movenext = false;

          } 
          else if(condition2 && conditionI2 && !showErrorAdditional)movenext = false;
          else if (condition0 || condition1 || condition2 ) nextNo = i + 1;
          else if (!condition2 && !condition1) movenext = false;
        } else if ((c1 && !isNotUpload)) {
          if (selData?.upload?.length || imagesDropbox.length > 0 || textAreaData !== "") nextNo = nextNo + 1;
          else movenext = false;
        } else if (c1 && isNotUpload) nextNo = nextNo + 1;
        else if (c2 )nextNo = nextNo + 1;
      }
    });
    if (selDetails?.isSample && nextNo == -1) {
      nextNo = 0;
    }
    // On purpose
    // const condition0 = key === "cpker" && (expanded !== 0 && expanded < i);
    // const condition1 = !condition0 && Boolean(selectedData[key] && selectedData[key].length);
    // const condition2 = !condition1 && key === "upload" && (selectedDetails?.upload?.hide || imagesDropbox.length > 0 );
    // const condition3 = !condition2 && allData[key]?.is_require === false;
    // if (condition0 || condition1 || condition2 || condition3) len++;
    // if (nextNo === -1) {
    //   nextNo = condition0 || !(condition1 || condition2 || condition3) ? i : nextNo;
    // }
    // if(isQty === "now") nextNo
    // isQty = Boolean(nextNo > -1 && length && Object.keys(selectedDetails)?.[nextNo] === "qty");
    return { nextNo, isQty, length: length };
  };

    const getPriceForQty = (qty, tierprice, isvalid) => {
    const sorted = tierprice?.slice()?.sort((a, b) => a?.qty - b?.qty);
    if (qty < sorted[0]?.qty) {
      const basePrice = sorted[0]?.price || 0;
      return isvalid ? basePrice : basePrice + qtyData?.addOnPrice;
    }

    let price = sorted[0]?.price || 0;

    for (const tier of sorted) {
      if (tier?.qty === qty) {
        return isvalid ? tier?.price : tier?.price + qtyData?.addOnPrice;
      }
      if (tier?.qty <= qty) price = tier?.price;
      else break;
    }

    return isvalid ? price : price + qtyData?.addOnPrice;
  };

  const handleExpanded = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : "");
    setIsNextClicked(false);
  };
  
  // helper: find nearest vertical scrollable parent (or return window)
function getScrollParent(node) {
  while (node && node !== document.body) {
    const s = getComputedStyle(node);
    const oy = s.overflowY;
    if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight) return node;
    node = node.parentElement;
  }
  return window;
}

// helper: wait until node's bounding height/top are stable for `stableThreshold` ms (fallback timeout)
function waitForStable(node, { stableThreshold = 100, timeout = 2500 } = {}) {
  return new Promise((resolve) => {
    let lastRect = node.getBoundingClientRect();
    let stableSince = null;
    const start = performance.now();

    function frame() {
      const now = performance.now();
      const rect = node.getBoundingClientRect();
      const heightDiff = Math.abs(rect.height - lastRect.height);
      const topDiff = Math.abs(rect.top - lastRect.top);

      // consider stable if both height and top change very little
      if (heightDiff < 0.6 && topDiff < 0.6) {
        if (stableSince === null) stableSince = now;
        else if (now - stableSince >= stableThreshold) { resolve(); return; }
      } else {
        lastRect = rect;
        stableSince = null;
      }

      if (now - start >= timeout) { resolve(); return; } // fallback
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  });
}

// helper: scroll element into view below header (handles window or scrollable container)
function scrollElementIntoViewBelowHeader(el, action, pad = 8) {
  const head = document.querySelector('.subHeader');
  const headerH = head?.offsetHeight || 0;
  const container = getScrollParent(el);

  const eRect = el.getBoundingClientRect();

   // delay scroll by 300ms
  setTimeout(() => {
    if (container === window) {
      const top = eRect.top + window.pageYOffset - headerH - (action ? 55 : 55) - pad;
      window.scrollTo({ top, left: 0, behavior: 'smooth' });
    } else {
      const cRect = container.getBoundingClientRect();
      const top = eRect.top - cRect.top + container.scrollTop - headerH - (action ? 30 : 0) - pad;
      container.scrollTo({ top, left: 0, behavior: 'smooth' });
    }
  }, 300);
}
  const handleExpandNext = (action, fromCart, data, details) => {
    const { nextNo, isQty, length } = getNextData(fromCart, data, details);
    if (nextNo > -1) {
      setExpanded(`${nextNo}`)
      if (fromCart) setErrorOpenTab(`${nextNo}`)
        else setErrorOpenTab("")
    } else if (nextNo === -1 && fromCart) {
      setErrorOpenTab("0")
    }

    // setTimeout(() => {
    //   const head = document.querySelector(`.subHeader`);
    //   if (nextNo >= -1) {
    //     let ele = document.querySelector(`.accordion${nextNo}`);
    //     // if (!ele) ele = document.querySelector(`.accordion0`);
    //       if (!ele) {
    //     const fallback = document.querySelector(`.scrollAfterFinish`);
    //     if (fallback) {
    //       const rect = fallback.getBoundingClientRect();
    //       const scrollPosition = window.scrollY + rect.top - 100; // move slightly up
    //       window.scrollTo({
    //         top: scrollPosition,
    //         left: 0,
    //         behavior: "smooth",
    //       });
    //     }
    //     return;
    //      }
    //     const top = ele?.offsetTop - (action ? -30 : -(head?.clientHeight));
    //     window.scrollTo({ top, left: 0, behavior: "smooth" });
    //   }}, action ? 800 : 600)

  const allValuesFilled =  data && Object.values(data || {}).every(
    v => Array.isArray(v) ? v.length > 0 : true
  );

  const token = Symbol("expandNextToken");
  window.__lastExpandNextToken = token;

  requestAnimationFrame(() => {
    const selector = `.accordion${nextNo}`;
    let tries = 0;

    function findAndWait() {
      const root = document.querySelector(selector);
    let target = null;
    if (isSample && !samplenextNav) {
      target = document.querySelector(`.accordion${lastVariantKey}`);
    } else if (root) {
      target = root;
    }

    if (target) {
      const animated =
        target.querySelector(
          ".MuiCollapse-wrapperInner, .MuiCollapse-wrapper, .MuiAccordionDetails-root"
        ) || target;

      waitForStable(animated, { stableThreshold: 80, timeout: 2200 }).then(() => {
        if (window.__lastExpandNextToken !== token) return;          
          setTimeout(() => {
            scrollElementIntoViewBelowHeader(target, action, 8);
          }, 300);
        });
      return;
    }
      if (tries++ < 8) return requestAnimationFrame(findAndWait);
      // --- fallback scroll only if all values are filled ---
      if (allValuesFilled) {
        const fallback = document.querySelector(".scrollAfterFinish");
        if (fallback) {
          waitForStable(fallback, { stableThreshold: 80, timeout: 2200 }).then(() => {
            if (window.__lastExpandNextToken !== token) return;
            setTimeout(() => {
              fallback.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 300);
          });
        }
      }
       if (nextNo === -1) {
    const selector = `.accordion${nextNo}`;
  const target = document.querySelector(selector);

  if (target) {
    // wait for collapse animation to settle
    waitForStable(target, { stableThreshold: 80, timeout: 2200 }).then(() => {
      if (window.__lastExpandNextToken !== token) return;
      setTimeout(() => {
        scrollElementIntoViewBelowHeader(target, action, 8);
      }, 300); // <-- 300ms after collapse
    });
  } else {
    // fallback: still force scroll after 300ms if target missing
    setTimeout(() => {
      const head = document.querySelector(`.subHeader`);
      const ele = document.querySelector(selector);
      if (ele) {
        const top = ele.offsetTop - (action ? -30 : -(head?.clientHeight));
        window.scrollTo({ top, left: 0, behavior: "smooth" });
      }
    }, 300);
  }
  return; // don't continue further if collapse case handled
      }
    }

    findAndWait();
  });
  };

  const isAdditionalOption = () => (imagesDropbox.length || selectedDetailsFinal.setup_costs || (allData["cpker"]?.thisType === "cpker")) ? true : false;

  const getDeliveryDate = (option, quantity, updateSimpleProductId) => {
    // Clear previous timer
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);

     // Abort previous API call if any
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }


    // Set new debounce timer
    debounceTimerRef.current = setTimeout(async () => { 

    const addiData = [
      ...(option?.customize?.length ? option?.customize : []),
      ...(option?.additional?.length ? option?.additional : [])
    ];
    let addiObj = {};
    if (addiData.length) {
      addiData.forEach((data) => {
        addiObj = { ...addiObj, ...data };
      });
    }
    const updatedSimpleProductIds = option?.products?.length
      ? option.products[option.products.length - 1]
      : null;
    const updatedSimpleProductId = option?.finalProducts ? option?.finalProducts[0] : updatedSimpleProductIds;
    const tempOption = {
      productId: data?.settings?.product_id,
      sampleProductIds: isSample ? (option?.finalProducts?.length ? option.finalProducts.join(",") : "") : "",
      simpleProductId: updateSimpleProductId ? updateSimpleProductId : simpleProductIdUpdated ? simpleProductIdUpdated : updatedSimpleProductId,
      customOptions: addiObj,
      itemId: 0,
      qty: quantity ? quantity : 1,
      selOptHasVariants: isAdditionalOption ? 1 : 0,
      isSample: isSample ? 1 : 0,
      storeId: storeId,
    };
    const optionKey = JSON.stringify(tempOption);
     // avoid duplicate API calls
      if (lastOptionKeyRef.current === optionKey) {
            return;
          }
        lastOptionKeyRef.current = optionKey;
    // Create new AbortController for this request
        const controller = new AbortController();
        abortControllerRef.current = controller;

        try {
          const resp = await axios.post(`${baseURL}/getdeliverydate`, tempOption,{ signal: controller.signal,});
          // Only set state if this is the latest request
            setDeliveryData({ ...resp.data[0] });
          
        } catch (err) {
          lastOptionKeyRef.current = "";
         if (err.name === "CanceledError") {
        // Request was canceled, do nothing
        } else {
        lastOptionKeyRef.current = "";
      }
      }
       }, 300); // 300ms debounce
  };

  useEffect(() => {
    if (data?.settings?.product_id && deliveryData === null) {
      getDeliveryDate({}, qty)
    }
  }, [])

  const qtymatch = (qty, tier_prices) => {
    let price = 0;
    if (tier_prices?.length) {
      tier_prices.sort((a, b) => a.qty - b.qty);

      tier_prices.forEach(t => {
        if (t.qty <= qty) {
          price = t.price;
        }
      });
    }
    return price > 0 ? parseFloat(price) : ""

  };
  const getApiCartOptions = () => {
    let option = null;
    if (data?.settings?.product_id && selectedDetails && Object.keys(selectedDetails).length) {
      option = { data: [], customize: [], additional: [], products: [],selectedOptionProductList:[], isUpload: false, isSample: false };
      Object.keys(selectedDetails).map((key, i) => {
        const d = selectedDetails[key];
        if (d && d?.thisType === "variant") {
          if (d?.products) option["products"] = [...option["products"], ...d.products]
          if (d?.returnData) option["data"] = [...option["data"], ...d.returnData]
          if (d?.returnData) option["finalData"] = [...d.returnData]
          if (d?.returnData) option["finalProducts"] = d?.selectedOptionProductList ? [...d?.selectedOptionProductList] : d?.products?.length ? [...d?.products] : []
        } else if (d && d?.thisType === "customize") {
          if (d?.returnData) option["customize"] = [...option["customize"], ...d.returnData]
        } else if (d && d?.thisType === "additional") {
          if (d?.returnData) option["additional"] = [...option["additional"], ...d.returnData]
        } else if (d && d?.thisType === "upload") {
          if (d?.returnData) option["isUpload"] = Boolean(d?.isUpload)
        } else if (d && d?.thisType === "isSample") {
          option["isSample"] = Boolean(d?.isSample)
        }
        return null;
      });
      // for multiple api call of get deliverydays commented
      // if (option["products"].length) getDeliveryDate(option, "getApiCartOptions")
    }
    return option;
  }

  const isValidBase64 = (str) => {

    if (/^\d+$/.test(str)) {
      return true;
    }

    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;

    if (!str || typeof str !== 'string' || !base64Regex.test(str)) {
      return false;
    }

    if (str === "0") {
      return true;
    }

    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };


  const decodeBase64 = (encodedString) => {
    try {
      return atob(encodedString);
    } catch (e) {
      return encodedString;
    }
  };
  //   const getKeyVal = (option, sizeOption) => {
  //     if (!option || !option.length) return [];
  //     let result = option.map((itemOption) => {
  //       return Object.keys(itemOption).map((key) => {
  //         return { option_id: key, option_value: itemOption[key] };
  //       });
  //     }).flat();
  //     if (data?.isTextileProduct === 1) {
  //       if (sizeOption && !isSample) {
  //         result.push({ option_id: sizeOption?.id, option_value: Object.values(sizeOption?.options)[0].id });
  //       }
  //     }
  //     // Remove duplicate option_id entries if not a sample
  //     if (!isSample) {
  //       let uniqueResult = result.reduce((acc, current) => {
  //         const x = acc.find(item => item.option_id === current.option_id);
  //         if (!x) {
  //           return acc.concat([current]);
  //         } else {
  //           return acc;
  //         }
  //       }, []);
  //       return uniqueResult;
  //     } else {
  //       return result;
  //     }
  // };
  const getKeyVal = (option, sizeOption) => {
    if (!option || !option.length) return [];
    let result = option.map((itemOption) => {

      return Object.keys(itemOption).map((key) => {
        let optionVal = itemOption[key]?.includes("YYYY") ? itemOption[key]?.replace("YYYY", "") : itemOption[key];
        if (itemOption[key]?.includes("YYYY")) {
          return { option_id: key, option_value: atob(optionVal) };
        }

        if (isValidBase64(optionVal)) {

          return { option_id: key, option_value: (itemOption[key]) };
        } else {
          const decodedValue = decodeBase64(optionVal);
          return { option_id: key, option_value: decodedValue };
        }
      });
    }).flat();

    if (data?.isTextileProduct === 1) {
      if (sizeOption && !isSample) {
        result.push({ option_id: sizeOption?.id, option_value: Object.values(sizeOption?.options)[0].id });
      }
    }
    // Remove duplicate option_id entries if not a sample
    if (!isSample) {
      let uniqueResult = result.reduce((acc, current) => {
        const x = acc.find(item => item.option_id === current.option_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      return uniqueResult;
    } else {
      return result;
    }
  };
  const getColorData = (selColorData) => {
    let colorPricker = {
      pms_distribution: "",
      pms_hex_value: "",
      pms_min_value: "",
      pms_value: "",
      pms_key: "",
      product_ids: "",
      is_multiselect: 0,
      design_explanation: "",
      pms_colors_selected: 1,
    };
    Object.keys(selColorData).forEach((colorId) => {
      colorPricker = {
        ...colorPricker,
        is_multiselect: data?.settings?.xml ? 0 : 1,
        pms_distribution: `${colorPricker.pms_distribution}:`,
        pms_hex_value: `${colorPricker.pms_hex_value}:`,
        pms_min_value: `${colorPricker.pms_min_value}:`,
        pms_value: `${colorPricker.pms_value}:`,
        pms_key: `${colorPricker.pms_key},`,
        product_ids: `${colorPricker.product_ids},`,
      };
      const temp = selColorData[colorId];
      if (temp.length) {
        let pms_key = "",
          product_ids = "";
        temp.forEach((tempColor) => {
          colorPricker = {
            ...colorPricker,
            pms_distribution: `${colorPricker?.pms_distribution ? `${colorPricker?.pms_distribution},` : ""}${tempColor?.qty}`.replace(/^:|^,/g, '').replace(/:,/g, ':').replace(/^,/, ''),
            pms_hex_value: `${colorPricker?.pms_hex_value ? `${colorPricker?.pms_hex_value},` : ""}${tempColor?.hex}`.replace(/^:|^,/g, '').replace(/:,/g, ':').replace(/^,/, ''),
            pms_min_value: `${colorPricker?.pms_min_value ? `${colorPricker?.pms_min_value},` : ""}${tempColor?.minQty}`.replace(/^:|^,/g, '').replace(/:,/g, ':').replace(/^,/, ''),
            pms_value: `${colorPricker?.pms_value ? `${colorPricker?.pms_value},` : ""}${tempColor?.name}`.replace(/^:|^,/g, '').replace(/:,/g, ':').replace(/^,/, ''),
          };

          pms_key = colorId;
          product_ids = tempColor?.product_ids;
        });
        colorPricker = {
          ...colorPricker,
          pms_key: `${colorPricker?.pms_key},${pms_key}`.replace(",,", ",").replace(/^,/, ""),
          product_ids: `${colorPricker?.product_ids},${product_ids}`.replace(",,", ",").replace(/^,/, ""),
        };
      }
    });
    return colorPricker;
  };
  const addToCart__gtm = (item) => {
    const addtocartGtmData = {
      event: 'addToCart',
      eventLabel: data?.settings?.product_name,
      ecommerce: {
        add: {
          products: [
            {
              name: data?.settings?.product_name,
              id: additionalOption.is ? additionalOption.sku : data?.settings?.product_sku || "",
              is_sample: isSample,
            }
          ]
        }
      },
    };

    TagManager.dataLayer({ dataLayer: addtocartGtmData });
  };
  function generateTextileAttributeId(product, attribute) {
    const attributeId = product[attribute] ? product[attribute].id : null;
    return attributeId;
  }
  const textileAttributes = (variantQtydata) => {
    const generateAttributeId = generateTextileAttributeId(data?.options, Object.keys(data.options).slice(-1)[0]);
    const filteredData = variantQtydata && variantQtydata?.length ? variantQtydata?.filter(item => item.qty > 0) : [];
    const is_textile_product = 1;
    const textile_product_ids = filteredData.map(item => item.productId).join(',');
    const textile_name = filteredData.map(item => item.sizeLabel).join(',');
    const textile_attribute_id = filteredData.map(item => generateAttributeId).join(',');
    const textile_quantity = filteredData.map(item => item.qty).join(',');
    const textile_attribute_value = filteredData.map(item => item.id).join(',');
    const result = {
      "is_textile_product": is_textile_product,
      "textile_product_ids": textile_product_ids,
      "textile_name": textile_name,
      "textile_attribute_id": textile_attribute_id,
      "textile_quantity": textile_quantity,
      "textile_attribute_value": textile_attribute_value
    };

    return result;
  }
  const guestAddToCart = (from) => {
    addToCart__gtm();
    setErrorCart("");
    const { nextNo, length } = getNextData(true, selectedDataNow);
    const option = getApiCartOptions();
    const textileProduct = !isSample && data?.isTextileProduct === 1 && Object.values(Object.entries(data?.options)?.at(-1)?.[1]?.options)?.length > 1  ? textileAttributes(variantQtydata) : null;
    const colorPricker = (selectedColorData && Object.keys(selectedColorData).length) ? getColorData(selectedColorData) : null;
    // For sample attribute id and values separation
    let keys = [];
    let values = [];
    if (option?.finalData?.length) {
      for (const obj of option?.finalData) {
        const [key, value] = Object.entries(obj)[0];
        keys.push(key);
        values.push(value);
      }
    }
    // Join keys and values into strings
    const keysString = keys.join(', ');
    const valuesString = values.join(', ');
    
    const oneTimePrice = isCustomQty
      ? euroCurrency(
        (qtyData?.price * (isSample ? sampleQty : qtyTemp)) *
        (isCpkerLength ? isCpkerLength : 1) +
        selectedDetailsFinal.change_costs +
        (selectedDetailsFinal?.amount_per_piece === "1"
          ? qtyTemp * selectedDetailsFinal?.product_cost_value
          : selectedDetailsFinal?.product_cost_value)
      ).trim()
      : euroCurrency(
        (qtyData?.price * (isSample ? sampleQty : qty)) *
        (isCpkerLength ? isCpkerLength : 1) +
        selectedDetailsFinal.change_costs +
        (selectedDetailsFinal?.amount_per_piece === "1"
          ? qty * selectedDetailsFinal?.product_cost_value
          : selectedDetailsFinal?.product_cost_value)
      ).trim();   

        const options =sampleCustomizeItem;
        const selectedOptions = [...getKeyVal(option?.customize), ...getKeyVal(option?.additional)];

        
        // Step 1: Extract selected option IDs
        const selectedIds = new Set(selectedOptions.map(opt => opt.option_id));

        // Step 2: Filter required options not in selectedOptions & remove is_require
        const missingRequired = options
          .filter(opt => opt.is_require === "1" && !selectedIds.has(opt.option_id))
          .map(({ option_id, option_value }) => ({ option_id, option_value }));

        // Step 3: Combine result
        const result = [...selectedOptions, ...missingRequired];
    const addCartItems = (key, id) => {
      const guestCartOptions = {
        isLoader: true,
        loaderAction: (bool) => {
          if (bool) {
            if (from) {
              setIsProcessing(bool)
            } else {
              setIsProcessing1(bool)
            }
          }
        },
        setGetResponseData: (resData) => {

          if (resData?.status === 200) {
            let tempError = ""
            if (resData?.data?.[0]?.code === 400) {
              tempError = resData?.data?.[0]?.message;
              if (from) {
                setIsProcessing(false)
              } else {
                setIsProcessing1(false)
              }
            }
            else if (from) {
              if (width >= 768 && !isSample) {
                dispatch(ACTION__MINICART__ITEMS("cart"))
              }
              else {
                navigate("/winkelwagen")
              }

              getCartItems(dispatch, setIsProcessing, id, "", () => dispatch(ACTION_OPENCART(!isSample)), defaultURL, storeId, token, navigate, isSessionExpired, width);
            } else {
              if (width >= 768) {
                dispatch(ACTION__MINICART__ITEMS("quote"))
              }
              else {
                navigate("/offerteaanvraag")
              }

              getCartItems(dispatch, setIsProcessing1, id, "", () => dispatch(ACTION_OPENCART(true)), defaultURL, storeId, token, navigate, isSessionExpired, width);
            }
            setErrorCart(tempError);
          } else if (resData?.status === false) {
          }
        },
        getStatus: (res) => {
          if (res?.status == 400) {
            const Name = translateData?.translations?.[`${res?.message}`.toLowerCase()] ? translateData?.translations[`${res?.message}`.toLowerCase()] : res?.message
            setErrorCart(Name)
            setIsProcessing(false)
            setIsProcessing1(false)

          }
          SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
        },
        axiosData: {
          url: `${defaultURL}/guest-carts/${key}/items`,
          paramsData: {
            cartItem: {
              sku: data?.settings?.product_sku || "",
              qty: isSample && getKeyVal(option?.data).length ? 1 : data?.isTextileProduct === 1 && Object.values(Object.entries(data?.options)?.at(-1)?.[1]?.options)?.length > 1 ? totalValueQty : qty ? qty : 1,
              quoteId: guestQuoteId,
              product_option: {
                extension_attributes: {
                  configurable_item_options: isSample ? getKeyVal(option?.data) : data?.isTextileProduct === 1 ? getKeyVal(option?.data, Object.entries(data?.options).slice(-1)[0][1]) : getKeyVal(option?.data),
                  custom_options: isSample || selectedData?.["position"]?.includes("geen opdruk") ? [...sampleCustomizeItem?.map(({ option_id, option_value }) => ({ option_id, option_value }))] : selectedData?.["position"] ? result : [...getKeyVal(option?.customize), ...getKeyVal(option?.additional)],
                }
              },
              extension_attributes: {
                sample_product_ids:isSample ? option?.finalProducts?.length ? option.finalProducts.join(",") : null : null,
                sample_attribute_id: isSample ? keysString : null,
                sample_attribute_value: isSample ? valuesString : null,
                manual_price: manualsizestr && selectedDetailsFinal?.tier_prices
                  ? selectedDetailsFinal.tier_prices
                    .map(item => `qty:${item.qty},price:${item.price}`)
                    .join(';') + ';'
                  : null,
                item_tier_qty_price:tierPriceQty,
                manual_size: manualsizestr?.replace("XXXXX", `${qtymatch(qty, selectedDetailsFinal.tier_prices)}`),
                is_additional_option: isAdditionalOption ? 1 : 0,
                ...textileProduct,
                is_sample: isSample,
                one_time: oneTimeValue === "1" ? oneTimePrice : "0",
                qty_increments: selectedDetailsFinal?.qty_increments,
                input_size: InputManualSize,
                dropbox_file: selectedDetails?.upload ? (selectedDetails?.upload?.hide ? "0" : selectedDetails?.upload?.isUpload && dropboxFiles ? dropboxFiles : "1") : "0",
                setup_costs: selectedDetailsFinal?.setup_costs ? selectedDetailsFinal?.setup_costs : 0,
                product_cost: selectedDetailsFinal?.product_cost_value,
                amount_per_piece: selectedDetailsFinal?.amount_per_piece,
                product_cost_label: selectedDetailsFinal?.product_cost_name,
                product_cost_id: selectedDetailsFinal?.product_cost_id,
                pdp_url: window.location.href,
                design_explanation: selectedDetails?.upload ? selectedDetails?.upload?.hide? "": selectedDetails?.upload?.isUpload && dropboxFiles ? textAreaData: textAreaData: "",
                config_product_id: data?.settings?.product_id,
                ...colorPricker?.pms_key && colorPricker,
                ...isSample && getKeyVal(option?.finalData).length && { sample_products: getKeyVal(option?.finalData).map((sample) => sample?.option_value) },
              }
            }
          }
        }
      };
      APIQueryPost(guestCartOptions);
    }
    const createQuoteId = (key) => {
      const guestQuoteDetailsOptions = {
        isLoader: true,
        loaderAction: (bool) => from ? setIsProcessing(bool) : setIsProcessing1(bool),
        setGetResponseData: (resData) => {
          if (resData?.status === 200) {
            dispatch(ACTION_GUESTQUOTE__DETAILS(resData?.data));
            dispatch(ACTION_GUESTKEY(key));
            addCartItems(key, resData?.data?.id);
          }
        },
        getStatus: (res) => {
          if (res?.status !== 200) {

          }
        },
        axiosData: {
          url: `${defaultURL}/guest-carts/${key}`
        }
      }
      APIQueryGet(guestQuoteDetailsOptions);
    }
    if ((nextNo !== -1) && (nextNo < (length))) {
      handleExpandNext("fast", 1)
    }
    else if ((option && option?.["products"]?.length) || option?.isSample) {
      const guestKeyOptions = {
        isLoader: true,
        loaderAction: (bool) => from ? setIsProcessing(bool) : setIsProcessing1(bool),
        setGetResponseData: (resData) => {
          if (resData?.status === 200) {
            createQuoteId(resData?.data);
          }
        },
        getStatus: (res) => {
          if (res?.status !== 200) { }
        },
        axiosData: {
          url: `${defaultURL}/guest-carts`,
        }
      }
      if (guestQuoteId) addCartItems(guestKey, guestQuoteId);
      else APIQueryPost(guestKeyOptions);
    } else {
      handleExpandNext("fast", 1)
    }
  };

  const customerAddToCart = (from) => {
    addToCart__gtm();
    setErrorCart("");
    const { nextNo, length } = getNextData(true, selectedDataNow);
    const option = getApiCartOptions();
    const textileProduct = !isSample && data?.isTextileProduct === 1 && Object.values(Object.entries(data?.options)?.at(-1)?.[1]?.options)?.length > 1 ? textileAttributes(variantQtydata) : null;
    const colorPricker = (selectedColorData && Object.keys(selectedColorData).length) ? getColorData(selectedColorData) : null;

    // For sample attribute id and values separation
    let keys = [];
    let values = [];
    if (option?.finalData?.length) {
      for (const obj of option?.finalData) {
        const [key, value] = Object.entries(obj)[0];
        keys.push(key);
        values.push(value);
      }
    }
    // Join keys and values into strings
    const keysString = keys.join(', ');
    const valuesString = values.join(', ');
    const oneTimePrice = isCustomQty
      ? euroCurrency(
        (qtyData?.price * (isSample ? sampleQty : qtyTemp)) *
        (isCpkerLength ? isCpkerLength : 1) +
        selectedDetailsFinal.change_costs +
        (selectedDetailsFinal?.amount_per_piece === "1"
          ? qtyTemp * selectedDetailsFinal?.product_cost_value
          : selectedDetailsFinal?.product_cost_value)
      ).trim()
      : euroCurrency(
        (qtyData?.price * (isSample ? sampleQty : qty)) *
        (isCpkerLength ? isCpkerLength : 1) +
        selectedDetailsFinal.change_costs +
        (selectedDetailsFinal?.amount_per_piece === "1"
          ? qty * selectedDetailsFinal?.product_cost_value
          : selectedDetailsFinal?.product_cost_value)
      ).trim();      

       const options =sampleCustomizeItem;
       const selectedOptions = [...getKeyVal(option?.customize), ...getKeyVal(option?.additional)];

       
       // Step 1: Extract selected option IDs
       const selectedIds = new Set(selectedOptions.map(opt => opt.option_id));

       // Step 2: Filter required options not in selectedOptions & remove is_require
       const missingRequired = options
         .filter(opt => opt.is_require === "1" && !selectedIds.has(opt.option_id))
         .map(({ option_id, option_value }) => ({ option_id, option_value }));

       // Step 3: Combine result
       const result = [...selectedOptions, ...missingRequired];
       
    const cartOptions = {
      isLoader: true,
      loaderAction: (bool) => {
        if (bool) {
          if (from) {
            setIsProcessing(bool)
          } else {
            setIsProcessing1(bool)
          }
        }
      },
      setGetResponseData: (resData) => {

        if (resData?.status === 200) {
          let tempError = ""
          if (resData?.data?.[0]?.code === 400) {
            tempError = resData?.data?.[0]?.message;
            if (from) {
              setIsProcessing(false)
            } else {
              setIsProcessing1(false)
            }
          }
          else if (from) {
            if (width >= 768 && !isSample) {
              dispatch(ACTION__MINICART__ITEMS("cart"))
            }
            else {
              navigate("/winkelwagen")
            }
            getCartItems(dispatch, setIsProcessing, customerQuoteId, customerId, () => dispatch(ACTION_OPENCART(!isSample)), defaultURL, storeId, token, navigate, isSessionExpired, width);

          } else {
            if (width >= 768) {
              dispatch(ACTION__MINICART__ITEMS("quote"))

            }
            else {
              navigate("/offerteaanvraag")
            }
            getCartItems(dispatch, setIsProcessing1, customerQuoteId, customerId, () => dispatch(ACTION_OPENCART(!isSample)), defaultURL, storeId, token, navigate, isSessionExpired, width);

          }
          setErrorCart(tempError);
        } else if (resData?.status === false) {
        }
      },
      getStatus: (res) => {
        if (res?.status == 400) {
          const Name = translateData?.translations?.[`${res?.message}`.toLowerCase()] ? translateData?.translations[`${res?.message}`.toLowerCase()] : res?.message
          setErrorCart(Name)
          setIsProcessing(false)
          setIsProcessing1(false)
        }
        SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
      },
      axiosData: {
        url: `${defaultURL}/carts/mine/items`,
        headers: { Authorization: `Bearer ${token}` },
        paramsData: {
          cartItem: {
            sku: data?.settings?.product_sku || "",
            qty: isSample && getKeyVal(option?.data).length ? 1 : data?.isTextileProduct === 1 && Object.values(Object.entries(data?.options)?.at(-1)?.[1]?.options)?.length > 1 ? totalValueQty : qty ? qty : 1,
            quoteId: customerQuoteId,
            product_option: {
              extension_attributes: {
                configurable_item_options: isSample ? getKeyVal(option?.data) : data?.isTextileProduct === 1 ? getKeyVal(option?.data, Object.entries(data?.options).slice(-1)[0][1]) : getKeyVal(option?.data),
                custom_options: isSample || selectedData?.["position"]?.includes("geen opdruk") ? [...sampleCustomizeItem?.map(({ option_id, option_value }) => ({ option_id, option_value }))] : selectedData?.["position"] ? result : [...getKeyVal(option?.customize), ...getKeyVal(option?.additional)],
              }
            },
            extension_attributes: {
              sample_product_ids:isSample ? option?.finalProducts?.length ? option.finalProducts.join(",") : null : null,
              sample_attribute_id: isSample ? keysString : null,
              sample_attribute_value: isSample ? valuesString : null,
              item_tier_qty_price:tierPriceQty,
              manual_size: manualsizestr?.replace("XXXXX", `${qtymatch(qty, selectedDetailsFinal.tier_prices)}`),
              manual_price: manualsizestr && selectedDetailsFinal?.tier_prices
                ? selectedDetailsFinal.tier_prices
                  .map(item => `qty:${item.qty},price:${item.price}`)
                  .join(';') + ';'
                : null,
              is_additional_option: isAdditionalOption ? 1 : 0,
              is_sample: isSample,
              one_time: oneTimeValue === "1" ? oneTimePrice : "0",
              input_size: InputManualSize,
              ...textileProduct,
              qty_increments: selectedDetailsFinal?.qty_increments,
              dropbox_file: selectedDetails?.upload ? (selectedDetails?.upload?.hide ? "0" : selectedDetails?.upload?.isUpload && dropboxFiles ? dropboxFiles : "1") : "0",
              setup_costs: selectedDetailsFinal?.setup_costs ? selectedDetailsFinal?.setup_costs : 0,
              product_cost: selectedDetailsFinal?.product_cost_value,
              amount_per_piece: selectedDetailsFinal?.amount_per_piece,
              product_cost_label: selectedDetailsFinal?.product_cost_name,
              product_cost_id: selectedDetailsFinal?.product_cost_id,
              pdp_url: window.location.href,
              design_explanation: selectedDetails?.upload ? selectedDetails?.upload?.hide? "": selectedDetails?.upload?.isUpload && dropboxFiles ? textAreaData: textAreaData: "",
              config_product_id: data?.settings?.product_id,
              ...colorPricker?.pms_key && colorPricker,
              ...isSample && getKeyVal(option?.finalData).length && { sample_products: getKeyVal(option?.finalData).map((sample) => sample?.option_value) },
            }
          }
        }
      }
    };
    if ((nextNo !== -1) && (nextNo < length)) {
      handleExpandNext("fast", 1)
    }
    else if ((option && option?.["products"]?.length) || option?.isSample) {
      APIQueryPost(cartOptions);
    } else {
      handleExpandNext("fast", 1)
    }
  };
  const kjd = (main, sec) => {
    const newArr = [...main, ...sec].map((a) => a.qty)
    const newArr1 = newArr.filter((item, pos) => newArr.lastIndexOf(item) === pos);
    const newArr2 = newArr1.sort(function (a, b) { return a - b })
    return sec?.length ? newArr2.map((d, i) => {
      let matchIndex = -1, foundKey = -1;
      sec.forEach((e, j) => {
        foundKey = (d === e.qty) ? j : foundKey
        matchIndex = (d >= e.qty) ? j : matchIndex
      });
      return (foundKey > -1) ? sec[foundKey] : (matchIndex > 0) ? { ...sec[matchIndex], qty: d } : { ...sec[0], qty: d };
    }) : [];
  }
  const mergeQty = (main, sec, isCpker, log) => {
    let arr = [], sec2 = [], main2 = [];
    if (main?.length) {
      if (isCpker) main2 = kjd(sec, main)
      else main2 = main
      if (isCpker) sec2 = kjd(main2, sec)
      else sec2 = sec
      if (sec?.length) arr = addArrayObj(main2, sec2)
      else arr = main;
    } else if (sec?.length) arr = sec;
    return arr;
  }
  const getAlignAllData = (urlGenData) => {
    const variantObj = {}, tempSelectedObj = {}, tempSelectedDetails = {};
    const firstObjName = data?.settings?.custom_made_option_title ? data.settings.custom_made_option_title : "";
    const variantTempObj = { ...data?.options }, isColorPicker = data?.settings?.is_color_picker && translateData?.color_picker?.totalRecords > 0, additionalTempObj = { ...data?.additionalCustomizables }, isColorPickerTierPrices = data?.settings?.xml;
    let isSizeQty = false, isSampleProduct = false, prevKey = "", isAnyDefault = [];
     const hasAnyLabelValue = (data) =>
      Object.values(data).some(groupValue =>
        Object.values(groupValue).some(items =>
          Object.values(items).some(itm =>
            itm.some(it =>
              it.grouplabel?.toString().trim().length > 0 ||
              it.subgrouplabel?.toString().trim().length > 0
            )
          )
        )
      );
    Object.keys(variantTempObj).map((key, i) => {
      const tempVariantItem = variantTempObj[key];
      if (tempVariantItem) {
        const tempOption = [];
        let isManualSize = false, defaultSelected = [];
        const variantOptions = tempVariantItem?.["options"] && Object.keys(tempVariantItem["options"]);
        if (tempVariantItem && variantOptions?.length) {
          variantOptions.map((key1) => {
            const tempOptionItem = tempVariantItem["options"][key1];
            const tempOptionProducts = [];
            tempOptionItem?.["products"] &&
              Object.keys(tempOptionItem["products"]).length &&
              Object.keys(tempOptionItem["products"]).map((key2) => {
                if (!isManualSize) isManualSize = !!tempOptionItem["products"][key2]?.manual_size_from;
                tempOptionItem["products"][key2] &&
                  (Object.keys(tempOptionItem["products"][key2]).length ?
                    tempOptionProducts.push({ ...tempOptionItem["products"][key2], pms_key: "key1" }) :
                    tempOptionProducts.push(tempOptionItem["products"][key2]))
              });
            tempOptionItem["id"] = tempOptionItem["id"] === 0 ? "0" : tempOptionItem["id"];
            if (variantOptions.length === 1 ) defaultSelected.push(tempOptionItem.id)
            tempOption.push({ ...tempOptionItem, ...tempOptionProducts.length && { products: tempOptionProducts } })
            return null;
          });
        }
        let lastKey = null;
            const flatOptions = Object.values(variantTempObj)?.flatMap(item => item?.options || []);

            const lastOption = flatOptions.at(-1);

            if (lastOption && typeof lastOption === 'object' && Object.values(lastOption)?.length > 1) {
              const keys = Object.keys(variantTempObj);
              lastKey = keys[keys.length - 1];
         }
        if (!isSizeQty) {
          isSizeQty = data?.isTextileProduct === 1 && key === lastKey;
        }
        variantObj[key] = {
          ...variantTempObj[key],
          thisType: "variant",
          ...variantTempObj[key]?.["id"] && { id: variantTempObj[key]?.["id"] },
          ...tempOption.length && { options: tempOption },
          label: firstObjName && !prevKey ? firstObjName : `Kies een ${(variantTempObj[key]?.["label"] ? variantTempObj[key]["label"] : "").toLowerCase()}`,
          // label: `Kies een ${(variantTempObj[key]?.["label"] ? variantTempObj[key]["label"] : "").toLowerCase()}`,
          mutiSelect: isColorPicker && !data?.settings?.xml,
          hideStock: isColorPicker,
          sizeQty: data?.isTextileProduct === 1 && key === lastKey,
          variantPosition: i,
          isManualSize,
          isAdditionalOption: !!(additionalTempObj && Object.keys(additionalTempObj).length),
          multiOption: Object.keys(variantTempObj).length > 1,
          variantLength: Object.keys(variantTempObj).length,
          variantDatas: Object.keys(variantTempObj),
        }

        isAnyDefault.push(defaultSelected.length ? "true" : "false");
        // tempSelectedObj[key.replace('&', '')] = defaultSelected;
        // tempSelectedDetails[key.replace('&', '')] = { thisType: "variant", prevKey, labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [] };
        tempSelectedObj[key] = defaultSelected;
        tempSelectedDetails[key] = { thisType: "variant", prevKey, labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [] ,imprint_required:data?.settings?.imprint_required };
        prevKey = key;
      }
    });
    if (data?.settings?.is_color_picker && translateData?.color_picker?.totalRecords) {
      const label = data?.settings?.color_picker_title, k = "cpker";
      variantObj[k] = {
        thisType: k,
        label: label ? label : `Kies de gewenste kleur`,
      }
      tempSelectedObj[k] = [];
      tempSelectedDetails[k] = isColorPickerTierPrices ? { thisType: k, labels: [], products: [], returnData: [] } : { thisType: k, labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [],imprint_required:data?.settings?.imprint_required };
    }
    const customizeTempObj = { ...data?.customizables }, sampleCustomizeTemp = [];
    Object.keys(customizeTempObj).map((key) => {
      const tempCustomizeItem = customizeTempObj[key]
      if (tempCustomizeItem && Object.keys(tempCustomizeItem).length) {
        if (Object.keys(tempCustomizeItem).length) {
          const key1 = Object.keys(tempCustomizeItem)[0];
          if (Object.keys(tempCustomizeItem).length > 1 || (key1 && tempCustomizeItem?.[key1]?.length > 1) || (tempCustomizeItem?.[key1]?.[0]?.grouplabel && tempCustomizeItem?.[key1]?.[0]?.groupinfo) || tempCustomizeItem?.[key1]?.[0]?.subgrouplabel) {
            const additionalCustomize100 = customizeTempObj;
            Object.keys(additionalCustomize100).map((key1) => {
              const additionalCustomize200 = additionalCustomize100[key1];
              if (additionalCustomize200 && Object.keys(additionalCustomize200).length) {
                Object.keys(additionalCustomize200)?.forEach((key200) => {
                  additionalCustomize200[key200]?.length && additionalCustomize200[key200].forEach((item200, index200) => {
                    additionalCustomize200[key200][index200]["optionImage"] = additionalCustomize200[key200][index200]?.options?.[0]?.image;
                  
                    const options = item200?.options || [];
                    const firstOption = options?.[0];
                    const freeOption = options?.find(opt => opt?.price === 0);
                    const exists = sampleCustomizeTemp.some(entry => entry.option_id === item200?.id);
                      if (!exists && item200?.is_require == 1) {
                        sampleCustomizeTemp.push({
                          option_id: item200?.id,
                          option_value: ["field", "area"].includes(item200?.type) ? "" : (freeOption?.id || firstOption?.id),
                          is_require: item200?.is_require
                        });
                      }
                  })
                })
                if (!variantObj["position"] && Object.keys(tempCustomizeItem).length > 1 && !variantObj[key1]) {
                  const k = "position";
                  //is_required option from the custom options
                   const requiredKeys = Object.keys(tempCustomizeItem).filter(key =>
                      tempCustomizeItem[key]?.some(item => item.is_require == 1)
                    );
                  variantObj[k] = {
                    label: "Kies de gewenste positie",
                    thisType: "additionalHeading",
                    options: [...Object.keys(tempCustomizeItem), "geen opdruk"],
                    requiredOption:requiredKeys,
                    data: { [key1]: additionalCustomize200 }

                  };
                  tempSelectedObj[k] = [];
                  tempSelectedDetails[k] = {};
                }
                if (!variantObj[key1]) variantObj[key1] = {
                  thisType: "additional",
                  options: {},
                  label: key1,
                  variantId: key1
                }
                if (!(variantObj[key1]?.["data"])) variantObj[key1]["data"] = {}
                variantObj[key1]["data"][key1] = additionalCustomize200;

                // Ensure "position" data path exists
                if (variantObj["position"]) {
                  variantObj["position"]["data"] = variantObj["position"]["data"] || {};
                 variantObj["position"]["data"][key1] = additionalCustomize200;
                }
                tempSelectedObj[key1] = [];

                tempSelectedDetails[key1] = { thisType: "additional", labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [], imprint_required:data?.settings?.imprint_required };
              }
              return null;
            });
          } else {
            const k = "customize";

            let labelName = key, varientType = "", is_require = "", defaultSelected = [];
            Object.keys(tempCustomizeItem).map((key1) => {
              const tempPersonal100 = tempCustomizeItem[key1];
              if (tempPersonal100 && tempPersonal100?.length) {
                tempPersonal100.map((itemTemp) => {
                  varientType = itemTemp?.type;
                  const tempPersonal200 = itemTemp?.options;
                  if (tempPersonal200 && tempPersonal200?.length) {
                    tempPersonal200.map((iTemp) => {
                      if (iTemp?.default === "1") {
                        defaultSelected.push(iTemp?.id)
                      }
                      const firstOption = tempPersonal200?.[0];
                      const freeOption = tempPersonal200?.find(opt => opt?.price === 0);
                      const exists = sampleCustomizeTemp?.some(entry => entry.option_id === itemTemp?.id);
                        if (!exists && itemTemp?.is_require == 1) {
                          sampleCustomizeTemp.push({
                            option_id: itemTemp?.id,
                            option_value: ["field", "area"].includes(varientType) ? "" : (freeOption?.id || firstOption?.id),
                            is_require: itemTemp?.is_require
                          });
                        }
                      return null;
                    })
                  }
                  labelName = itemTemp?.["grouplabel"] ? itemTemp["grouplabel"] : itemTemp?.["name"] ? itemTemp["name"] : labelName;
                  is_require = true;
                  // itemTemp?.["is_require"] === "1" ? true : false // On purpose 
                  return null;
                })
              }
              return null;
            });
            variantObj[key] = {
              ...variantTempObj[key],
              varientType,
              is_require,
              thisType: k,
              ...tempCustomizeItem && Object.keys(tempCustomizeItem).length && { options: tempCustomizeItem },
              label: labelName
            }
            // variantData[key]?.options ? variantData[key]?.options?.[0]?.type === "field
            tempSelectedObj[key] = [...defaultSelected];
            isAnyDefault.push(defaultSelected.length ? "true" : "false");
            tempSelectedDetails[key] = { thisType: k, labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [], imprint_required:data?.settings?.imprint_required };
          }
        }
      }
    });
    if (additionalTempObj && Object.keys(additionalTempObj).length) {
      let varientType = ""
      Object.keys(additionalTempObj).map((bey100) => {
        const addCustom100 = additionalTempObj[bey100];
        Object.keys(addCustom100).map((key200) => {
          let addCustom200 = addCustom100[key200];
          const keyArry = addCustom200 ? Object.keys(addCustom200) : null;
          if (keyArry.length) {
            const sortorder200 = []; let is_require = true, reqFound = false;
            keyArry.map((key300, i) => {
              const addCustom300 = addCustom200[key300];
               if (addCustom300 && addCustom300?.length) {
                    addCustom300.map((iTemp) => {
                      const firstOption = addCustom300?.[0];
                      const freeOption = addCustom300?.find(opt => opt?.price === 0);
                      const exists = sampleCustomizeTemp?.some(entry => entry.option_id === iTemp?.id);
                        if (!exists && iTemp?.is_require == 1) {
                          sampleCustomizeTemp.push({
                            option_id: iTemp?.id,
                            option_value: ["field", "area"].includes(varientType) ? "" : (freeOption?.id || firstOption?.id),
                            is_require: iTemp?.is_require
                          });
                        }
                      return null;
                    })
                  }
              if (addCustom300.length) {
                if (!reqFound && addCustom300[0]?.is_require) {
                  is_require = true;
                  reqFound = true;
                }
                varientType = addCustom300[0]?.type
                addCustom300.sort((i, j) => parseInt(i.sortorder || 0) - parseInt(j.sortorder || 0));
                sortorder200.push({ key: key300, sortorder: parseInt(addCustom300[0]?.custom_sort_order || 0) })
              }
              return null;
            })
            if (sortorder200.length) {
              sortorder200.sort((k, l) => k.sortorder - l.sortorder);
              const temp200 = {};
              sortorder200.map((orderItem200) => temp200[orderItem200.key] = addCustom200[orderItem200.key])
              addCustom200 = { ...temp200 };
            }
            if (!variantObj["position"] && keyArry.length > 1 && !variantObj[key200] && varientType !== "field") {
              const k = "position";
              variantObj[k] = {
                label: "Kies de gewenste positie",
                thisType: "additionalHeading",
                options: [...keyArry, "geen opdruk"],
                data: { [bey100]: addCustom200 }
              };

              tempSelectedObj[k] = [];
              tempSelectedDetails[k] = {};
            }
            if (!variantObj[key200] && !selectedData?.["position"]?.includes("geen opdruk")) variantObj[key200] = {
              thisType: "additional",
              ...addCustom200 && Object.keys(addCustom200).length && { options: addCustom200 },
              label: key200,
              is_require,
              varientType,
              isGroupAvailable:!hasAnyLabelValue(data?.additionalCustomizables),
            }
            setAdditionalOption({ is: true, sku: "" })
            if (!(variantObj[key200]?.["data"])) variantObj[key200]["data"] = {}
            variantObj[key200]["data"][bey100] = addCustom200;

             // Ensure "position" data path exists
                if (variantObj["position"]) {
                  variantObj["position"]["data"] = variantObj["position"]["data"] || {};
                  variantObj["position"]["data"][bey100] = addCustom200;
                }
            tempSelectedObj[key200] = [];
            tempSelectedDetails[key200] = { thisType: "additional", labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [], imprint_required:data?.settings?.imprint_required };
          }
          return null;
        });
        return null;
      });
    }

    if (sampleCustomizeTemp.length) setSampleCustomizeItem([...sampleCustomizeTemp]);

    if (!isSizeQty && (!(variantObj?.["cpker"]?.label) || (variantObj?.["cpker"]?.label && isColorPickerTierPrices))) {
      const k = "qty";
      variantObj[k] = {
        label: "Kies aantal", //Choose quantity
      }
      tempSelectedObj[k] = [];
      tempSelectedDetails[k] = { labels: [] };
    }
    if (((data?.dropboxClientId && data?.dropboxClientSecretId && data?.dropboxRefreshToken) || (data?.settings?.customer_canvas_id))) {
      const k = "upload";
      variantObj[k] = {
        label: storeId === 1 ? "Gratis ontwerp" : "Bestand uploaden", // Upload / ontwerp
        isDropbox: Boolean(data?.dropboxClientId && data?.dropboxClientSecretId && data?.dropboxRefreshToken),
        isCanvas: Boolean(data?.settings?.customer_canvas_id && data?.settings?.customer_canvas_key && data?.settings?.customer_canvas_domain),
        canvasData: {
          id: data?.settings?.customer_canvas_id,
          key: data?.settings?.customer_canvas_key,
          domain: data?.settings?.customer_canvas_domain
        }
      }
      tempSelectedObj[k] = [];
      tempSelectedDetails[k] = { labels: [] };
    }
    if ((data?.settings?.allowed_sample === "1")) {
      const k = "isSample";
      variantObj[k] = {}
      tempSelectedObj[k] = [];
      tempSelectedDetails[k] = {};
    }

    setSelectedDataDefault({ ...tempSelectedObj });
    setSelectedDetailsDefault({ ...tempSelectedDetails });
    setAllData({ ...variantObj });
    if (urlGenData && Object.keys(urlGenData)?.length) {
      let hasValue = false;
      Object.keys(urlGenData).map((k, i) => {
        if (tempSelectedObj[k] && urlGenData[k]) {
          let manual_size_data = null;
          try {
            if (urlGenData[k].includes('manualSize')) {
              const a = JSON.parse(`[${urlGenData[k]}]`)
              manual_size_data = a?.[0]?.manualSize ? a?.[0]?.manualSize : null;
            }
          }
          catch (e) { }
          if (manual_size_data && manual_size_data?.key) {
            const a = {}, b = {};
            Object.keys(manual_size_data).map((k) => {
              if (k !== "key") a[k] = manual_size_data[k]
            })
            b[manual_size_data?.key] = { ...a };
            setSelectedManualSizeData({ ...b });
          } else {
            hasValue = true;
            tempSelectedObj[k] = `${urlGenData[k]}`.split(',')
          }
        }
        if (data?.settings?.allowed_sample && k === "isSample" && urlGenData[k] === "true") {
          isSampleProduct = true;
        }
        if (k === "qty" && urlGenData[k] && Number(urlGenData[k]) > 0) {
          if (urlGenData?.size?.includes("manualSize")) {
            setTimeout(() => {
              setQtyUrl(Math.round(Number(urlGenData[k])))
            }, 300)
          }
          else {
            setQtyUrl(Math.round(Number(urlGenData[k])))
          }

        }
        return null;
      });
      setReqExpanded(hasValue);
    }
    // For swaping the upload and quantity section - has bug (commented on purpose)
    // let orderedVariantList = {}, orderedVariantObj = {}, orderedSelectedDetails = {};
    // if(variantObj["upload"] && Object.keys(variantObj).length) {
    //   Object.keys(variantObj).map((key,i)=>{
    //     if(key!=="upload" && key!=="isSample") {
    //       orderedVariantList[key] = variantObj[key];
    //     }
    //   });
    //   if(variantObj["upload"]) orderedVariantList["upload"] = variantObj["upload"];
    //   if(variantObj["isSample"]) orderedVariantList["isSample"] = variantObj["isSample"];
    // }
    // if(tempSelectedObj["upload"] && Object.keys(tempSelectedObj).length) {
    //   Object.keys(tempSelectedObj).map((key,i)=>{
    //     if(key!=="upload" && key!=="isSample") {
    //       orderedVariantObj[key] = tempSelectedObj[key];
    //     }
    //   });
    //   if(tempSelectedObj["upload"]) orderedVariantObj["upload"] = tempSelectedObj["upload"];
    //   if(tempSelectedObj["isSample"]) orderedVariantObj["isSample"] = tempSelectedObj["isSample"];
    // }
    // if(tempSelectedDetails["upload"] && Object.keys(tempSelectedDetails).length) {
    //   Object.keys(tempSelectedDetails).map((key,i)=>{
    //     if(key!=="upload" && key!=="isSample") {
    //       orderedSelectedDetails[key] = tempSelectedDetails[key];
    //     }
    //   });
    //   if(tempSelectedDetails["upload"]) orderedSelectedDetails["upload"] = tempSelectedDetails["upload"];
    //   if(tempSelectedDetails["isSample"]) orderedSelectedDetails["isSample"] = tempSelectedDetails["isSample"];
    // }
    // const modifiedObject = [];
    // Object.keys(tempSelectedObj).forEach(key => {
    //     const newKey = key.replace('&', ''); // Remove '&' symbol
    //     modifiedObject[newKey] = tempSelectedObj[key];
    // });
    if (isSampleProduct) {
      setSelectedDataBackup({ ...tempSelectedObj });
      setIsSample(true);
    } else {
      setSelectedData({ ...tempSelectedObj });
    }
    setSelectedDetails({ ...tempSelectedDetails });

    setTimeout(() => {
      const indexDefault = (isAnyDefault.indexOf("false") > -1) ? isAnyDefault.indexOf("false") : (isAnyDefault.indexOf("true") > -1) ? isAnyDefault.indexOf("true") + (Object.keys(tempSelectedObj)?.length === 3 ? 1 : 1) : -1;
      setExpanded(indexDefault > -1 ? `${indexDefault}` : `${isAnyDefault.length}`);

      const keysArray = Object.keys(tempSelectedObj);
      const qtyIndex = keysArray.indexOf("qty");
      const optionsBeforeQty = keysArray.slice(0, qtyIndex);
      const isDefaultSelected = (optionName) => {
        const options = tempSelectedObj[optionName];
        return options?.length > 0 && options.every(opt => opt.default === "1");
      };
      const hasEmptyArrayNotDefault = optionsBeforeQty.some(
        key => {
          const options = tempSelectedObj[key];
          return Array.isArray(options) && options.length === 0 && !isDefaultSelected(key);
        }
      );
      setExpanded((prevExpanded) => {
        let newExpanded = prevExpanded;
        if (hasEmptyArrayNotDefault) {
          if (prevExpanded === `${qtyIndex}`) {
            newExpanded = `${qtyIndex}-closed`;
          }
        } else {
          newExpanded = `${qtyIndex}`;
        }

        return newExpanded;
      });    

    }, 300);


    //commented for purpose
    // setTimeout(() => {
    //   const indexFalse = isAnyDefault.indexOf("false"); 
    //   const indexTrue = isAnyDefault.indexOf("true");   

    //   const indexDefault = indexFalse > -1 
    //       ? indexFalse 
    //       : indexTrue > -1 
    //           ? indexTrue + (Object.keys(tempSelectedObj)?.length === 3 ? 1 : 1) 
    //           : -1;

    //   const isBedrukkingDefault = tempSelectedObj["Bedrukking"] && tempSelectedObj["Bedrukking"].length > 0;

    //   if (isBedrukkingDefault && indexTrue > -1) {
    //       setExpanded(null);
    //   } else if (indexDefault === -1) {
    //       setExpanded(`${isAnyDefault.length}`);
    //   } else {
    //       setExpanded(`${indexDefault}`);
    //   }
    // }, 300);

    //   setTimeout(() => {
    //     const indexFalse = isAnyDefault.indexOf("false");
    //     const indexTrue = isAnyDefault.indexOf("true");

    //     let indexDefault = -1;

    //     if (indexFalse > -1) {
    //         indexDefault = indexFalse;
    //     } else if (indexTrue > -1) {
    //         indexDefault = isAnyDefault.lastIndexOf("true") + (Object.keys(tempSelectedObj)?.length === 3 ? 1 : 1);
    //     }

    //     setExpanded(indexDefault > -1 ? `${indexDefault}` : `${isAnyDefault.length}`);
    // }, 300);

  };

  useEffect(() => {
    if (tokenGetData === "")
      if (data?.settings?.product_id) {
        // on purpose
        // if (data?.settings?.product_id && cmsColor?.color_picker?.totalRecords > 0 ) {
        setTokenGetData("loaded");
        getAlignAllData(urlGenData);
      };

  }, [data, urlGenData, translateData]);

  const availablePrintCustomize = ["print", "Print", "afdrukken", "bedrukken", "bedrukking", "laserengraving", "bewerking", "gewenste", "lasergraveren", "lasergravering", "colour",];
  const noPrintCustomizeOption = ["", "None", "Geen", "none", "geen", "Nee", "nee", "No", "no", "middenblad", "verzendopties", "onbedrukt", "levertijd", "kies kleur tafelblad", "kleur dop", "laserengraving", "Accessoire", "accessoire"];
  // const noPrintCustomizeOption = ["","Kies een kleur", "bedrukking", "None", "Geen", "none", "geen", "Nee", "nee", "No", "no", "middenblad", "verzendopties", "onbedrukt", "levertijd", "kies kleur tafelblad", "kleur dop", "laserengraving"];
  //  commented for purpose
  // const noPrintCustomizeOption = ["middenblad","kies kleur tafelblad","kleur dop","verzendopties","geen", "none", "onbedrukt", "nee", "no","levertijd",""];
  //  const noPrintCustomizeOption = ["","bedrukking","None", "Geen", "geen", "Nee", "nee", "No", "no","middenblad","kies kleur tafelblad","kleur dop","verzendopties", "onbedrukt","levertijd","kies kleur tafelblad","kleur dop","laserengraving"];

  useEffect(() => {
    // Retrieve the saved simpleProductId from localStorage only on reload
    const storedProductId = localStorage.getItem("simpleProductId");
    if (storedProductId) {
      setSimpleProductIdUpdated(storedProductId);
    }
  }, []);

useEffect(() => {
  if (shouldScroll && accordionRef.current) {
    const el = accordionRef.current;

    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });

      setShouldScroll(false);

      const qtySection = document.querySelector('.qty-section');
      if (!qtySection) return;

      const header = document.querySelector('.header');
      const headerHeight = header?.offsetHeight || 80;

      setTimeout(() => {
        const observer = new IntersectionObserver(
          ([entry], observerInstance) => {
            if (!entry.isIntersecting) {
              const rect = qtySection.getBoundingClientRect();
              const scrollTop = window.scrollY + rect.top - headerHeight - 50;

              window.scrollTo({
                top: scrollTop,
                behavior: 'smooth',
              });
            }

            observerInstance.disconnect();
          },
          {
            threshold: 1.0,
            rootMargin: `-${headerHeight}px 0px 0px 0px`,
          }
        );

        observer.observe(qtySection);
      }, 1500); 
    });
  }
}, [shouldScroll]);

  useEffect(() => {
    if (selectedDataDefault && selectedData && Object.keys(selectedData)?.length) {
      setdisableAction("selectedData")
      const tempSelectedDetails = { ...selectedDetails };
      const tempSelectedData = { ...selectedData }, isColorPickerTierPrices = data?.settings?.xml;
      let isManualSizeProduct = false;
      let tempTierPriceSmaple = [];
      let temp = { delivery: "", qtyStock: 0, manageStock: 0, qty_increments: "", product_cost_name: "", product_cost_id: "", amount_per_piece: null, product_cost_value: null, tier_prices: [], price: 0, min_sale_qty: 0, setup_costs: 0, productsArray: [], am_shipping_type: 0, am_shipping_type_free: false, product_vat: data?.settings?.product_vat || 0, change_costs: 0 }, isPrintProduct = -2;
      let delivery = "", product_cost_name = "", qtyStock = 0, manageStock = 0, qty_increments = "", product_cost_id = "", amount_per_piece = null, product_cost_value = null, selectedSampleQty = 0, selectedVarientQty = 0, tempVariantId = "", isSizeQtyProduct = false, productsArray = [], am_shipping_type_free = false, am_shipping_type = 0, prevKey = "", variantCount = -1, tempCanvasTemplate = "", 
      isGallerySelected = false, change_costs = data?.settings?.size_change_costs_price || 0, isCpker = Object.keys(tempSelectedData).indexOf("cpker") > -1, isCpkerLength = 0, reduseCount = 0, custom_prices = [];
     
      Object.keys(tempSelectedData).map((k, i) => {
        const allDataItem = allData[k], thisObjSample = tempSelectedData["isSample"]?.[0] === "true";
        if (allDataItem?.thisType === "variant") {
          if (tempSelectedData[k]?.length && allDataItem?.options?.length) {
            const isManualSize = !!(`${tempSelectedData?.[k]?.[0]}`.includes("manualSize"));
            if (!isManualSizeProduct)
              isManualSizeProduct = isManualSize;
            variantCount++;
            selectedSampleQty = tempSelectedData[k]?.length;
            let singleProductId = [], tempLabel = [], tempProductId = [], tempReturnData = [], tier_prices = [], price = 0, min_sale_qty = 1, setup_costs = 0, product_vat = 0, selectedOptionProductList = [], isNoMachSelected = false;
            if (allDataItem?.multiOption && prevKey)
              allDataItem.options.map((item) => {
                if (item?.id && tempSelectedData[k].includes(item.id)) {
                  if (item?.products && item.products.length) item.products.map((pro) => singleProductId.push(pro.id))
                }
                return null;
              });
            const isSingleOptions = allDataItem?.options?.length;



            isSizeQtyProduct = !isManualSize && tempSelectedData[k]?.length ? tempSelectedData[k][0]?.includes(":") ? true : false : false;
            allDataItem.options.map((item, optionIndex) => {
              const tempId = tempSelectedData[k].map(i => i.includes(":") ? i.split(":")[0] : i);
              if (item?.id && tempId.includes(item.id)) {
                if (isManualSize) {
                  setStopNextNav(true)
                }
                if (isSample && ((allDataItem?.variantPosition === allDataItem?.variantLength - 1))) {
                  tempTierPriceSmaple.push(item?.selectedProducts ? item?.selectedProducts?.tier_prices?.[0]?.price : item?.products?.[0]?.tier_prices?.[0]?.price || 0)
                } else if ((prevKey && isSizeQtyProduct) || variantCount > 0) {
                  tier_prices = temp.tier_prices
                }

                const prevSelectedOptionProductList = tempSelectedDetails?.[prevKey]?.["selectedOptionProductList"]
                if (!allDataItem?.multiOption || !prevKey ||
                  (allDataItem?.multiOption && prevKey && singleProductId.length && prevSelectedOptionProductList?.["length"])) {
                  let isProductInclude = false;
                  if (allDataItem?.multiOption && prevKey)
                    prevSelectedOptionProductList.map((pId) => {
                      if (!isProductInclude && singleProductId.includes(pId)) isProductInclude = true;
                      return null;
                    });
                  if (!allDataItem?.multiOption || !prevKey || isProductInclude || isManualSize) {
                    let temp = {};
                    selectedVarientQty++;
                    temp[allDataItem.id] = item?.id;
                    tempReturnData.push({ ...temp });
                    if (item?.products && item.products.length) {
                      item.products.map((pro) => {
                        tempCanvasTemplate = pro?.customer_canvas_design ? pro?.customer_canvas_design : "";
                        if (prevSelectedOptionProductList?.length) {
                          if (prevSelectedOptionProductList?.includes(pro.id))
                            selectedOptionProductList.push(pro.id);
                        } else
                          selectedOptionProductList.push(pro.id);

                        if (additionalOption.is) {
                          setAdditionalOption({ is: true, sku: pro.sku })
                        }
                      });
                    }
                    // selected varient gallery old logic commented on purpose
                    // if(variantCount > 0 && item.products[0]?.product_gallery_images?.[variantCount]?.image && item.products[0]["product_name"]){
                    if (isSingleOptions >= 1 && variantCount < 2)
                      if (item.products[0]?.product_gallery_images?.length) {
                        let selectedVaraintId = item?.products?.find((it)=>it?.id === item?.selectedProducts?.id);
                        // Commented on purpose for Gallery show order
                        // setGallerySelected({
                        //   name:item.products[0]["product_name"],
                        //   image:item.products[0].product_gallery_images[variantCount].image,
                        // });
                        if(selectedVaraintId){
                          setGallerySelected([...selectedVaraintId?.product_gallery_images]);
                        }else{
                          setGallerySelected([...item.products[0]?.product_gallery_images]);
                        }
                        isGallerySelected = true
                      } else if (item.products[0]?.["images"] && item.products[0]["product_name"]) {

                        setGallerySelected([{
                          name: item.products[0]["product_name"],
                          image: item.products[0]?.["images"],
                        }]);
                        isGallerySelected = true
                      }
                    if (item?.label) tempLabel = [...tempLabel, item.label];

                    if (item?.products?.[0]?.["id"]) {
                      tempProductId = [...tempProductId, item.products[0]["id"]];
                      tempVariantId = variantCount < 2 ? item.products[0]["id"] : tempVariantId;
                      const productSelected = item?.products?.length && item?.products.find(item => item.id === tempVariantId);
                      if (item?.selectedProducts && isPrintProduct == -2) {
                        isPrintProduct = item?.selectedProducts?.show_design_options == 1 ? 1 : -1;
                      }
                      else if (productSelected && isPrintProduct == -2) {
                        isPrintProduct = productSelected?.show_design_options == 1 ? 1 : -1;
                      }
                      // if (item?.label && isPrintProduct == 0) {
                      //   if (`${item.label}`.toLowerCase().includes("print") || `${item.label}`.toLowerCase().includes("bedrukt") || `${item.label}`.toLowerCase().includes("afdrukken") || `${item.label}`.toLowerCase().includes("bedrukken")) isPrintProduct = 3

                      // }
                      if (allDataItem?.options?.length) {
                        const selectedOption = allDataItem.options.find(option => option.id == [tempSelectedData[k]]);
                        tempVariantId = selectedOption?.selectedProducts?.id ? selectedOption?.selectedProducts?.id : variantCount < 2 ? item.products[0]["id"] : tempVariantId

                      }
                      else {
                        tempVariantId = variantCount < 2 ? item.products[0]["id"] : tempVariantId;

                      }

                    }
                    setSimpleProductIdUpdated(tempVariantId)

                    let selectedProductCharacteristics = [];
                      const selectedProductData = item.products.find(prod => prod.id == tempVariantId);
                      if (selectedProductData && selectedProductData.characteristics) {
                        selectedProductCharacteristics = selectedProductData.characteristics;
                        dispatch(ACTION__CHARACTERISTICS(selectedProductCharacteristics));
                      }

                    // New login to get selected product price and tire_price for SKU:RU-QS
                    const selectedProductItem = item?.selectedProducts?.id ? item.selectedProducts : item.products?.[0];
                    if (isManualSize && selectedProductItem?.["tier_prices"]?.length) {
                      let price = 0;
                      if (selectedManualSizeData && Object.keys(selectedManualSizeData).length) {
                        Object.keys(selectedManualSizeData).forEach((a) => {
                          if (selectedManualSizeData[a]?.price)
                            price = selectedManualSizeData[a]?.price
                        })
                      }
                      const tempManualTier = [];
                      selectedProductItem?.["tier_prices"].forEach((manualTier) => {
                        const p = ((price || 1) * ((manualTier?.percentage || 100) / 100)).toFixed(4);
                        tempManualTier.push({ qty: manualTier?.qty, price: parseFloat(p) });
                      })
                      tier_prices = tempManualTier;
                    } else if ((selectedProductItem?.["price"] > -1) && selectedProductItem?.["tier_prices"]?.length) {
                      // && variantCount===0
                      tier_prices = selectedProductItem["tier_prices"];
                    } else if (selectedProductItem?.["price"] > -1) {
                      // && variantCount === 0 CN-KC-onbedrukt
                      price = parseFloat(selectedProductItem?.["price"]);

                    }
                   
                    if (selectedProductItem?.["qty_increments"]) {
                      qty_increments = parseFloat(selectedProductItem?.["qty_increments"]);
                    }
                    else if(data?.settings?.qty_increments){
                      qty_increments = parseFloat(data?.settings?.["qty_increments"]);

                    }
                    if (selectedProductItem?.["setup_costs"]) {
                      setup_costs = parseFloat(selectedProductItem?.["setup_costs"]);
                    }
                    if (selectedProductItem?.["min_sale_qty"]) {
                      min_sale_qty = parseFloat(selectedProductItem?.["min_sale_qty"]);
                    }
                    if (selectedProductItem?.["product_vat"]) {
                      product_vat = parseFloat(selectedProductItem?.["product_vat"]);
                    }
                    if (selectedProductItem?.["product_cost"]) {
                      product_cost_id = selectedProductItem?.["product_cost"];
                    }
                    if (selectedProductItem?.["product_cost_name"]) {
                      product_cost_name = selectedProductItem?.["product_cost_name"];
                    }
                    if (selectedProductItem?.["amount_per_piece"]) {
                      amount_per_piece = selectedProductItem?.["amount_per_piece"];
                    }
                    if (selectedProductItem?.["product_cost_value"]) {
                      product_cost_value = selectedProductItem?.["product_cost_value"];
                    }
                    if (selectedProductItem?.["am_shipping_type_free"]) {
                      am_shipping_type_free = selectedProductItem?.["am_shipping_type_free"];
                    }
                    if (selectedProductItem?.["qty"] !== undefined && selectedProductItem?.["qty"] !== null) {
                      qtyStock = selectedProductItem?.["qty"];
                    }
                    if (selectedProductItem?.["manage_stock"] !== undefined && selectedProductItem?.["qty"] !== null) {
                      manageStock = parseFloat(selectedProductItem?.["manage_stock"]);
                    }
                    if (selectedProductItem?.["am_shipping_type"]) {
                      am_shipping_type = parseFloat(selectedProductItem?.["am_shipping_type"]);
                    }
                    if (item.products?.length) {
                      productsArray = item?.products;
                    }
                  } else if (!(!allDataItem?.multiOption || !prevKey)) {
                    isNoMachSelected = true;
                  }
                }
              }
              return null;
            });
            if (isNoMachSelected) tempSelectedData[k] = [];

            const totalLength = selectedColorData &&
              Object.values(selectedColorData).reduce((sum, array) => {
                const uniqueIds = new Set(array?.map(item => item?.pms_id));
                return sum + uniqueIds?.size;
              }, 0);

            const sample_tier_price =tempTierPriceSmaple.length ? Math.min(...tempTierPriceSmaple) * (tempTierPriceSmaple.length) : 0;
            setSampleProductPrice({
              highest_tier: (() => {
                const total = data?.isFreeSample ? 0 : sample_tier_price;
                const sampleShippingCost = Number(data?.settings?.sample_product_shipping?.value) || 0;
                const minimumPrice = Number(data?.settings?.sample_product_minimumprice) || 0;

                return data?.isFreeSample ? total + sampleShippingCost : total > minimumPrice ? total + sampleShippingCost : 0;
              })(),
              condtion_one: sample_tier_price < parseFloat(data?.settings?.sample_product_minimumprice),
              condition_two: sample_tier_price >= parseFloat(data?.settings?.sample_product_minimumprice) &&
                sample_tier_price < parseFloat(data?.settings?.sample_product_maximumprice),
              condtion_three: sample_tier_price >= parseFloat(data?.settings?.sample_product_maximumprice),
              tempTierPriceSmaple: tempTierPriceSmaple?.length ? tempTierPriceSmaple : ""
            });
            // let totalLength = tempSelectedData?.cpker?.length && Object.values(tempSelectedData?.cpker[0]).reduce((sum, array) => sum + array.length, 0);
            // multi varient single price (Commented on purpose)
            // temp = {...temp, tier_prices:mergeQty(temp["tier_prices"], tier_prices),min_sale_qty:(temp.min_sale_qty<min_sale_qty) ? min_sale_qty:temp.min_sale_qty, price:temp["price"] + price, setup_costs:temp["setup_costs"]+setup_costs, product_vat:temp["product_vat"]+product_vat};
            temp = {
              ...temp,
              tier_prices: tier_prices,
              min_sale_qty: (temp.min_sale_qty < min_sale_qty) ? min_sale_qty : temp.min_sale_qty,
              price: price,
              setup_costs: setup_costs,
              product_vat: product_vat,
              qtyStock: qtyStock,
              manageStock: manageStock,
              qty_increments: qty_increments,
              am_shipping_type_free: am_shipping_type_free,
              product_cost_name: product_cost_name,
              amount_per_piece: amount_per_piece,
              product_cost_value: product_cost_value,
              product_cost_id: product_cost_id,
              am_shipping_type: am_shipping_type,
              change_costs: change_costs && totalLength && !thisObjSample && tempSelectedData[k]?.length ? ((totalLength - 1) * change_costs) : 0
            };
            tempSelectedDetails[k] = {};
            tempSelectedDetails[k]["labels"] = tempLabel;
            tempSelectedDetails[k]["products"] = tempProductId;
            tempSelectedDetails[k]["returnData"] = tempReturnData;
            tempSelectedDetails[k]["variantIndex"] = i;

            if (allDataItem?.multiOption) {
              tempSelectedDetails[k]["prevKey"] = prevKey;
              tempSelectedDetails[k]["variantCount"] = variantCount;
              tempSelectedDetails[k]["selectedOptionProductList"] = selectedOptionProductList;
            }
            tempSelectedDetails[k]["thisType"] = "variant";
            prevKey = k;
            setTierpriceQty(getPriceForQty(qty,temp?.tier_prices,true)) 
          } else if (allDataItem?.multiOption) {
            tempSelectedDetails[k] = { variantIndex: i, thisType: "variant", prevKey, labels: [], products: [], returnData: [], setup_costs: 0, change_costs: 0, price: 0, min_sale_qty: 0, tier_prices: [] };
            prevKey = k;
            selectedSampleQty = 0;
          } else {
            if (additionalOption.is) {
              setAdditionalOption({ is: true, sku: "" })
            }
            tempSelectedDetails[k] = { variantIndex: i, thisType: "variant", prevKey, labels: [], products: [], returnData: [], setup_costs: 0, change_costs: 0, price: 0, min_sale_qty: 0, tier_prices: [] };
          }

        }
        else if (!thisObjSample && allDataItem?.thisType === "customize") {
          const TempTierPrice = temp?.tier_prices
          if(allDataItem?.label === "Kies uw bewerking" || allDataItem?.label === "Kies de gewenste bewerking" ){

          // if (isPrintProduct === 1 && allDataItem?.label) {

          //   let isAny = false;
          //   availablePrintCustomize.forEach((i) => {
          //     if (`${allDataItem.label}`.toLowerCase().includes(i.toLowerCase()) || `${allDataItem.label}`.toLowerCase() !== "none") isAny = true;
          //   })
          //   if (isAny) isPrintProduct = 1;
          // }

          // noPrintCustomizeOption.forEach((i) => {
          //   if (`${allDataItem.lafibel}`.toLowerCase().includes(i.toLowerCase()) && isPrintProduct !== 3 ) isPrintProduct = 1;
          // })
          if (isPrintProduct === 0 && allDataItem?.label) {
            let isAny = false;
            availablePrintCustomize.forEach((i) => {
              if (`${allDataItem.label}`.toLowerCase().includes(i.toLowerCase()) || `${allDataItem.label}`.toLowerCase() !== "none") isAny = true;
            })
            if (isAny) {
              isPrintProduct = 1;
            }
          }
         }
          if (tempSelectedData[k]?.length && allDataItem?.options && Object.keys(allDataItem.options)) {
            tempSelectedDetails[k] = {};
            let tempLabel = [], tempProductId = [], tempReturnData = [], tier_prices = [], price = 0, setup_costs = 0, product_vat = 0;
            if (allData[k]?.["varientType"] === "field" || allData[k]?.["varientType"] === "area") {
              tempLabel = tempSelectedData[k];
              Object.keys(allDataItem.options).map((k1) => {
                if (allDataItem.options[k1].length) {
                  allDataItem.options[k1].map((dataItem) => {
                    let temp = {};
                    temp[dataItem.id] = tempSelectedData[k]?.length ? tempSelectedData[k][0] : "";
                    tempReturnData.push({ ...temp });
                    return null;
                  })
                }
                return null;
              })
            }
            else {
              let isAnyPrintOption = false;
              Object.keys(allDataItem.options).map((k1) => {
                if (allDataItem.options[k1].length) {
                  allDataItem.options[k1].map((dataItem) => {
                    setOneTime(dataItem?.one_time)

                    if (dataItem.options.length)
                      dataItem.options.map((item) => {
                        if (item?.id && tempSelectedData[k].includes(item.id) && allDataItem?.label) {
// if(noPrintCustomizeOption.includes(`${allDataItem.label}`.toLocaleLowerCase())){
// isPrintProduct = 0
// }
// if(allDataItem?.label == "Kies uw bewerking" ||allDataItem?.label == "Kies de gewenste bewerking" ||allDataItem?.label.includes("Bedrukking") ){
//   if (!isAnyPrintOption && isPrintProduct === 1 && item?.name && !noPrintCustomizeOption.includes(`${item.name}`.toLocaleLowerCase()) && !noPrintCustomizeOption.includes(`${allDataItem.label}`.toLocaleLowerCase())) isAnyPrintOption = true;
//   noPrintCustomizeOption.forEach((i) => {
//     if (`${allDataItem.label}`.toLowerCase().includes(i.toLowerCase()) && isPrintProduct !== 3 ) isPrintProduct = 1;
//   })
// }
                  if (!isAnyPrintOption && isPrintProduct === 1 && item?.name && !noPrintCustomizeOption.includes(`${item.name}`.toLocaleLowerCase())) isAnyPrintOption = true;

                          let temp = {};
                          temp[dataItem.id] = item.id;

                          tempReturnData.push({ ...temp });
                          if (item?.name) tempLabel = [...tempLabel, item.name];

                          if (item?.["price"] > -1) {
                            if (item?.tier_prices?.length) {
                              if (dataItem?.one_time === "1") {
                                tier_prices = getSingleTierPrice(item?.tier_prices)
                              } else {
                                tier_prices = item["tier_prices"];
                              }
                            }
                            else {
                              if (dataItem?.one_time === "1" && TempTierPrice?.length) {
                                let newTierPrice = [];
                                TempTierPrice.map((priceItem) => {
                                  newTierPrice.push({ qty: priceItem.qty, price: item?.["price"] / priceItem.qty })
                                })
                                tier_prices = newTierPrice;
                              }
                              else if (dataItem?.one_time === "0") {
                                price = parseFloat(item?.["price"]);
                              }

                            }
                            // if (dataItem?.one_time === "0") {
                            //   price = parseFloat(item?.["price"]);

                            // }
                            // if (dataItem?.one_time !== "1") {
                            //   let newTierPrice = [];
                            //   TempTierPrice.map((priceItem) => {
                            //     newTierPrice.push({ qty: priceItem.qty, price: parseFloat(item?.["price"]) })
                            //   })
                            //   tier_prices = newTierPrice;
                            // }

                          }

                          // if (item?.["name"] && item["name"].includes("Zelfde")) {
                          //   delivery = item?.["name"];
                          // }

                          if (item?.["setup_costs"]) {
                            setup_costs = item?.["setup_costs"] ? item?.["setup_costs"] : 0;
                            //  setSetupCostColor(item?.["setup_costs"] ? item?.["setup_costs"] : 0)
                            // setup_costs = item?.["setup_costs"] ? item?.["setup_costs"] * (isCpkerLength ? isCpkerLength : 1) : 0;
                          }
                          if (item?.["product_vat"]) {
                            product_vat = parseFloat(item?.["product_vat"]);
                          }
                        }
                        return null;
                      });
                    return null;
                  });
                }
              if(allDataItem?.label === "Kies uw bewerking" || allDataItem?.label === "Kies de gewenste bewerking"){

                if (isPrintProduct === 1) isPrintProduct = isAnyPrintOption ? 2 : 0;
              }
                return null;
              })
            }
            if (isManualSizeProduct && tier_prices.length) {
              const newTierPrice = [], additionalPercentage = tier_prices[0].percentage;
              if (additionalPercentage && temp["tier_prices"]?.length) {
                temp["tier_prices"].map((item) => {
                  newTierPrice.push({
                    ...item, price: item.price + (item.price * additionalPercentage / 100)
                  })
                })
                temp["tier_prices"] = newTierPrice
              }
            }
            temp = {
              ...temp,
              delivery,
              tier_prices: mergeQty(temp["tier_prices"], tier_prices, isCpker),
              price: tier_prices.length ? temp["price"] : temp["price"] + price,
              setup_costs: temp["setup_costs"] + setup_costs,
              product_vat: temp["product_vat"] + product_vat,
            };
            // temp = { ...temp, delivery, tier_prices: mergeQty(temp["tier_prices"], tier_prices, isCpker), price:temp["price"] + price, setup_costs: temp["setup_costs"] + setup_costs, product_vat: temp["product_vat"] + product_vat };
            tempSelectedDetails[k]["labels"] = tempLabel;
            tempSelectedDetails[k]["products"] = tempProductId;
            tempSelectedDetails[k]["returnData"] = tempReturnData;
            tempSelectedDetails[k]["thisType"] = "customize";
            tempSelectedDetails[k]["imprint_required"] = data?.settings?.imprint_required;
          } else {
            // if (isPrintProduct === 1) isPrintProduct = 0;
            tempSelectedDetails[k] = { thisType: "customize", labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [], imprint_required:data?.settings?.imprint_required };
          }
        } else if (!thisObjSample && allDataItem?.thisType === "additional") {
          if (allDataItem.variantId === k) tempVariantId = k;
          if (isPrintProduct === 0 && allDataItem?.label) {
            let isAny = false;
            availablePrintCustomize.forEach((i) => {
              if (`${allDataItem.label}`.toLowerCase().includes(i.toLowerCase()) || `${allDataItem.label}`.toLowerCase() !== "none") isAny = true;
            })
            if (isAny) {
              isPrintProduct = 1;
            }
          }
          if (tempVariantId) {
            if (/[a-zA-Z]/.test(tempVariantId)) {
            } else {
              setSimpleProductIdUpdated(tempVariantId);
            }

            tempSelectedDetails[k] = {};
            tempSelectedDetails[k]["variant"] = tempVariantId;
            const additionalVarientData = allDataItem?.["data"]?.[tempVariantId], sampleCustomizeTemp = [];
            let tempLabel = [], tempProductId = [], tempReturnData = [], tier_prices = [], price = 0, setup_costs = 0, product_vat = 0;
            if (allData[k]?.["varientType"] === "field" || allData[k]?.["varientType"] === "area") {
              tempLabel = tempSelectedData[k];

              Object.keys(allDataItem.options).map((k1) => {

                if (allDataItem.options[k1].length) {
                  allDataItem.options[k1].map((dataItem) => {
                    let temp = {};
                    temp[dataItem.id] = tempSelectedData[k]?.length ? tempSelectedData[k][0] : "";
                    tempReturnData.push({ ...temp });
                    return null;
                  })
                }
                return null;
              })
            }
            else {
              let isAnyPrintOption = false;
              if (additionalVarientData) {
                Object.keys(additionalVarientData).map((key) => {
                  const tempAdd = additionalVarientData[key];
                  if (tempAdd && tempAdd.length) {
                    tempAdd.map((i) => {
                      if (i.options && i.options.length) {
                        i.options.map((j) => {
                          if (tempSelectedData[k]?.length) {
                            if (j.id && tempSelectedData[k].includes(j.id)) {
                              // if(noPrintCustomizeOption.includes(`${allDataItem.label}`.toLocaleLowerCase())){
                              //   isPrintProduct = 0
                              //   }
                              if (!isAnyPrintOption && isPrintProduct === 1 && j?.name && !noPrintCustomizeOption.includes(`${j.name}`.toLocaleLowerCase())) isAnyPrintOption = true;
                              let t = {};
                              t[i.id] = j.id;
                              tempReturnData.push({ ...t });
                              if (j?.name) tempLabel = [...tempLabel, j.name];
                              if (j?.["tier_prices"] && j["tier_prices"].length) {
                                tier_prices = mergeQty(j["tier_prices"], tier_prices, isCpker, true)
                              } else if (j?.["price"]) {
                                price = price + parseFloat(j?.["price"]);
                              }
                              if(j?.["custom_prices"]){
                                 custom_prices?.push(...j?.custom_prices)
                              }
                              if (j?.["setup_costs"]) {
                                setup_costs = setup_costs + parseFloat(j?.["setup_costs"]);
                              }
                              if (j?.["product_vat"]) {
                                product_vat = product_vat + parseFloat(j?.["product_vat"]);
                              }
                            }
                          } else {
                            //  const options = i?.options || [];
                            //  const firstOption = options?.[0];
                            //  const freeOption = options?.find(opt => opt?.price === 0);
                            // // Determine final selected option
                            //   const selectedOption = freeOption || firstOption;
                            //   const optionValue = ["field", "area"].includes(i?.type) ? "" : selectedOption?.id;

                            //   // Avoid duplicates
                            //   const exists = sampleCustomizeTemp?.some(entry => entry.option_id === i?.id);
                            //   if (!exists && selectedOption) {
                            //     // sampleCustomizeTemp.push({
                            //     //   option_id: i?.id,
                            //     //   option_value: optionValue,
                            //     //   is_require: i?.is_require
                            //     // });
                            //   }
                              return null
                          }
                          return null;
                        })
                      }
                      return null;
                    })
                  }
                  return null;
                })
              }
              if (isPrintProduct === 1) isPrintProduct = isAnyPrintOption ? 2 : 0;
            }
            if (sampleCustomizeTemp.length) {
              setSampleCustomizeItem([...sampleCustomizeTemp])
            }
            temp = { ...temp, tier_prices: mergeQty(temp["tier_prices"], tier_prices, isCpker), price: temp["price"] + price, setup_costs: temp["setup_costs"] + setup_costs, product_vat: temp["product_vat"] + product_vat , custom_prices, imprint_required:data?.settings?.imprint_required};
            tempSelectedDetails[k]["labels"] = tempLabel;
            tempSelectedDetails[k]["products"] = tempProductId;
            tempSelectedDetails[k]["returnData"] = tempReturnData;
            tempSelectedDetails[k]["thisType"] = "additional";
            tempSelectedDetails[k]["hide"] = !allData?.[k]?.["data"]?.[tempVariantId] || selectedData?.["position"]?.includes("geen opdruk") ||allData["position"]?.options?.length && allData["position"]?.options?.length > 1 &&  !selectedData?.["position"]?.length;
            reduseCount = !allData?.[k]?.["data"]?.[tempVariantId] ? reduseCount + 1 : reduseCount;
            tempSelectedDetails[k]["imprint_required"] = data?.settings?.imprint_required;
          } else {
            // if (isPrintProduct === 1) isPrintProduct = 0;
            tempSelectedDetails[k] = { thisType: "additional", labels: [], products: [], returnData: [], setup_costs: 0, price: 0, tier_prices: [], imprint_required:data?.settings?.imprint_required };
          }
        } else if(!thisObjSample && allDataItem?.thisType === "additionalHeading"){
          tempSelectedDetails[k] ={};
          tempSelectedDetails[k]["variant"] = tempVariantId;
        } else if (!thisObjSample && k === "upload") {
          const filteredOptions = Object.values(allData).every(item =>
             item.thisType !== 'additional' || item.thisType !== "customize" );
           if (isPrintProduct === 1 && filteredOptions) isPrintProduct = 2;
          tempSelectedDetails[k] = {};
          tempSelectedDetails[k]["reduseCount"] = reduseCount;
          tempSelectedDetails[k]["labels"] =
            tempSelectedData[k]?.[0] === "true" ? "Ik lever het ontwerp later aan" :
              imagesDropbox.length ? "Bestanden geupload" : "";
          tempSelectedDetails[k]["isUpload"] = isPrintProduct !== 2 || tempSelectedData[k]?.[0] === "true" ? false : true;
          tempSelectedDetails[k]["thisType"] = "upload"; // isPrintProduct
          tempSelectedDetails[k]["hide"] = isPrintProduct !== 2;
          // setReqExpanded(isPrintProduct === 2 && tempSelectedData[k]?.[0] === "true");
        } else if (k === "isSample") {
          tempSelectedDetails[k] = {};
          tempSelectedData[k] = (tempSelectedData[k]?.[0] === "true") ? ['true'] : [];
          tempSelectedDetails[k]["thisType"] = "isSample";
          tempSelectedDetails[k]["isSample"] = tempSelectedData[k]?.[0] === "true";
        } else if (k === "qty") {
          const qty1 = thisObjSample ? selectedVarientQty : qtyUrl > -1 ? qtyUrl : qty;
          if (qtyUrl > -1) {
            setQty(qtyUrl);
            setcustomQty(true)
            setQtyTemp(qtyUrl);
            setQtyUrl(-1);
          }
          tempSelectedDetails[k] = {};
          let tempQty = { ...qtyDataDefault };
          tempSelectedData[k] = thisObjSample ? [] : qty1 ? [`${qty1}`] : [];
          tempSelectedDetails[k]["labels"] = qty1 ? `${qty1}  stuk(s)` : "";
          tempSelectedDetails[k]["reduseCount"] = reduseCount;
          const tier_prices = temp?.tier_prices?.length ? isCpker ? temp.tier_prices : temp.tier_prices.filter((a) => a?.hide !== true) : [];

          if (qty1 > 0 && temp.tier_prices.length) {
            // let nm_tier_prices = (temp?.tier_prices?.length ? [...temp.tier_prices].filter((a) => a?.hide === true) : []).length;
            tier_prices.map((tier_i, i) => {
              if (tier_i.qty !== qty1 && tier_i.qty < qty1) {
                tempQty = { isCustomQty: true, index: i, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
                setQtyTemp(qty1);
              } else if (tier_i.qty === qty1) {
                tempQty = { isCustomQty: isCustomQty === true ? true : false, index: i, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
              } else if (thisObjSample) {
                tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(tier_prices[0]?.price)) ? (parseFloat(tier_prices[0]?.price) + temp.price) : 0, addOnPrice: temp.price }
                setQtyTemp(qty1);
              }
              return null;
            })
          } else if (!tier_prices?.length && (temp?.price > 0) && (temp?.min_sale_qty > 0)) {
            tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(temp?.price)) ? parseFloat(temp.price) : 0, addOnPrice: temp.price }
            setQtyTemp(qty <= temp.min_sale_qty ? temp.min_sale_qty : qty);
            if (qty <= temp.min_sale_qty) {
              tempSelectedData[k] = [temp.min_sale_qty];
            }
          } else {
            tempQty = { isCustomQty: false, index: -1, price: 0.0, addOnPrice: temp.price }
            setQtyTemp(0);
            setQty(0);
            tempSelectedData[k] = [];
          }
          setIsCustomQty(tempQty.isCustomQty)
          setQtyData(tempQty)
          // commented for purpose
          // if(tempQty.isCustomQty){
          //   setQty(tier_prices?.length?tier_prices[0]?.qty:1)
          // }
          // if(tempQty.isCustomQty && qty >0){
          //   setcustomQty(true)
          // }
          setMinPrice({ qty: tier_prices[0]?.qty, price: parseFloat(tier_prices[0]?.price) });
          if (thisObjSample) setSampleQty(selectedSampleQty);
        }
        if (!thisObjSample && isSizeQtyProduct) {
          let qtySizeVariant = totalValueQty;
          if (variantQtydata?.length && (totalValueQty >= data?.settings?.min_sale_qty)) {
            setQty(qtySizeVariant);
          }
          let tempQty = { ...qtyDataDefault };
          if (qtySizeVariant > 0 && temp.tier_prices.length) {
            temp.tier_prices.map((tier_i, i) => {
              if (tier_i.qty !== qtySizeVariant && tier_i.qty < qtySizeVariant) {
                tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
              }else if (qtySizeVariant < tier_i.qty && i === 0) {
                tempQty = {
                  isCustomQty: true,
                  index: -1,
                  price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i.price) + temp.price) : 0,
                  addOnPrice: temp.price
                };
              }
               else if (tier_i.qty === qtySizeVariant) {

                tempQty = { isCustomQty: false, index: i, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
              } else if (thisObjSample) {
                tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(temp.tier_prices[0]?.price)) ? (parseFloat(temp.tier_prices[0]?.price) + temp.price) : 0, addOnPrice: temp.price }
              }
              return null;
            })
          }
          setQtyData(tempQty);          
          setMinPrice({ qty: temp.tier_prices[0]?.qty, price: parseFloat(temp.tier_prices[0]?.price) });
        }
        if ((!thisObjSample && k === "cpker") || (!thisObjSample && allDataItem?.thisType === "customize" && Object.keys(tempSelectedData)?.includes("cpker"))) {
          const k = "cpker";
          isCpker = true;
          tempSelectedDetails[k] = {};
          tempSelectedDetails[k]["labels"] = tempSelectedData[k] && Object.keys(tempSelectedData[k]).length ? [" "] : [];
          tempSelectedDetails[k]["thisType"] = "cpker";
          let objTemp = {}
          if (tempSelectedData[k]?.length && (typeof tempSelectedData[k][0] === "string")) {
            const tempStringSelected = tempSelectedData[k].join();
            objTemp = JSON.parse(tempStringSelected)
          } else if (tempSelectedData[k]?.length) {
            objTemp = tempSelectedData[k][0]
          }
          if (!isColorPickerTierPrices) {
            let qtyCpker = 0;
            if (objTemp && Object.keys(objTemp)?.length) {
              Object.keys(objTemp).map((cKey, index) => {
                const tempColorItem = objTemp[cKey]
                if (tempColorItem && tempColorItem.length) {
                  tempColorItem.map((clr) => qtyCpker = qtyCpker + (clr.qty || 0))
                }
                return null;
              })
            }
            setQty(prevQty => {
              return qtyCpker > 0 ? qtyCpker : prevQty;
            });
            
            let tempQty = { ...qtyDataDefault };
            if (qtyCpker > 0 && temp.tier_prices.length) {
              temp.tier_prices.map((tier_i, i) => {
                if (tier_i.qty !== qtyCpker && tier_i.qty < qtyCpker) {
                  tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
                } else if (tier_i.qty === qtyCpker) {
                  tempQty = { isCustomQty: false, index: i, price: !isNaN(parseFloat(tier_i?.price)) ? (parseFloat(tier_i?.price) + temp.price) : 0, addOnPrice: temp.price }
                } else if (thisObjSample) {
                  tempQty = { isCustomQty: true, index: -1, price: !isNaN(parseFloat(temp.tier_prices[0]?.price)) ? (parseFloat(temp.tier_prices[0]?.price) + temp.price) : 0, addOnPrice: temp.price }
                }
                return null;
              })
            }
            setQtyData(tempQty);            
            setMinPrice({ qty: temp.tier_prices[0]?.qty, price: parseFloat(temp.tier_prices[0]?.price) });
          }
        }
      });
      if (!isGallerySelected) {
        setGallerySelected([]);
      }

      //     const matched_tier_prices = temp?.tier_prices?.length 
      // ? (isCpker 
      //     ? temp.tier_prices 
      //     : temp.tier_prices
      //         .filter((a) => a?.hide !== true)
      //         .map((tier) => ({
      //           ...tier,
      //           price: Math.ceil(tier.price * 100) / 100 
      //         }))
      //   ) 
      // const matched_tier_prices = temp?.tier_prices?.length 
      // ? (isCpker 
      //     ? temp.tier_prices 
      //     : temp.tier_prices
      //         .filter((a) => a?.hide !== true)
      //         .map((tier) => ({
      //           ...tier,
      //           price: Number(tier.price.toFixed(4)) 
      //         }))
      //   ) 
      // : [];
      const matched_tier_prices = temp?.tier_prices?.length
        ? (isCpker
          ? temp.tier_prices
          : temp.tier_prices
            .filter((a) => a?.hide !== true)
            .map((tier) => ({
              ...tier,
              price: Number(tier.price.toFixed(4))
            }))
            .sort((a, b) => a.qty - b.qty)
        )
        : [];


      // const matched_tier_prices = temp?.tier_prices?.length ? isCpker ? temp.tier_prices : temp.tier_prices.filter((a) => a?.hide !== true) : [];
      const not_matched_tier_prices = temp?.tier_prices?.length ? temp.tier_prices.filter((a) => a?.hide === true) : [];
      setImageCanvasTemplate(tempCanvasTemplate);
      setSelectedDetailsFinal({ ...temp, tier_prices: matched_tier_prices, not_matched_tier_prices, product_vat: temp?.product_vat ? temp.product_vat : data?.settings?.product_vat ? data.settings.product_vat : 0 })
      setSelectedDetails({ ...tempSelectedDetails });

      if (reqExpanded) {
        setReloadScroll(true)
        handleExpandNext(reloadScroll ? 1 : 0, reqExpanded === "cart", tempSelectedData, tempSelectedDetails);
        setReqExpanded(false);
      }
      setSelectedDataNow(tempSelectedData);
      generateNewUrl(tempSelectedData);
      if (isNewUrlLoad) {
        // const reCheckExpandOnload = Object.keys(selectedDataDefault).length - 1 - (isPrintProduct !== 2 ? 1 : 0);
        // if (`${reCheckExpandOnload}` === expanded || expanded === 0) {
        // setTimeout(()=> {
        //   if (isPrintProduct !== 2) setExpanded(`${reCheckExpandOnload + 1}`)
        // },300)
        // }
        setIsNewUrlLoad(false);
      }
    }
  }, [selectedData, qty]);

  useEffect(() => {
    let CustomOptions;
    if (!isSample && (data?.settings?.product_id && selectedDetails && Object.keys(selectedDetails).length)) {
      const option = getApiCartOptions();
      CustomOptions = isSample ? [...sampleCustomizeItem] : [...getKeyVal(option?.customize), ...getKeyVal(option?.additional)]
      if (data?.settings?.product_id && deliveryData === null && qty > 0 && !hasFetchedDeliveryDate.current) {
        const updateSimpleProductId = option?.finalProducts?.length ? option?.finalProducts[0] : null;
        getDeliveryDate(option, qty, updateSimpleProductId);

        hasFetchedDeliveryDate.current = true;
      }
    }
    setdisableAction("selectedDetails");
    setCustomOptions(CustomOptions)
    if (changeCustomizeOption?.qty) {
      if (selectedDetailsFinal?.not_matched_tier_prices?.length) {
        const matchedQty = selectedDetailsFinal.not_matched_tier_prices.some(
          item => item.qty === qty
        );

        if (matchedQty) {
          setQty(0);
          setReqExpanded(true);
          setchangeCustomizeOption({ qty: false });
        }
      }
    }
    if (changeCustomizeOption?.customoption || changeCustomizeOption?.variant) {
      setchangeCustomizeOption({
        customoption: "",
        variant: ""
      })
      const option = getApiCartOptions();
      getDeliveryDate(option, qty)
    }

  }, [selectedDetails]);

  useEffect(() => {
    getDeliveryDate({}, qty);
  }, [isSample])
  
  useEffect(() => {
    if (disableAction !== "") {
      setTimeout(() => {
        if (disableAction !== "") setdisableAction("");
      }, 600);
    }
  }, [disableAction])

  useEffect(() => {
    if (data && selectedDataDefault) {
      const tempSelectedObj = { ...selectedDataDefault };
      if (urlGenData && Object.keys(urlGenData)?.length) {
        Object.keys(urlGenData).map((k, i) => {
          // if (tempSelectedObj[k] && urlGenData[k]) tempSelectedObj[k] = `${urlGenData[k]}`.split(',');
          if (k === "qty" && urlGenData[k] && Number(urlGenData[k]) > 0) {
            // setQtyUrl(Math.round(Number(urlGenData[k])))
          } else if (tempSelectedObj[k] && urlGenData[k]) {
            let manual_size_data = null;
            try {
              const a = JSON.parse(urlGenData[k])
              manual_size_data = a?.[0]?.manualSize ? a?.[0]?.manualSize : null;
            }
            catch (e) { }
            if (manual_size_data && manual_size_data?.key) {
              const a = {}, b = {};
              Object.keys(manual_size_data).map((k) => {
                if (k !== "key") a[k] = manual_size_data[k]
              })
              b[manual_size_data?.key] = [{ ...a }];
              tempSelectedObj[k] = [{ manualSize: { ...b } }]
            } else tempSelectedObj[k] = `${urlGenData[k]}`.split(',')
          } else {
            setQtyUrl(0)
          }
          return null;
        })
      }
      if (stopNextNav) {
        setStopNextNav(false)
      } else setReqExpanded(true);
      try {
        if (JSON.stringify(tempSelectedObj) !== JSON.stringify(selectedData))
          setSelectedData({ ...tempSelectedObj })
      } catch (e) {
        console.log(e, "error")
      }
    }
  }, [urlGenData]);

  useEffect(() => {
    if (singleToken === "loaded" && data && selectedDataDefault) {
      if (isSample) {
        const temp = {}, temp1 = {};
        Object.keys(selectedDetailsDefault).length && Object.keys(selectedDetailsDefault).forEach((k) => {
          const vType = selectedDetailsDefault[k]?.thisType;
          if (vType === "isSample" || vType === "variant") {
            temp1[k] = selectedDetailsDefault[k];
          }
        })
        setSelectedDetails({ ...temp1 });
        const backup = selectedDataBackup && Object.keys(selectedDataBackup).length ? { ...selectedDataBackup } : { ...selectedDataDefault };
        setSelectedDataBackup({ ...selectedData });
        setReqExpanded(true);
        setExpanded("0");
        Object.keys(backup).length && Object.keys(selectedDetailsDefault).forEach((k) => {
          const vType = selectedDetailsDefault[k]?.thisType;
          if (vType === "isSample" || vType === "variant") {
            temp[k] = backup[k];
          }
        })
        setSelectedData({ ...temp, isSample: ["true"] });
      } else {
        const backup = selectedDataBackup && Object.keys(selectedDataBackup).length ? { ...selectedDataBackup } : { ...selectedDataDefault };
        setSelectedDetails({ ...selectedDetailsDefault })
        setSelectedDataBackup({ ...selectedData });
        setSelectedData({ ...backup });
      }
    }
  }, [isSample]);

  useEffect(() => {
    if (singleToken === "") setSingleToken("loaded");
  }, [singleToken]);

  const addToWishlist__gtm = (productName, productSku) => {
    const data = {
      event: 'addToWishlist',
      eventLabel: productName,
      ecommerce: {
        addwishlist: {
          products: [
            {
              name: productName,
              id: productSku,
            }
          ]
        }
      },
    };
    TagManager.dataLayer({ dataLayer: data });
  };

  const calculateShippingCostsFree = () => {
    const isCpkerLength = selectedColorData &&
      Object.values(selectedColorData).reduce((sum, array) => {
        const uniqueIds = new Set(array?.map(item => item?.pms_id));
        return sum + uniqueIds?.size;
      }, 0);
    let shippingCostsFree = false;
    if (
      parseInt(selectedDetailsFinal?.am_shipping_type) === 3338 &&
      ((qtyData?.price * (isSample ? sampleQty : qty)) + selectedDetailsFinal.setup_costs * (isCpkerLength ? isCpkerLength : 1) + selectedDetailsFinal.change_costs) > 500
    ) {
      return true;
    }
    if (selectedDetailsFinal?.am_shipping_type_free) {
      shippingCostsFree = selectedDetailsFinal?.am_shipping_type_free;
    }
    return shippingCostsFree;
  };
  const shippingCostsFree1 = calculateShippingCostsFree();
  const isCpkerLength =
    selectedColorData &&
    Object.values(selectedColorData).reduce((sum, array) => {
      const uniqueIds = new Set(array?.map((item) => item?.pms_id));
      return sum + uniqueIds?.size;
    }, 0);

  const isBase64Encoded = (str) => {
    let string;
    try {
      if (str?.includes("YYYY")) {
        string = str?.replace("YYYY", "");
        return atob(string);
      } else {
        return atob(str);
      }
    } catch (e) {
      return str;
    }
  };

  //commented for purpose 
  // useEffect(() => {
  //   if (!selectedDetailsFinal) return;

  //   const { manageStock, qtyStock } = selectedDetailsFinal;
  //   const formattedQtyStock = qtyStock?.toString().includes('.') 
  //     ? Math.round(qtyStock * 1000) 
  //     : qtyStock;


  //   if (manageStock === 1) {
  //     if (qtyStock === 0 || formattedQtyStock < qty || deliveryData?.text?.includes("onbekend")) {
  //       setIsOutOfStock(true);
  //     } else {
  //       setIsOutOfStock(false);
  //     }
  //   } else if (manageStock === 0) {
  //     if (qtyStock === 0 && formattedQtyStock < qty) {
  //       setIsOutOfStock(true);
  //     } else {
  //       setIsOutOfStock(false);
  //     }
  //   } else if (deliveryData?.text?.includes("onbekend")) {
  //     setIsOutOfStock(true);
  //   } else {
  //     setIsOutOfStock(false);
  //   }
  // }, [selectedDetailsFinal, qty, deliveryData]);

  useEffect(() => {
    if (selectedDetailsFinal?.manageStock === 1) {
      let formattedQtyStock = selectedDetailsFinal?.qtyStock.toString().includes('.') ? Math.round(parseFloat(selectedDetailsFinal.qtyStock) * 1000) : selectedDetailsFinal.qtyStock
      if (selectedDetailsFinal?.qtyStock === 0 || formattedQtyStock < qty || selectedDetailsFinal?.text?.includes("onbekend")) {
        setIsOutOfStock(true);
      } else {
        setIsOutOfStock(false);
      }
    } else {
      setIsOutOfStock(false)
    }
  }, [selectedDetailsFinal?.qtyStock, qty, selectedDetailsFinal?.manageStock]);

  //   useEffect(() => {
  //     const params = new URLSearchParams(location.search);
  //     const qtyFromUrl = parseInt(params.get("qty"), 10);

  //     if (isCustomQty) {
  //         // Only update if custom quantity is enabled
  //         if (!isNaN(qtyFromUrl) && qtyFromUrl >= selectedDetailsFinal?.minQty) {
  //             setQtyTemp(qtyFromUrl);
  //         }
  //         UpdateTextQty(newqtyTemp, selectedDetailsFinal, setQty, setnewQtyTemp, getDeliveryDate, getApiCartOptions);
  //     } else {
  //         // Prevent default selection of min quantity, but do nothing if qty is not set
  //         if (!isNaN(qtyFromUrl) && qtyFromUrl !== selectedDetailsFinal?.minQty) {
  //             setQtyTemp(selectedDetailsFinal?.minQty);
  //         }
  //     }
  // }, [location.search,isCustomQty]);

  useEffect(() => {
    if (isCustomQty) {
      UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
    } else if (!isCustomQty && qty > 0) {
      UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
    }
  }, [isCustomQty]);

const currentMinQty = useMemo(() => {
  if (selectedDetailsFinal?.tier_prices?.length > 0) {
    return Math.min(...selectedDetailsFinal.tier_prices.map(item => item.qty));
  } else if (selectedDetailsFinal?.not_matched_tier_prices?.length > 0) {
    return Math.min(...selectedDetailsFinal.not_matched_tier_prices.map(item => item.qty));
  }
  return null;
}, [selectedDetailsFinal]);

useEffect(() => {

  if (currentMinQty && qty < currentMinQty) {
    setQty(0); 
    setQtyTemp(0); 
    setIsCustomQty(false); 
    setReqExpanded(true)
  }
}, [currentMinQty, qty]);

// unique price on quantity section
const uniquePrices = (value = []) => {
    if (!Array.isArray(value)) return [];

    return value.reduce((acc, curr) => {
        if (!acc.some(item => item.price === curr.price)) {
            acc.push(curr);
        }
        return acc;
    }, []);
};
  const selectedOptions = data?.options || {}; 
  const expectedKeys = Object.keys(selectedOptions); 
  const lastVariantKey = expectedKeys[expectedKeys.length - 1]; 

  return (
    <React.Fragment key={key}>
      <div className='productVariant'>
        {/* {disableAction !== "" ? <div className='variantOverlay' /> : null} */}
        <div ref={startAccordionRef} style={{ minHeight: 1 }} />
        <div className={`accordion0`} />
        <div className={`w-1/1 gap-6 flex ${isSample ? "col-i" : "col"}`}>
          <div className='variant-list'>
            {Object.keys(allData).length ? (
              <React.Fragment>
                {Object.keys(allData).map((key, item) => (
                  <React.Fragment key={`aoptions[0]?.labelllData-${item}`}>
                    <div className={`accordion${item}`} />
                    {allData[key]?.thisType === "variant" ? (
                      <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                        <Accordion key={`Accordion_${allData[key]?.label}_${item}`} expanded={expanded === `${item}` || (
                            allData[key]?.options?.length > 1 &&
                            isSample &&
                            key === lastVariantKey &&
                            (() => {
                              const keys = Object.keys(allData);
                              const currentIndex = keys.indexOf(key);
                              const prevKey = keys[currentIndex - 1];
                              return !!selectedDetails?.[prevKey]?.variant;
                            })()
                          ) ||
                         (
                          isSample && allData[key]?.options?.length > 1 &&
                          key === lastVariantKey &&
                          samplenextNav === false &&
                          (() => {
                            const keys = Object.keys(allData);
                            const currentIndex = keys.indexOf(key);
                            if (currentIndex === 0) return true; 
                            const prevKey = keys[currentIndex - 1];
                            return !!selectedDetails?.[prevKey]?.variant;
                          })()
                        )
                        } 
                          onChange={handleExpanded(`${item}`)}>
                          <VariantHeader 
                           id={`${item}`} 
                           name={`${allData[key]?.label}`} 
                           isError={(parseInt(expanded) > item && !(allData[key]?.sizeQty ? variantQtydata?.length && totalValueQty >= data?.settings?.min_sale_qty : allData[key]?.options?.[0]?.label === "manual-size" ? selectedDetails?.[key]?.products?.length : selectedData?.[key]?.length)) || (expanded === `${item}` && expanded === errorOpenTab)} 
                           expanded={expanded === `${item}` || expanded === item} label={allData[key]?.options?.[0]?.label === "manual-size" ? manualsizelabel : selectedDetails[key]?.labels?.join(", ")} 
                           order={item + 1} completed={allData[key]?.sizeQty && !isSample ? variantQtydata?.length && totalValueQty >= data?.settings?.min_sale_qty : allData[key]?.options?.[0]?.label === "manual-size" ? selectedDetails?.[key]?.products?.length : selectedData?.[key]?.length} 
                           translate={translateData?.translations} isValidTier={selectedDetailsFinal} />
                           
                          <AccordionDetails>
                            {allData[key]?.options && allData[key]?.options?.length ?
                              <React.Fragment>
                                {isSample ? 
                                <p className='mb-4' style={{ fontSize: 15, lineHeight: "23px"}}>
                                  {(`U kunt maximaal ${["color", "size"].every(type => allData[key]?.variantDatas?.includes(type)) ? 5 : 3} samples tegelijk aanvragen, mits beschikbaar.`)}</p>
                                 : null}
                                {/* {allData[key]?.mutiSelect ? <p className='mb-4' style={{ fontSize: 15, lineHeight: "23px" }}>{`Selecteer de gewenste opties, meerdere keuzes mogelijk.`}</p> : null} As per client request it was removed on purpose */}
                                {item === 0 && data?.settings?.custom_made_option_subtitle ? <p className='mb-4' style={{ fontSize: 15, lineHeight: "23px" }}>{data?.settings?.custom_made_option_subtitle}</p> : null}
                                {allData[key]?.sizeQty && !isSample ? (
                                  <div className="sizeQty relative">
                                    <VariantQtyPicker
                                      keyList={[key]}
                                      allData={allData}
                                      isSample={isSample}
                                      variantData={allData[key]}
                                      setSelected={setSelectedData}
                                      selectedDetails={selectedDetails}
                                      setStopNextNav={setStopNextNav}
                                      translate={translateData?.translations}
                                      selectedData={selectedData}
                                      setReqExpanded={setReqExpanded}
                                      expanded={expanded}
                                      setExpanded={setExpanded}
                                      selectedDetailsFinal={selectedDetailsFinal}
                                      setVariantQtyData={setVariantQtyData}
                                      variantQtydata={variantQtydata}
                                      setOpenModelQty={setOpenModelQty}
                                      openModelQty={openModelQty}
                                      setErrorQty={setErrorQty}
                                      errorQty={errorQty}
                                      setTotalValueQty={setTotalValueQty}
                                      totalValueQty={totalValueQty}
                                      productData={data}
                                      setInitialTierPricePopup={setInitialTierPricePopup}
                                      setErrorCart={setErrorCart}
                                    />
                                    {!isSample && Object.keys(allData).map((key, item) => {
                                      let isValidSampleAtLast = Object.keys(allData).map((key,item) => Object.values(allData)[item])?.[0]?.variantDatas?.slice(-1)?.[0]
                                      return(
                                      <React.Fragment key={`alldata_${key}_${item}`}>
                                        {((storeId === 1 && expanded === `${item}` && (data?.isTextileProduct == "1" && key === isValidSampleAtLast)) && (selectedDetailsFinal?.tier_prices?.length && data?.settings?.allowed_sample === "1")) ? (
                                          <div className='sampleForm mt-6'>
                                            <div className="content">
                                              <div className="flex w-1/1 gap-3">
                                                <div className="flex-0 checkbox">
                                                  <input type="checkbox" aria-label="checkbox" checked={isSample} readOnly />
                                                  <button aria-label="button" onClick={() => { 
                                                    setSelectedData({...selectedData,isSample: isSample ? [] : ["true"]});
                                                    setIsSample(!isSample); setQty(0) }}></button>
                                                </div>
                                                {sampleProductPrice?.condition_two ?
                                                  <div className="flex-1 flex col gap-2">
                                                    <h3>{data?.settings?.message2Heading}</h3>
                                                    <p>
                                                      {data?.settings?.message2Content}
                                                      <p className='refund-icon'>
                                                        <RefundIcon />
                                                        <b>
                                                          {data?.settings?.message2HighlightedText}
                                                        </b>
                                                      </p>
                                                      <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                                                    </p>
                                                  </div>
                                                  :
                                                  sampleProductPrice?.condtion_three ?
                                                    <div className="flex-1 flex col gap-2">
                                                      <h3>{data?.settings?.message3Heading}</h3>
                                                      <p>
                                                        {data?.settings?.message3Content}
                                                        <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                                                      </p>
                                                    </div> :
                                                    //condition one and if condition not satisfied it will render
                                                    <div className="flex-1 flex col gap-2">
                                                      <h3>{data?.settings?.message1Heading}</h3>
                                                      <p>
                                                        {data?.settings?.message1Content}
                                                        <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                                                      </p>
                                                    </div>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        ) : (null)}
                                      </React.Fragment>
                                    )})}
                                  </div>
                                ) : (
                                  <div className="flex left wrap gap-y-4 variantCardList">
                                    <VariantCardSeeMore
                                      setchangeCustomizeOption={setchangeCustomizeOption}
                                      qty={qty}
                                      getApiCartOptions={getApiCartOptions}
                                      getDeliveryDate={getDeliveryDate}
                                      keyList={[key]}
                                      allData={allData}
                                      isSample={isSample}
                                      variantData={allData[key]}
                                      selected={selectedData}
                                      setSelected={setSelectedData}
                                      expandNext={setReqExpanded}
                                      selectedDetails={selectedDetails}
                                      setStopNextNav={setStopNextNav}
                                      handleExpandNext={handleExpandNext}
                                      selectedManualSizeData={selectedManualSizeData}
                                      setSelectedManualSizeData={setSelectedManualSizeData}
                                      setmanualsizestr={setmanualsizestr}
                                      setmanualsizelabel={setmanualsizelabel}
                                      manualsizelabel={manualsizelabel}
                                      translate={translateData?.translations}
                                      lastVariantKey={lastVariantKey}
                                      setsamplenextNav={setsamplenextNav}
                                    />
                                    {allData[key]?.options[0]?.label === "manual-size" ?
                                      <div className='variantCardList'>
                                        <Button onClick={() => {
                                          if (expanded === 0) setExpanded("0")
                                          const selectedD = { ...selectedData };
                                          setSelectedData(selectedD);
                                          setReqExpanded(true);
                                        }} className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'>{t("volgende")}</Button>
                                      </div>
                                      : null}
                                  </div>
                                )}
                              </React.Fragment> : null
                            }

                            {allData[key]?.options?.length > 1 && isSample && key === lastVariantKey ? (
                                <div className='variantCardList flex row gap-4'>
                                  <div>
                                  <Button
                                    onClick={() => {
                                      if (expanded === 0) setExpanded("0");
                                      const selectedD = { ...selectedData };
                                      setSelectedData(selectedD);
                                      setReqExpanded("cart");
                                      setShowError(false)
                                      setsamplenextNav(true);
                                      if(selectedD[key]?.length){
                                        setIsNextClicked(true);
                                      }
                                    }}
                                    className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'
                                  >
                                    {t("volgende")}
                                  </Button>
                                  </div>
                                  <div>
                                    {isSample && showError === true && key === lastVariantKey
                                           ?
                                        <p
                                          className='error-container pl-2 pt-4 no-translate notranslate'
                                          style={{ fontSize: '15px', color: 'rgb(255,0,0)', lineHeight: '36px' }}
                                        >
                                          {t("Klik op volgende om door te gaan")}
                                        </p>
                                        : ""
                                      } 
                                      </div>
                                </div>
                              ) : null}

 
                            {allData[key]?.mutiSelect ?
                              <div className='variantCardList'>
                                <Button onClick={() => {
                                  if (expanded === 0) setExpanded("0")
                                  const selectedD = { ...selectedData };
                                  setSelectedData(selectedD);
                                  setReqExpanded("cart");
                                }} className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'>{t("volgende")}</Button>
                              </div>
                              : null}
                          </AccordionDetails>
                        </Accordion>
                      </React.Fragment>
                    ) : !isSample && allData[key]?.thisType === "cpker" ? (
                      <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                        <div className={`accordion${item}`} />
                        {/* selectedColorData && Object.keys(selectedColorData).length) && Object.values(selectedColorData).some(array => array.length === 0) */}
                        <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                          <VariantHeader 
                             id={`${item}`} 
                             name={`${allData[key]?.label}`} 
                             isError={(cmsError == "false" && true)} 
                             expanded={expanded === `${item}`} 
                             order={item + 1} 
                             label="" 
                            //  completed={cmsError == "true" ? true : false} 
                             completed={ cmsError == "true" && !( !selectedColorData || Object.values(selectedColorData).every( arr => !arr || arr.every(item => item === undefined))) ? true : false}
                             translate={translateData?.translations} 
                             isValidTier={selectedDetailsFinal}
                              />

                          <AccordionDetails>
                            <div className="flex left wrap gap-y-4 cpList">
                              {selectedData[Object.keys(allData)[item - 1]]?.length ?
                                <React.Fragment key={`cpker${selectedData[Object.keys(allData)[item - 1]]?.length}`}>
                                  <div className='variantCardList w-1/1'>
                                    <VariantColorPicker
                                      keyList={key}
                                      product={{ selected: selectedData[Object.keys(allData)[item - 1]], data: allData[Object.keys(allData)[item - 1]].options }}
                                      selected={selectedData}
                                      setSelected={setSelectedData}
                                      setStopNextNav={setStopNextNav}
                                      selectedColorData={selectedColorData}
                                      setSelectedColorData={setSelectedColorData}
                                      openColorModel={openColorModel}
                                      setOpenColorModel={setOpenColorModel}
                                      selectedColorItem={selectedColorItem}
                                      setSelectedColorItem={setSelectedColorItem}
                                      colorDataList={translateData?.color_picker?.items}
                                      isColorPickerTierPrices={data?.settings?.xml}
                                      setCmsError={setCmsError}
                                      cmsError={cmsError}
                                    />
                                  </div>

                                  <div className='variantCardList w-1/1'>
                                    {cmsError == "false" && <p className='error no-translate notranslate'>{t("Kies een kleur om verder te gaan")}</p>}
                                    <Button
                                      onClick={() => {
                                        const selectedD = { ...selectedData };
                                        setSelectedData(selectedD);
                                        if (selectedD) {
                                          let isError = "true";

                                          selectedD?.[key]?.forEach(obj => {
                                            Object.values(obj).forEach(array => {
                                              array?.forEach(dataObj => {
                                                if (dataObj.color === "") isError = "false";
                                                else setReqExpanded(true);
                                              });
                                            });
                                          });
                                          setCmsError(isError);
                                        }
                                      }}
                                      className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'
                                    >
                                      {t("volgende")}
                                    </Button>
                                  </div>
                                </React.Fragment> : null}
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </React.Fragment>
                    ) : !isSample && allData[key]?.thisType === "additionalHeading" ? (
                      <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                        <div className={`accordion${item}`} />
                        <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                          <VariantHeader 
                             id={`${item}`} 
                             name={`${allData[key]?.label}`} 
                             isError={(parseInt(expanded) > item && !(selectedData?.[key]?.length)) || (expanded === `${item}` && expanded === errorOpenTab)} 
                             expanded={expanded === `${item}`} label={selectedData[key]?.length ? selectedData[key]?.join(", ") : ""} 
                             order={item + 1} 
                             completed={selectedData?.[key]?.length} 
                             translate={translateData?.translations}
                             isValidTier={selectedDetailsFinal}
                             />
                           
                          <AccordionDetails>
                            <div className="flex left wrap gap-y-4 variantCardList">
                              {allData[key]?.options?.length > 0 &&
                                allData[key]?.options.map((item, index) => {
                                  const variantData = allData[key]?.data?.[selectedDetails[key]?.variant];
                                  const availableName = variantData && Object.keys(variantData).length > 0 ? [...Object.keys(variantData), "geen opdruk"] : [];
                                  const isSelected = selectedData[key]?.includes(item);
                                  return (
                                    <>
                                   {(!availableName?.length || availableName?.includes(item)) && <button
                                      aria-label="button"
                                      className={`heading_button flex col gap-2 ${isSelected ? "selected" : "unselected"}`}
                                      key={item}
                                      style={{ display : item.toLowerCase() === "geen opdruk" && data?.settings?.imprint_required == "1" ? "none" : "block"}}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setStopNextNav(true);
                                        setReqExpanded(false);
                                        setSelectedData((prev) => {
                                          const currentSelection = prev[key] || [];
                                          let newSelection;
                                    
                                          if (item === "geen opdruk") {
                                            newSelection = currentSelection.includes("geen opdruk") ? [] : ["geen opdruk"];
                                          } else {
                                            const filtered = currentSelection.filter((val) => val !== "geen opdruk");
                                            newSelection = currentSelection.includes(item)
                                              ? filtered.filter((val) => val !== item)
                                              : [...filtered, item];
                                          }
                                          return {
                                            ...prev,
                                            [key]: newSelection,
                                          };
                                        });
                                      }}
                                    >
                                      {translateData?.translations?.[`${item}`.toLowerCase()] ? translateData?.translations[`${item}`.toLowerCase()] : item}
                                    </button>}
                                    </>
                                  );
                                })}
                            </div>
                            <Button onClick={() => {
                              const selectedD = { ...selectedData };
                              setSelectedData(selectedD);
                              if (selectedData?.[key]?.length) {
                                setReqExpanded(true);
                              }
                              else {
                                setReqExpanded("cart");
                              }
                            }} className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary no-translate notranslate'>{t("volgende")}</Button>

                          </AccordionDetails>
                        </Accordion>
                      </React.Fragment>
                    )

                      : !isSample && allData[key]?.thisType === "customize" ? (
                        <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                          <div className={`accordion${item}`} />
                          <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                            <VariantHeader 
                               id={`${item}`} 
                               name={`${allData[key]?.label}`} 
                               isError={(parseInt(expanded) > item && !(selectedData?.[key]?.length > 4)) || inputFieldExpand || (expanded === `${item}` && expanded === errorOpenTab)} 
                               expanded={expanded === `${item}`} label={(allData[key]?.varientType === "area" || allData[key]?.varientType === "field") ? isBase64Encoded(selectedDetails[key]?.labels?.join("")) : selectedDetails[key]?.labels?.length ? selectedDetails[key]?.labels?.join(", ") : allData[key]?.is_require === false ? "optioneel" : ""} 
                               order={item + 1} 
                               completed={selectedData?.[key]?.length} 
                               translate={translateData?.translations}
                               isValidTier={selectedDetailsFinal}
                               isRequiredError={isRequiredError}
                                />

                            <AccordionDetails>
                              <div className="flex left wrap gap-y-4 variantCardList">
                                {allData[key]?.varientType === "field" || allData[key]?.varientType === "area" ?
                                  <div className='pt-3 pb-3 w-1/1 flex col gap-2'>
                                    {allData[key]?.options?.[key]?.[0]?.custom_option_description ? <p>{allData[key].options[key][0].custom_option_description}</p> : null}
                                    {allData[key]?.options?.[0]?.custom_option_description ? <p>{allData[key].options[0].custom_option_description}</p> : null}
                                    <InputTextBox allData={allData} setInputFieldExpand={setInputFieldExpand} selectedData={selectedData} setSelectedData={setSelectedData} keyName={key} placeholder={"Typ hier..."} setInputManualSize={setInputManualSize} expanded={expanded} setExpanded={setExpanded} setStopNextNav={setStopNextNav} />
                                    <div>
                                    </div>
                                  </div> : allData[key]?.options ?
                                    <>
                                      {allData[key]?.options?.[key]?.[0]?.custom_option_description ? <p>{allData[key].options[key][0].custom_option_description}</p> : null}
                                      {allData[key]?.options?.[0]?.custom_option_description ? <p>{allData[key].options[0].custom_option_description}</p> : null}

                                      <CustomizeCardRoot
                                        selectedDetailsFinal={selectedDetailsFinal}
                                        setQty={setQty}
                                        storeId={storeId}
                                        keyList={[key]}
                                        setchangeCustomizeOption={setchangeCustomizeOption}
                                        variantData={allData[key]}
                                        selected={selectedData}
                                        setSelected={setSelectedData}
                                        expandNext={setReqExpanded}
                                        handleExpandNext={handleExpandNext}
                                        setStopNextNav={setStopNextNav}
                                        translate={translateData?.translations}
                                        getDeliveryDate={getDeliveryDate}
                                        getApiCartOptions={getApiCartOptions}
                                        qty={qty}
                                        qtymatch={qtymatch}
                                        isImPrintRequired={selectedDetails[key]?.imprint_required}
                                        wholeDataOfSubGroup={allData[key]?.options}
                                        setIsRequiredError={setIsRequiredError}
                                        setShowErrorAdditional={setShowErrorAdditional}
                                      />
                                    </>
                                    : null
                                }
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </React.Fragment>
                      ) : !isSample && allData[key]?.thisType === "additional" && selectedDetails[key]?.hide !== true ? (
                       <>
                       {allData[key]?.isGroupAvailable ? 
                          <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                          <div className={`accordion${item}`} />
                          <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                            <VariantHeader 
                               id={`${item}`} 
                               name={`${allData[key]?.label}`} 
                               isError={(parseInt(expanded) > item && !(selectedData?.[key]?.length > 4)) || inputFieldExpand || (expanded === `${item}` && expanded === errorOpenTab)} 
                               expanded={expanded === `${item}`} 
                               label={(allData[key]?.varientType === "area" || allData[key]?.varientType === "field") ? isBase64Encoded(selectedDetails[key]?.labels?.join("")) : selectedDetails[key]?.labels?.length ? selectedDetails[key]?.labels?.join(", ") : allData[key]?.is_require === false ? "optioneel" : ""} 
                               order={item + 1} 
                               completed={selectedData?.[key]?.length} 
                               translate={translateData?.translations} 
                               isValidTier={selectedDetailsFinal}
                               />

                            <AccordionDetails>
                              <div className="flex left wrap gap-y-4 variantCardList">
                                {allData[key]?.varientType === "field" || allData[key]?.varientType === "area" ?
                                  <div className='pt-3 pb-3 w-1/1 flex col gap-2'>
                                    {allData[key]?.options?.[key]?.[0]?.custom_option_description ? <p>{allData[key].options[key][0].custom_option_description}</p> : null}
                                    {allData[key]?.options?.[0]?.custom_option_description ? <p>{allData[key].options[0].custom_option_description}</p> : null}
                                    <InputTextBox allData={allData} setInputFieldExpand={setInputFieldExpand} selectedData={selectedData} setSelectedData={setSelectedData} keyName={key} placeholder={"Typ hier..."} setInputManualSize={setInputManualSize} expanded={expanded} setExpanded={setExpanded} setStopNextNav={setStopNextNav} />
                                    <div>
                                    </div>
                                  </div> : allData[key]?.options ?
                                    <>
                                      {allData[key]?.options?.[key]?.[0]?.custom_option_description ? <p>{allData[key].options[key][0].custom_option_description}</p> : null}
                                      {allData[key]?.options?.[0]?.custom_option_description ? <p>{allData[key].options[0].custom_option_description}</p> : null}

                                      {(() => {
                                            const keys = key;
                                            const filteredKeys = allData[key]["data"][selectedDetails[key]["variant"]] && Object.keys(allData[key]["data"][selectedDetails[key]["variant"]])
                                              .filter(k => selectedData?.["position"]?.includes(k));

                                            const processedData = Object.fromEntries(
                                              (filteredKeys || []).map(k => [
                                                k, allData?.[key]?.["data"]?.[selectedDetails?.[key]?.["variant"]]?.[k] ?? {}
                                              ])
                                            );
                                            const shouldUseFilteredData = Object.values(processedData).length > 0; // Condition check

                                            const finalData = shouldUseFilteredData
                                              ? processedData
                                              : allData[key]["data"][selectedDetails[key]["variant"]];
                                              
                                            return (
                                              <>
                                              <CustomizeCardRoot
                                                    selectedDetailsFinal={selectedDetailsFinal}
                                                    setQty={setQty}
                                                    storeId={storeId}
                                                    keyList={[keys]}
                                                    setchangeCustomizeOption={setchangeCustomizeOption}
                                                    variantData={{...allData[key],options:finalData}}
                                                    selected={selectedData}
                                                    setSelected={setSelectedData}
                                                    expandNext={setReqExpanded}
                                                    handleExpandNext={handleExpandNext}
                                                    setStopNextNav={setStopNextNav}
                                                    translate={translateData?.translations}
                                                    getDeliveryDate={getDeliveryDate}
                                                    getApiCartOptions={getApiCartOptions}
                                                    qty={qty}
                                                    qtymatch={qtymatch}
                                                    isImPrintRequired={selectedDetails[key]?.imprint_required}
                                                    wholeDataOfSubGroup={allData[key]?.options}
                                                    setIsRequiredError={setIsRequiredError}
                                                    setShowErrorAdditional={setShowErrorAdditional}
                                                  />
                                              </>

                                            )
                                          })()}
                                    </>
                                    : null
                                }
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        </React.Fragment> :
                        <React.Fragment key={`Fragment_${key}_${allData[key]?.label}_${item}`}>
                            <div className={`accordion${item}`} />
                            <div className={`additionalSubGroupListEle`} />
                            <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                            <VariantHeader 
                              id={`${item}`}
                              additional={true} 
                              name={`${allData?.[key]?.label}`} 
                              isError={(parseInt(expanded) > item && !([selectedDetails?.[key]?.variant] && allData?.[key]?.data?.[selectedDetails?.[key]?.variant] && Object.keys(allData?.[key]?.data?.[selectedDetails?.[key]?.variant] || {})?.length > 1 ? (showErrorAdditional && selectedData?.[key]?.length) : selectedData?.[key]?.length)) || (expanded === `${item}` && expanded === errorOpenTab) || inputFieldExpand}
                              expanded={expanded === `${item}`} label={(allData?.[key]?.varientType === "area" || allData?.[key]?.varientType === "field") ? isBase64Encoded(selectedDetails?.[key]?.labels?.join("")) : selectedDetails?.[key]?.labels?.length ? selectedDetails?.[key]?.labels?.join(", ") : allData?.[key]?.is_require === false ? "optioneel" : ""} 
                              order={item + 1} 
                              completed={[selectedDetails?.[key]?.variant] && allData?.[key]?.data?.[selectedDetails?.[key]?.variant] && Object.keys(allData?.[key]?.data?.[selectedDetails?.[key]?.variant] || {})?.length > 1 ? (!isRequiredError?.value && showErrorAdditional && selectedData?.[key]?.length) : !isRequiredError?.value && selectedData?.[key]?.length} 
                              translate={translateData?.translations} 
                              isRequiredError={isRequiredError}
                              selectedItem={selectedData}
                              isValidTier={selectedDetailsFinal}
                              />
                              <AccordionDetails>
                                <div ref={accordionRef} className="flex left wrap gap-y-4 additionalSubGroupList variantCardList">
                                  {selectedDetails?.[key]?.["variant"] && allData[key]?.["data"]?.[selectedDetails[key]["variant"]] && Object.keys(allData[key]["data"][selectedDetails[key]["variant"]]).length ?
                                    <>
                                      {allData[key]?.varientType === "field" || allData[key]?.varientType === "area" ?
                                        <div className='pt-3 pb-3 w-1/1 flex col gap-2'>
                                          {allData[key]?.options?.[key]?.[0]?.custom_option_description ? <p>{allData[key].options[key][0].custom_option_description}</p> : null}
                                          {allData[key]?.options?.[0]?.custom_option_description ? <p>{allData[key].options[0].custom_option_description}</p> : null}
                                          <InputTextBox allData={allData} setExpanded={setExpanded} setInputFieldExpand={setInputFieldExpand} selectedData={selectedData} setSelectedData={setSelectedData} keyName={key} placeholder={"Typ hier..."} setInputManualSize={setInputManualSize} setStopNextNav={setStopNextNav} />
                                          <div>
                                          </div>
                                        </div>
                                        : allData[key]?.options ?
                                          <>
                                            {(() => {
                                              const keys = key;
                                              const Item = item;
                                              const AllDataKey = allData[key];
                                              const filteredKeys = Object.keys(allData[key]["data"][selectedDetails[key]["variant"]])
                                                .filter(k => selectedData?.["position"]?.includes(k));

                                            
                                              const processedData = Object.fromEntries(
                                                (filteredKeys || []).map(k => [
                                                  k, allData?.[key]?.["data"]?.[selectedDetails?.[key]?.["variant"]]?.[k] ?? {}
                                                ])
                                              );
                                              const shouldUseFilteredData = Object.values(processedData).length > 0; // Condition check

                                              const finalData = shouldUseFilteredData
                                                ? processedData
                                                : allData[key]["data"][selectedDetails[key]["variant"]];
                                              return (
                                                <>

                                                  <AdditionalSubGroupList
                                                    setIsRequiredError={setIsRequiredError}
                                                    setShowErrorAdditional={setShowErrorAdditional}
                                                    setchangeCustomizeOption={setchangeCustomizeOption}
                                                    getApiCartOptions={getApiCartOptions} getDeliveryDate={getDeliveryDate}
                                                    key={`additionalSubGroup_${Item}`}
                                                    keyList={[keys]}
                                                    name={AllDataKey?.label}
                                                    data={finalData}
                                                    variantId={selectedDetails[key]["variant"]}
                                                    selected={selectedData}
                                                    setSelected={setSelectedData}
                                                    expandNext={setReqExpanded}
                                                    stopNextNav={stopNextNav}
                                                    setStopNextNav={setStopNextNav}
                                                    setOpenModel={setOpenModelUPS}
                                                    setOpenModelInfo={setOpenModelInfo}
                                                    setServicesDetailsData={setServicesDetailsData}
                                                    translate={translateData?.translations}
                                                    qty={qty}
                                                    isImPrintRequired={selectedDetails[key]?.imprint_required}
                                                    wholeDataOfSubGroup={Object.keys(allData[key]?.options)?.length ? allData[key]?.data[selectedDetails[key]["variant"]] : Object.values(allData[key]?.data)}
                                                  />
                                                </>

                                              )
                                            })()}

                                            <div>
                                              <Button onClick={() => {
                                                const selectedD = { ...selectedData };
                                                setSelectedData(selectedD);
                                                if (selectedData?.[key]?.length) {
                                                  setReqExpanded(true);
                                                }
                                                else {
                                                  setReqExpanded("cart");
                                                }
                                                // const variant = selectedDetails?.[key]?.variant;
                                                // const variantData = allData?.[key]?.data?.[variant];
                                                // const hasMultipleOptions = variantData && Object.keys(variantData || {}).length > 1;
                                                // const selectedLength = selectedData?.[key]?.length;

                                                // const completed = hasMultipleOptions
                                                //   ? (showErrorAdditional && selectedLength)
                                                //   : selectedLength;

                                                // if (completed && !isRequiredError?.value) {
                                                //   setShouldScroll(true);
                                                // }

                                              }} className='contained sm mt-4 mb-2 py-2 px-4 r-9 primary'>volgende</Button>
                                            </div>
                                          </> : null
                                      }

                                    </> : null
                                  }
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          </React.Fragment>
                              }
                       </>
                      ) : !isSample && key === "qty" ? (
                        <React.Fragment key={`Fragmentqty`}>
                          <div className={`accordion${item}`} id={`${item}`} data-id={`${typeof expanded}:${typeof `${item}`} ${expanded}:${item}`} />
                          <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)}>
                            <VariantHeader 
                               id={`${item}`} 
                               name={`${allData[key]?.label}`} 
                               isError={(parseInt(expanded) > item && (!(customQty && qty > 0) || !(isCustomQty && qty > 0))) || (expanded === `${item}` && expanded === errorOpenTab)} 
                               expanded={expanded === `${item}`} 
                               label={selectedDetails[key]?.labels}
                              // order={selectedDetails?.["upload"]?.hide === true ? (item - (selectedDetails[key]?.reduseCount || 0)) : (item + 1 - (selectedDetails[key]?.reduseCount || 0))}
                              order={allData["position"]?.options?.length && allData["position"]?.options?.length > 1 && !selectedData?.["position"]?.length ? item:!selectedData?.["position"]?.includes("geen opdruk") ?item + 1:item}
                              completed={isCustomQty ? qty > 0 && customQty : qty > 0 && customQty} 
                              translate={translateData?.translations} 
                              showError={showError}
                              isValidTier={selectedDetailsFinal}
                               />

                            {(selectedDetailsFinal?.tier_prices?.length || selectedDetailsFinal?.not_matched_tier_prices?.length > 0 || (qtyData.addOnPrice > 0 || (!selectedDetailsFinal?.tier_prices?.length && (selectedDetailsFinal?.price > 0)))) ?
                              <AccordionDetails>
                                <div className="flex w-1/1 qtyTable1 qty-section" ref={scrollTargetRef}>
                                  <div className="table-head">
                                    <div className="table-row table-row-title">
                                      <div className="item-cell">{t("Aantal")}</div>
                                      <div className="item-cell"><i>{t("Bespaar")}</i></div>
                                      <div className="item-cell">{t("Stuksprijs")}</div>
                                      {width <= 768 ?
                                        <div className="item-cell">{t("Totaalprijs")}</div>
                                        :
                                        <div className="item-cell">{t("Totaal (excl. BTW)")}</div>
                                      }
                                    </div>
                                  </div>

                                  <div className="table-body">
                                  {(selectedDetailsFinal?.not_matched_tier_prices?.length > 0 || selectedDetailsFinal?.tier_prices?.length > 0) &&
                                  (uniquePrices([...(selectedDetailsFinal?.not_matched_tier_prices || []), ...(selectedDetailsFinal?.tier_prices || [])].sort((a, b) => a.qty - b.qty)).map((item, i) => {
                                    return(
                                        <React.Fragment key={i}>
                                          {item?.hide ?  <div key={`qty_no_${i}`} className={`relative table-row ${item.hide || ""}`}>
                                        <div className="item-cell " data-label="Quantity">
                                          <div className='flex middle gap-4'>
                                            <input aria-label="checkbox" type="checkbox" readOnly checked={false} />
                                            <span className='span'></span>
                                            <span>{item.hide ? item.q : item?.qty}</span>
                                          </div>
                                        </div>
                                        <div className="item-cell" data-label="Save"> - </div>
                                        <div className="item-cell" data-label="Price"> - </div>
                                        <div className="item-cell" data-label="Total"> - </div>
                                      </div> :
                                     
                                        <div key={`qty_${i}`} className={`relative table-row`} onClick={() => {
                                          const option = getApiCartOptions()
                                          setTimeout(() => {
                                            getDeliveryDate(option, item.qty)
                                          }, 1000)
                                          setQtyTemp(item.qty); setIsCustomQty(false); setReqExpanded(false); setQty(item.qty)
                                        }}>
                                          <div className="item-cell " data-label="Quantity">
                                            <div className='flex middle gap-4'>
                                              <input type="checkbox" aria-label="checkbox" readOnly checked={!isCustomQty && qtyTemp === item.qty} />
                                              <span className='span'></span>
                                              <span>{item?.qty}</span>
                                            </div>
                                          </div>
                                          <div className="item-cell" data-label="Save">
                                           {(() => {
                                                  const tierPrice = selectedDetailsFinal.tier_prices?.[0]?.price || 0;
                                                  const itemPrice = item?.price || 0;
                                                  const addOn = qtyData?.addOnPrice || 0;
                                                  const basePrice = tierPrice + addOn;

                                                  if (basePrice === 0) {
                                                    return <span className="hypen">-</span>;
                                                  }

                                                  const discount = (((tierPrice + addOn) - (itemPrice + addOn)) / basePrice) * 100;

                                                  if (isNaN(discount) || discount === 0) {
                                                    return <span className="hypen">-</span>;
                                                  }

                                                  return (
                                                    <>
                                                      {Math.round(discount)}
                                                      <span>%</span>
                                                    </>
                                                  );
                                                })()}
                                          </div>
                                          <div className="item-cell no-translate notranslate " data-label="Price">
                                            {`${item.hide ? "-" : euroCurrency(parseFloat((item?.price || 0) + qtyData.addOnPrice).toFixed(2))}`}
                                          </div>
                                          <div className="item-cell no-translate notranslate" data-label="Total">
                                            {`${item.hide ? "-" : euroCurrency(parseFloat((parseFloat((item?.price || 0) + qtyData.addOnPrice).toFixed(2)) * item.qty).toFixed(2))}`}
                                          </div>
  
                                        </div> }
                                      </React.Fragment>
                                              )})
                                          )}

                                    <div className={`relative text-row table-row`} onClick={() => {
                                      if (selectedDetailsFinal?.tier_prices?.length) {
                                        setIsCustomQty(true)
                                      };
                                    }}>
                                      <div className="item-cell" data-label="Quantity">
                                        <div className={`flex middle gap-4 ${isCustomQty ? "custom" : ""}`}>
                                          <input type="checkbox" aria-label="checkbox" readOnly checked={isCustomQty} />
                                          <span className='span'></span>

                                          <div className="input__container flex center">
                                            <button
                                                onClick={() => {
                                                  const newQtyTemp = qtyTemp - (selectedDetailsFinal?.qty_increments || 1);

                                                  if (newQtyTemp < 0) {
                                                    setQtyTemp(0);
                                                  } else {
                                                    const enteredQty = parseInt(newQtyTemp) || 0;
                                                    const tierPrices = selectedDetailsFinal?.not_matched_tier_prices || [];
                                                    const hasMatchingTierPrice = tierPrices.some(tier => tier.qty === enteredQty);

                                                    if (hasMatchingTierPrice && enteredQty > 0) {
                                                      setQtyTemp('');
                                                    } else {
                                                      setQtyTemp(newQtyTemp);
                                                      UpdateTextQty(
                                                        newQtyTemp,
                                                        selectedDetailsFinal,
                                                        setQty,
                                                        setQtyTemp,
                                                        getDeliveryDate,
                                                        getApiCartOptions
                                                      );
                                                    }
                                                  }
                                                }}
                                                aria-label="button"
                                              >
                                                -
                                              </button>

                                            <input className="text-qty" type="text" placeholder="0" style={{ width: "100%", zIndex: isCustomQty ? 1 : 0, position: "relative", border: "0", textAlign: "center" }}

                                              value={isCustomQty ? qtyTemp : ''}
                                              onChange={(e) => {
                                                let value = e.target.value;

                                                if (!isNaN(value)) {
                                                  value = value.slice(0, 6);
                                                  setQtyTemp(value);
                                                }
                                              }}
                                              // onChange={(e) => {
                                              //   let value = parseFloat(e.target.value);

                                              //   if (!isNaN(value)) {
                                              //     const increment = selectedDetailsFinal?.qty_increments || 1;

                                              //     // Adjust value to the nearest multiple of qty_increments
                                              //     const nearestMultiple = Math.round(value / increment) * increment;

                                              //     if (nearestMultiple >= 0) {
                                              //       setQtyTemp(nearestMultiple.toString().slice(0, 6)); // Update qtyTemp with nearest multiple
                                              //     }
                                              //   }
                                              // }}

                                              onKeyDown={(e) =>
                                                (e.key === 'Enter') && UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions)
                                              }
                                              // onBlur={() =>
                                              //   UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions)
                                              // }

                                              onBlur={() => {
                                              if (qtyTemp && qtyTemp !== '') {
                                                const enteredQty = parseInt(qtyTemp) || 0;
                                                const tierPrices = selectedDetailsFinal?.not_matched_tier_prices || [];
                                                const hasMatchingTierPrice = tierPrices.some(tier => tier.qty === enteredQty);
                                                
                                                if (hasMatchingTierPrice && enteredQty > 0) {
                                                  setQtyTemp(''); 
                                                // const minQty = Math.min(...matchedtierPrices.map(tier => tier.qty));
                                                // setQtyTemp(minQty.toString());
                                                } else{
                                                  UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
                                                }
                                              }
                                            }}	
                                            />
                                            <button
                                              onClick={() => {
                                                const newQtyTemp = qtyTemp + (selectedDetailsFinal?.qty_increments || 1);
                                                if (newQtyTemp > 50000) {
                                                  setQtyTemp(50000);
                                                }
                                                else {
                                                  setQtyTemp(newQtyTemp);
                                                }


                                                  const enteredQty = parseInt(newQtyTemp) || 0;
                                                  const tierPrices = selectedDetailsFinal?.not_matched_tier_prices || [];
                                                  const hasMatchingTierPrice = tierPrices.some(tier => tier.qty === enteredQty);

                                                  if (hasMatchingTierPrice && enteredQty > 0) {
                                                    setQtyTemp('');
                                                  } else {
                                                    UpdateTextQty(
                                                      newQtyTemp,
                                                      selectedDetailsFinal,
                                                      setQty,
                                                      setQtyTemp,
                                                      getDeliveryDate,
                                                      getApiCartOptions
                                                    );
                                                  }
                                              }
                                              }
                                              aria-label="button"
                                            >
                                              +
                                            </button>

                                          </div>

                                          <button aria-label="button" onClick={() => {
                                            if (selectedDetailsFinal?.tier_prices?.length) {
                                              setIsCustomQty(true)
                                            };
                                            const newQtyTemp = qtyTemp + (selectedDetailsFinal?.qty_increments || 1);
                                            if (newQtyTemp > 50000) {
                                              setQtyTemp(50000);
                                            }
                                            else {
                                              setQtyTemp(newQtyTemp);
                                            }
                                            // if (selectedDetailsFinal?.qty_increments > 1 && isCustomQty) {
                                            //   setReqExpanded(false);
                                            // }
                                            UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
                                            // setTimeout(() => {
                                            //   if (selectedDetailsFinal?.qty_increments > 1 && warningMessage == "") {
                                            //     setReqExpanded(false);
                                            //   }

                                            // })
                                          }}></button>
                                        </div>
                                      </div>
                                      {isCustomQty ? (
                                        <React.Fragment>
                                          <div className="item-cell middle" data-label="Save">
                                            <i>
                                              {qtyTemp > selectedDetailsFinal?.tier_prices?.[0]?.qty && selectedDetailsFinal?.tier_prices?.length
                                                ? (() => {
                                                  const priceDiff = Math.round(
                                                    ((((selectedDetailsFinal.tier_prices[0].price || 0) + qtyData.addOnPrice) -
                                                      (qtyData?.price?.toFixed(2) || 0)) /
                                                      ((selectedDetailsFinal.tier_prices[0].price || 0) + qtyData.addOnPrice)) * 100
                                                  );
                                                  return priceDiff === 0 ? '-' : `${priceDiff}%`;
                                                })()
                                                : '-'}
                                            </i>
                                          </div>

                                          <div className="item-cell middle no-translate notranslate" data-label="Price">{`${euroCurrency(qtymatch(qtyTemp, selectedDetailsFinal?.tier_prices?.length ? selectedDetailsFinal?.tier_prices : selectedDetailsFinal?.price) + qtyData.addOnPrice || selectedDetailsFinal?.price)}`}</div>
                                          <div className="item-cell middle no-translate notranslate" data-label="Total">{`${euroCurrency((qtymatch(qtyTemp, selectedDetailsFinal?.tier_prices?.length ? selectedDetailsFinal?.tier_prices : selectedDetailsFinal?.price) + qtyData.addOnPrice || selectedDetailsFinal?.price) * qtyTemp)}`}</div>
                                        </React.Fragment>
                                      ) : (
                                        <React.Fragment>
                                          <div className="item-cell flex middle no-translate notranslate" data-label="Save">{t("Anderaantal")}</div>
                                          <div className="item-cell flex middle" data-label="Price">-</div>
                                          <div className="item-cell flex middle" data-label="Total">-&nbsp;</div>
                                        </React.Fragment>
                                      )}
                                    </div>
                                  </div>
                                  <div className='py-2 flex middle'>
                                    <button aria-label="button" onClick={() => {
                                      if (qty > 0) {
                                        setShowError(true)
                                        const selectedD = { ...selectedData };
                                        setSelectedData(selectedD);
                                        setReqExpanded(true);
                                        setcustomQty(true)
                                        UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
                                        }else {
                                       setShowError(true)
                                       }
                                    }}
                                      className='contained sm mt-4  py-2 px-4 r-9 primary no-translate notranslate'
                                    >
                                      {t("volgende")}
                                    </button>
                                    {
                                      (!showError && (parseInt(expanded) > item && (!(customQty && qty > 0) || !(isCustomQty && qty > 0))) ||
                                        !showError && (expanded === `${item}` &&
                                          expanded === errorOpenTab &&
                                          (!(isCustomQty ? customQty && qty > 0 : customQty && qty > 0)))) && (completed === true && qty > 0) && (
                                        <p
                                          className='pl-4 pt-4 no-translate notranslate'
                                          style={{ fontSize: '15px', color: 'rgb(255,0,0)', lineHeight: '30px' }}
                                        >
                                          {t("Klik op volgende om door te gaan")}
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </AccordionDetails>
                              : null}
                          </Accordion>
                        </React.Fragment>
                      )
                        : !isSample && key === "upload" && selectedDetails[key]?.hide !== true ? (
                          <React.Fragment key={`Fragment_upload`}>
                            <div className={`accordion${item}`} />
                            <Accordion expanded={expanded === `${item}`} onChange={handleExpanded(`${item}`)} >
                             <VariantHeader 
                                id={`${item}`} 
                                name={`${allData[key]?.label}`} 
                                isError={textAreaData?.trim() === "" && ((parseInt(expanded) > item && (!selectedData?.[key]?.[0] && !imagesDropbox?.length)) || (expanded === `${item}` && expanded === errorOpenTab) || reqExpandedUpload === false )} 
                                expanded={expanded === `${item}` ||(!selectedData?.[key]?.length && !imagesDropbox?.length && textAreaData?.trim() === "")} 
                                label={ selectedDetails[key]?.labels && selectedDetails[key].labels !== "Bestanden geupload" ? selectedDetails[key].labels : imagesDropbox?.length ? "Bestanden geupload" : ""} 
                                order={(item + 1 - (selectedDetails[key]?.reduseCount || 0))} 
                                // completed={ selectedData?.[key]?.length || imagesDropbox?.length || textAreaData?.trim() !== ""} 
                                completed={(
                                    (!selectedDetails[key]?.labels || 
                                    selectedDetails[key]?.labels === "" || 
                                    selectedDetails[key]?.labels === "Bestanden geupload") &&
                                    textAreaData?.trim() === "" &&
                                    !imagesDropbox?.length
                                  )
                                    ? false
                                    : (
                                        selectedData?.[key]?.length > 0 ||
                                        imagesDropbox?.length > 0 ||
                                        textAreaData?.trim() !== ""
                                      )
                                }
                                translate={translateData?.translations}
                                isValidTier={selectedDetailsFinal}
                                />

                              <AccordionDetails>
                                <Suspense fallback={<CircularProgress />}>
                                  <UploadImages
                                    files={files}
                                    setFiles={setFiles}
                                    customOptions={customOptions}
                                    setreqExpandedUpload={setreqExpandedUpload}
                                    textAreaData={textAreaData}
                                    setTextData={setTextData}
                                    isSample={isSample}
                                    deliveryData={deliveryData}
                                    dropboxFiles={dropboxFiles} setDropboxFiles={setDropboxFiles}
                                    imagesDropboxHome={imagesDropbox} setImagesDropboxHome={setImagesDropbox}
                                    openModel={openModelUpload} setOpenModel={setOpenModelUpload}
                                    data={data}
                                    selectedData={selectedData} setSelectedData={setSelectedData}
                                    selectedKey={key} allData={allData} imageCanvasTemplate={imageCanvasTemplate}
                                    stateUploadedPath={stateUploadedPath} setStateUploadedPath={setStateUploadedPath}
                                    expandNext={setReqExpanded}
                                    isUploadOpen={expanded === `${item}`}
                                  />
                                </Suspense>
                              </AccordionDetails>
                            </Accordion>
                          </React.Fragment>
                        )
                          : null}
                  </React.Fragment>
                ))}
              </React.Fragment>
            ) : null}
          </div>                                     
          {Object.keys(allData).map((key, item) => {
           let isValidSampleAtLast =Object.keys(allData)?.includes("qty") ? "" : Object.keys(allData).map((key,item) => Object.values(allData)[item])?.[0]?.variantDatas?.slice(-1)?.[0] 
           setIsValidSampleAtLast(isValidSampleAtLast)
            return(
            <React.Fragment key={`alldata_${key}_${item}`}>
              {(((storeId === 1 && key === "qty" && expanded === `${item}`) 
              && (selectedDetailsFinal?.tier_prices?.length && data?.settings?.allowed_sample === "1")) 
              || (key === "qty" && isSample)  
              || (data?.isTextileProduct == "1" && isValidSampleAtLast === key && isSample)
            ) ? (
                <div className='sampleForm'>
                  <div className="content">
                    <div className="flex w-1/1 gap-3">
                      <div className="flex-0 checkbox">
                        <input type="checkbox" aria-label="checkbox" checked={isSample} readOnly />
                        <button aria-label="button" 
                        onClick={() => {
                            if (!isSample) {
                              setSelectedData(prev => ({
                                ...prev,
                                isSample: [],
                              }));
                             setQty(0);
                            } else {
                              setSelectedData(prev => ({
                                ...prev,
                                isSample: ["true"],
                              }));
                              setQty(0);
                            }
                            setIsSample(!isSample); 
                          }}
                          >
                          </button>
                      </div>
                     
                      {sampleProductPrice?.condition_two ?
                        <div className="flex-1 flex col gap-2" >
                          <h3>{data?.settings?.message2Heading}</h3>
                          <p>
                            {data?.settings?.message2Content}
                            <p className='refund-icon'>
                              <RefundIcon />
                              <b>
                                {data?.settings?.message2HighlightedText}
                              </b>
                            </p>
                            <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                          </p>
                        </div>
                        :
                        sampleProductPrice?.condtion_three ?
                          <div className="flex-1 flex col gap-2" >
                            <h3>{data?.settings?.message3Heading}</h3>
                            <p>
                              {data?.settings?.message3Content}
                              <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                            </p>
                          </div> :
                          //condition one and if condition not satisfied it will render
                          <div className="flex-1 flex col gap-2">
                            <h3>{data?.settings?.message1Heading}</h3>
                            <p>
                              {data?.settings?.message1Content}
                              <span className='pointer' onClick={() => setOpenFreeSample(true)}>{data?.settings?.hyperlink_text}</span>
                            </p>
                          </div>
                      }
                    </div>
                  </div>
                </div>
              ) : (null)}
            </React.Fragment>
          )})}
        </div>

        {displayAfterRender &&
          <div className='flex col w-1/1 gap-6 pt-6'>
            {deliveryData && deliveryData ? (
              <>
                <div className={`deliveryTime ${isOutOfStock ? "deliverytime_red" : ""}`}>
                  <div className="content ">
                    <div className="flex w-1/1 gap-3">
                      <div className="flex-0">
                        <div className="icon">
                          <AccessTimeIcon />
                        </div>
                      </div>                   

<div className="flex-1">
  <div className={`flex col gap-2`} style={{ display: isSample ? 'flex' : 'none' , display: isSample ? "block" : "none" }}>
    {!deliveryData?.text?.includes("onbekend") && (
      <div className='flex middle'>
        <h3 className='pb-2'>
          Verstuurd na: {selectedDetailsFinal.delivery ? selectedDetailsFinal.delivery : `ongeveer ${deliveryData?.working_days == 0 ? "zelfde" : deliveryData?.working_days} werkdag(en)`}
        </h3>
        <span onClick={() => setOpenModelDelivery(true)} 
        role='button'
        aria-label='info-icon'
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setOpenModelDelivery(true)}
        className="ml-2 infoimgs relative pointer">
          <InfoPdpIcon role="presentation" />
        </span>
      </div>
    )}
    <p style={{ fontWeight: "300" }} dangerouslySetInnerHTML={{ __html: deliveryData?.text }}></p>
  </div>

  <div className={`flex col gap-2`} style={{ display: !isSample ? 'flex' : 'none' , display: !isSample ? "block" : "none" }}>
    {!deliveryData?.text?.includes("onbekend") && (
      <div className='flex middle'>
        <h3 className='pb-2'>
          Verstuurd na: {selectedDetailsFinal.delivery ? selectedDetailsFinal.delivery : `ongeveer ${deliveryData?.working_days == 0 ? "zelfde" : deliveryData?.working_days} werkdag(en)`}
        </h3>
        <span onClick={() => setOpenModelDelivery(true)} 
        role='button'
        aria-label='info-icon'
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setOpenModelDelivery(true)}
         className="ml-2 infoimgs relative pointer">
          <InfoPdpIcon role="presentation" />
        </span>
      </div>
    )}
    <p style={{ fontWeight: "300" }} dangerouslySetInnerHTML={{ __html: deliveryData?.text }}></p>
  </div>
</div>

                    </div>
                  </div>
                </div>
                <DeliveryInfo isSample={isSample} deliveryData={deliveryData} openModel={openModelDelivery} setOpenModel={setOpenModelDelivery} data={data?.settings} />
              </>
            ) : null}
            <div className='scrollAfterFinish flex col w-1/1 gap-3'>
              <Accordion expanded={expandPrice} onChange={() => null}>
                <AccordionSummary className='hide' aria-controls={`expandPrice-content"`} id={`expandPrice-header`}> </AccordionSummary>
                <AccordionDetails>
                  <div className='flex col w-1/1 md-flex md-row'>
                    <div className='flex-1'></div>
                    <div className='flex-2'>
                      <div className='priceDetails py-3 px-7'>
                        <div className="content">
                          <div className="flex w-1/1 gap-3">
                          <table style={{visibility: isSample ? "visible" : "hidden",  position: isSample ? "static" : "absolute",  right : "0"}}>
                                  <tbody>
                                    <tr>
                                      <td className='no-translate notranslate'>{t("Sample prijs")}</td>
                                      <td  className='no-translate notranslate'>{`(${sampleProductPrice?.tempTierPriceSmaple?.length}x) `}{sampleProductPrice?.condtion_one ? `${euroCurrency(0)}` : data?.isFreeSample ? "0,00" : sampleProductPrice?.tempTierPriceSmaple?.length &&  !isNaN(Number(sampleProductPrice?.tempTierPriceSmaple?.[0])) ? euroCurrency(sampleProductPrice?.tempTierPriceSmaple[0]).trim() :"0,00"}</td>
                                    </tr>

                                    {isSample ? null
                                      : <tr>
                                        <td role="rowheader" className='no-translate notranslate'>{t("Digitale drukproef")}</td>
                                        <td><b className='normal green no-translate notranslate'>{t("Gratis")}</b></td>
                                      </tr>}
                                    {isSample ? null :
                                      <tr>
                                        <td role="rowheader" className='no-translate notranslate'>{t("Instelkosten")}</td>
                                        <td><b className='normal green no-translate notranslate'>{t("Gratis")}</b></td>
                                      </tr>}

                                    <tr>
                                      <td role="rowheader">{data?.settings?.sample_product_shipping?.label ? data?.settings?.sample_product_shipping?.label : "Verzendkosten"}</td>
                                        <td className='no-translate notranslate'>
                                        {data?.settings?.sample_product_shipping?.value && data?.settings?.sample_product_shipping?.value !== "0.00" ? euroCurrency(data?.settings?.sample_product_shipping?.value).trim():
                                        <b className='normal green no-translate notranslate'>{t("Gratis")}</b>
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td role="rowheader" className='no-translate notranslate'><b>{t("Totaal excl. BTW")}</b></td>
                                      <td className='no-translate notranslate'><b>{sampleProductPrice?.condtion_one && data?.settings?.sample_product_shipping?.value ? `${euroCurrency (data?.settings?.sample_product_shipping?.value).trim() }`: sampleProductPrice?.condtion_one ? "Gratis"
                                        : sampleProductPrice?.condition_two ? `${euroCurrency(sampleProductPrice?.highest_tier)}`.trim()
                                          : sampleProductPrice?.condtion_three ? `${euroCurrency(sampleProductPrice?.highest_tier)}`.trim()
                                            : <span>{t("Gratis")}</span>}</b></td>
                                    </tr>
                                 
                                   {selectedDetailsFinal.product_vat !== 21 ?
                                    <>
                                    {data?.settings?.sample_product_shipping?.value !== "0.00" ?
                                    <tr>
                                      <td role="rowheader">
                                        {`BTW 21% NL`}
                                      </td>
                                      <td className='no-translate notranslate'>
                                       {euroCurrency(parseFloat(data?.settings?.sample_product_shipping?.value ?? 0) * 0.21).trim()}
                                      </td>
                                    </tr>:""}
                                    {(sampleProductPrice?.condtion_one || data?.isFreeSample || 
                                        (sampleProductPrice?.tempTierPriceSmaple?.length && !isNaN(Number(sampleProductPrice?.tempTierPriceSmaple?.[0])))) ? (
                                        <tr>
                                          <td role="rowheader">
                                            {`BTW ${
                                              sampleProductPrice?.condtion_one && data?.settings?.sample_product_shipping?.value !== null
                                                ? selectedDetailsFinal.product_vat
                                                : data?.settings?.sample_product_shipping?.value !== null
                                                  ? selectedDetailsFinal.product_vat
                                                  : "0"
                                            }% NL`}
                                          </td>
                                          <td className='no-translate notranslate'>
                                            {sampleProductPrice?.condtion_one
                                              ? euroCurrency(0)
                                              : data?.isFreeSample
                                                ? "0,00"
                                                : sampleProductPrice?.tempTierPriceSmaple?.length && !isNaN(Number(sampleProductPrice?.tempTierPriceSmaple?.[0]))
                                                  ? euroCurrency((sampleProductPrice?.tempTierPriceSmaple?.length * sampleProductPrice?.tempTierPriceSmaple[0]) * (parseFloat((selectedDetailsFinal?.product_vat ?? 0).toFixed(2)) / 100))
                                                  : "0,00"}
                                          </td>
                                        </tr>
                                      ) : ""}
                                    </>
                                     :
                                    <tr>
                                      <td role="rowheader">
                                       {`BTW ${sampleProductPrice?.condtion_one && data?.settings?.sample_product_shipping?.value !== null
                                          ? selectedDetailsFinal.product_vat
                                          : data?.settings?.sample_product_shipping?.value !== null
                                            ? selectedDetailsFinal.product_vat
                                            : "0"}% NL`}
                                      </td>
                                      <td className='no-translate notranslate'>
                                      {(() => {
                                          const vatPercent = selectedDetailsFinal?.product_vat ?? 0;
                                          const vatRate = vatPercent / 100;

                                          let value = 0;

                                          if (sampleProductPrice?.condtion_one && data?.settings?.sample_product_shipping?.value) {
                                            value = (data?.settings?.sample_product_shipping?.value ?? 0) * vatRate;
                                          } else if (sampleProductPrice?.condtion_one) {
                                            value = 0;
                                          } else if (sampleProductPrice?.condition_two) {
                                            value = (sampleProductPrice?.highest_tier ?? 0) * vatRate;
                                          } else if (sampleProductPrice?.condtion_three) {
                                            value = (sampleProductPrice?.highest_tier ?? 0) * vatRate;
                                          } else {
                                            value = 0;
                                          }
                                          const safeValue = Math.round((value + Number.EPSILON) * 100) / 100;

                                          return euroCurrency(safeValue).trim();
                                        })()}
                                      </td>
                                    </tr>}

                                    <tr>
                                      <td role="rowheader" className='no-translate notranslate'>{t("Totaal incl. BTW")}</td>
                                      {selectedDetailsFinal?.product_vat !== 21 ?
                                      <td className='no-translate notranslate'>
                                        {(() => {
                                                  const round2 = n => Math.round((n + Number.EPSILON) * 100) / 100;

                                                  const vatRate21 = 0.21;
                                                  const vatRateProd = (selectedDetailsFinal?.product_vat ?? 0) / 100; // 0.09 here
                                                  const shippingEx = data?.settings?.sample_product_shipping?.value ?? 0;

                                                  if (sampleProductPrice?.condtion_one) {
                                                    if (shippingEx) {
                                                      const shippingInc = round2(shippingEx * (1 + vatRate21));
                                                      return euroCurrency(shippingInc).trim();
                                                    }
                                                    return <span>{t("Gratis")}</span>;
                                                  }

                                                  const unit = parseFloat(sampleProductPrice?.tempTierPriceSmaple?.[0] ?? 0) || 0; 
                                                  const qty  = sampleProductPrice?.tempTierPriceSmaple?.length || 0;               
                                                  const sampleEx = unit * qty;                                                    

                                                  const sampleInc  = round2(sampleEx  * (1 + vatRateProd)); 
                                                  const shippingInc = round2(shippingEx * (1 + vatRate21)); 

                                                  const totalInc = round2(sampleInc + shippingInc); 

                                                  return euroCurrency(totalInc).trim();
                                                })()}

                                      </td> :
                                      <td className='no-translate notranslate'>
                                       {sampleProductPrice?.condtion_one ? (
                                            data?.settings?.sample_product_shipping?.value ? (
                                              euroCurrency(
                                                Math.round(
                                                  ( (data.settings.sample_product_shipping.value ?? 0) *
                                                    (1 + (selectedDetailsFinal?.product_vat ?? 0) / 100)
                                                  + Number.EPSILON
                                                  ) * 100
                                                ) / 100
                                              ).trim()
                                            ) : (
                                              <span>{t("Gratis")}</span>
                                            )
                                          ) : (
                                            euroCurrency(
                                              Math.round(
                                                ( (sampleProductPrice?.highest_tier ?? 0) *
                                                  (1 + (selectedDetailsFinal?.product_vat ?? 0) / 100)
                                                + Number.EPSILON
                                                ) * 100
                                              ) / 100
                                            ).trim() || <span>{t("Gratis")}</span>
                                          )}
                                      </td>
                                       }
                                    </tr>
                                  </tbody>
                                </table>
                          
                                <table style={{visibility: !isSample ? "visible" : "hidden", position: !isSample ? "static" : "absolute", right : "0"}}>
                                  <tbody>
                                    {isSample ? null :
                                      <tr>
                                        <td role="rowheader" className='no-translate notranslate'>{t("Prijs per stuk")}</td>
                                        <td className='no-translate notranslate'>{`(${qty}x) `}{euroCurrency(getPriceForQty(qty,selectedDetailsFinal?.tier_prices)).trim()}</td>
                                      </tr>
                                    }
                                    <>
                                      {
                                        selectedDetailsFinal?.custom_prices?.length > 0 &&
                                          Object.entries(
                                            selectedDetailsFinal.custom_prices.reduce((acc, item) => {
                                              const label = item.custom_price_name;
                                              const value = parseFloat(item.custom_price);
                                              acc[label] = (acc[label] || 0) + value;
                                              return acc;
                                            }, {})
                                          ).map(([label, total], index) => (
                                            <tr key={`custom-price-${index}`}>
                                              <td>{label}</td>
                                              <td>{total.toFixed(2).replace(".", ",")}</td>
                                            </tr>
                                          ))
                                      }
                                    </>

                                    {isSample ? null :
                                      <tr>
                                        <td role="rowheader" className='no-translate notranslate'>{t("Instelkosten")}</td>
                                       <td className='no-translate notranslate'>{selectedDetailsFinal?.setup_costs ? `${euroCurrency(selectedDetailsFinal.setup_costs * (isCpkerLength ? isCpkerLength : 1)).trim()}` : <b className='normal green no-translate notranslate'>{t("Gratis")}</b>}</td>

                                      </tr>}
                                    {isSample ? null :
                                      <tr>
                                        <td  role="rowheader"className='no-translate notranslate'>{t("Digitale drukproef")}</td>
                                        <td><b className='normal green no-translate notranslate'>{t("Gratis")}</b></td>
                                      </tr>
                                    }

                                    {selectedDetailsFinal.change_costs ? (
                                      <tr>
                                        <td role="rowheader" className='no-translate notranslate'>{t("Maatwisselkosten")}</td>
                                       <td className='no-translate notranslate'>{`${euroCurrency(selectedDetailsFinal.change_costs)}`.trim()}</td>
                                      </tr>
                                    ) : null}
                                    <tr>
                                      <td role="rowheader" className='no-translate notranslate'>{t("Verzendkosten")}</td>
                                      <td>{shippingCostsFree1 == true ?
                                        <b className='normal green no-translate notranslate'>{t("Gratis")}</b> : <b className='normal green no-translate notranslate'>{t("Zie winkelwagen")}</b>}</td>

                                    </tr>
                                    {selectedDetailsFinal?.product_cost_name ?
                                      <tr>
                                        <td role="rowheader">{selectedDetailsFinal?.product_cost_name}</td>
                                       <td className='no-translate notranslate'>{`${euroCurrency(selectedDetailsFinal?.amount_per_piece === "1" ? qty * selectedDetailsFinal?.product_cost_value : selectedDetailsFinal?.product_cost_value)}`.trim()}</td>
                                      </tr> : ""}
                                   
                                    <tr>
                                      <td role="rowheader" className='no-translate notranslate'><b>{t("Totaal excl. BTW")}</b></td>
                                      {isCustomQty ? (
                                       <td className='no-translate notranslate'><b>{`${euroCurrency(
                                          parseFloat((
                                            ((parseFloat(qtyData?.price?.toFixed(2)) || 0) * (isSample ? sampleQty : qtyTemp)) +
                                            ((parseFloat(selectedDetailsFinal?.setup_costs?.toFixed(2)) || 0) * (isCpkerLength ? isCpkerLength : 1)) +
                                            (parseFloat(selectedDetailsFinal?.change_costs?.toFixed(2)) || 0) +
                                            (selectedDetailsFinal?.amount_per_piece === "1"
                                              ? ((parseFloat(selectedDetailsFinal?.product_cost_value?.toFixed(2)) || 0) * qtyTemp)
                                              : (parseFloat(selectedDetailsFinal?.product_cost_value?.toFixed(2)) || 0))+ (
                                                Array.isArray(selectedDetailsFinal?.custom_prices)
                                                  ? selectedDetailsFinal.custom_prices.reduce((acc, item) => {
                                                      return acc + parseFloat(item?.custom_price || 0);
                                                    }, 0)
                                                  : 0
                                              )

                                          ).toFixed(2))
                                        )}`.trim()}</b></td>
                                      ) : (
                                        <td className='no-translate notranslate'><b>{`${euroCurrency(
                                          parseFloat((
                                            ((parseFloat(qtyData?.price?.toFixed(2)) || 0) * (isSample ? sampleQty : qty)) +
                                            ((parseFloat(selectedDetailsFinal?.setup_costs?.toFixed(2)) || 0) * (isCpkerLength ? isCpkerLength : 1)) +
                                            (parseFloat(selectedDetailsFinal?.change_costs?.toFixed(2)) || 0) +
                                            (selectedDetailsFinal?.amount_per_piece === "1"
                                              ? ((parseFloat(selectedDetailsFinal?.product_cost_value?.toFixed(2)) || 0) * qty)
                                              : (parseFloat(selectedDetailsFinal?.product_cost_value?.toFixed(2)) || 0))+ (
                                              Array.isArray(selectedDetailsFinal?.custom_prices)
                                                ? selectedDetailsFinal.custom_prices.reduce((acc, item) => {
                                                    return acc + parseFloat(item?.custom_price || 0);
                                                  }, 0)
                                                : 0
                                            )

                                          ).toFixed(2))
                                        )}`.trim()}</b></td>
                                      )}
                                    </tr>
                                    {selectedDetailsFinal.product_vat !== 21 ?  
                                    <>
                                        {(() => {
                                            const setupCost = selectedDetailsFinal.setup_costs ?? 0;
                                            const changeCost = selectedDetailsFinal.change_costs ?? 0;
                                            const productCost = selectedDetailsFinal?.amount_per_piece === "1"
                                              ? (isCustomQty ? qtyTemp : qty) * (selectedDetailsFinal?.product_cost_value ?? 0)
                                              : (selectedDetailsFinal?.product_cost_value ?? 0);

                                            const customPrices = Array.isArray(selectedDetailsFinal?.custom_prices)
                                              ? selectedDetailsFinal.custom_prices.reduce((acc, item) => acc + (parseFloat(item?.custom_price ?? 0) || 0), 0)
                                              : 0;

                                            const baseValue = (setupCost * (isCpkerLength || 1)) + changeCost + productCost + customPrices;

                                            const vatValue = baseValue * 0.21;

                                            if (vatValue === 0) return null;

                                            // Round safely at display time
                                            const safeRoundedVat = Math.round((vatValue + Number.EPSILON) * 100) / 100;

                                            return (
                                              <tr>
                                                <td role="rowheader">{`BTW 21% NL`}</td>
                                                <td className='no-translate notranslate'>
                                                  {euroCurrency(safeRoundedVat).trim()}
                                                </td>
                                              </tr>
                                            );
                                          })()}
                                     <tr>
                                      <td role="rowheader">BTW {`${selectedDetailsFinal.product_vat}% NL`}</td>
                                      {isCustomQty ? (
                                        <td className='no-translate notranslate'>
                                          {euroCurrency(
                                            Math.round(
                                              ((qtyData?.price ?? 0)?.toFixed(2) * (isSample ? sampleQty : qtyTemp) * ((selectedDetailsFinal.product_vat ?? 0) / 100) + Number.EPSILON) * 100
                                            ) / 100
                                          ).trim()}
                                        </td>
                                      ) : (
                                        <td className='no-translate notranslate'>
                                          {euroCurrency(
                                            Math.round(
                                              ((qtyData?.price ?? 0)?.toFixed(2) * (isSample ? sampleQty : qty) * ((selectedDetailsFinal.product_vat ?? 0) / 100) + Number.EPSILON) * 100
                                            ) / 100
                                          ).trim()}
                                        </td>
                                      )}
                                    </tr>
                                    </>
                                    :
                                    <tr>
                                     <td  role="rowheader">BTW {`${selectedDetailsFinal.product_vat}% NL`}</td>
                                     {(() => {
                                          const qtyValue = isCustomQty ? qtyTemp : qty;

                                          const baseValue =
                                            (qtyData?.price ?? 0)?.toFixed(2) * (isSample ? qtyValue : qtyValue) +
                                            (selectedDetailsFinal.setup_costs ?? 0) * (isCpkerLength || 1) +
                                            (selectedDetailsFinal.change_costs ?? 0) +
                                            (selectedDetailsFinal?.amount_per_piece === "1"
                                              ? qtyValue * (selectedDetailsFinal?.product_cost_value ?? 0)
                                              : (selectedDetailsFinal?.product_cost_value ?? 0)) +
                                            (Array.isArray(selectedDetailsFinal?.custom_prices)
                                              ? selectedDetailsFinal.custom_prices.reduce(
                                                  (acc, item) => acc + (parseFloat(item?.custom_price ?? 0) || 0),
                                                  0
                                                )
                                              : 0);

                                          // Convert to cents for accurate VAT
                                          const vatRate = Number(selectedDetailsFinal.product_vat ?? 0);
                                          const baseCents = Math.round(baseValue * 100);       
                                          const vatCents = Math.round((baseCents * vatRate) / 100);  
                                          const safeVat = vatCents / 100;                            

                                          return (
                                            <td className="no-translate notranslate">
                                              {euroCurrency(safeVat).trim()}
                                            </td>
                                          );
                                        })()}
                                    </tr>
                                  }
                                   <tr>
                                      <td role="rowheader" className='no-translate notranslate'>{t("Totaal incl. BTW")}</td>
                                      {isCustomQty ? (
                                      <>
                                     {(() => {
                                          const toCents = value => Math.round(Number(value) * 100);
                                          const toEuros = cents => cents / 100;

                                          const setupCost = selectedDetailsFinal.setup_costs ?? 0;
                                          const changeCost = selectedDetailsFinal.change_costs ?? 0;
                                          const productCost =
                                            selectedDetailsFinal?.amount_per_piece === "1"
                                              ? qtyTemp * (selectedDetailsFinal?.product_cost_value ?? 0)
                                              : (selectedDetailsFinal?.product_cost_value ?? 0);

                                          const customPrices = Array.isArray(selectedDetailsFinal?.custom_prices)
                                            ? selectedDetailsFinal.custom_prices.reduce(
                                                (acc, item) => acc + (parseFloat(item?.custom_price ?? 0) || 0),
                                                0
                                              )
                                            : 0;

                                          const qtyPrice = (qtyData?.price ?? 0)?.toFixed(2) * (isSample ? sampleQty : qtyTemp);
                                          const vatPercent = Number(selectedDetailsFinal?.product_vat ?? 0);

                                          const setupEtcEx = (setupCost * (isCpkerLength || 1)) + changeCost + productCost + customPrices;

                                          // Convert to cents first
                                          const qtyPriceCents = toCents(qtyPrice);
                                          const setupEtcExCents = toCents(setupEtcEx);

                                          let vat21Cents = 0;
                                          let vatOtherCents = 0;

                                          if (vatPercent === 21) {
                                            // Everything gets 21%
                                            vat21Cents = Math.round((setupEtcExCents + qtyPriceCents) * 0.21);
                                          } else {
                                            // Setup/etc at 21%
                                            vat21Cents = Math.round(setupEtcExCents * 0.21);
                                            // Products at product VAT rate (e.g., 9%)
                                            vatOtherCents = Math.round(qtyPriceCents * (vatPercent / 100));
                                          }

                                          const safeTotalCents = setupEtcExCents + qtyPriceCents + vat21Cents + vatOtherCents;

                                          return (
                                            <td className="no-translate notranslate">
                                              {euroCurrency(toEuros(safeTotalCents)).trim()}
                                            </td>
                                          );
                                        })()}
                                      </>
                                      ) : (
                                      <>
                                      {(() => {
                                            const toCents = value => Math.round(Number(value) * 100);
                                            const toEuros = cents => cents / 100;

                                            const setupCost   = (selectedDetailsFinal.setup_costs ?? 0) * (isCpkerLength || 1);
                                            const changeCost  = selectedDetailsFinal.change_costs ?? 0;
                                            const productCost = selectedDetailsFinal?.amount_per_piece === "1"
                                              ? qty * (selectedDetailsFinal?.product_cost_value ?? 0)
                                              : (selectedDetailsFinal?.product_cost_value ?? 0);

                                            const customPrices = Array.isArray(selectedDetailsFinal?.custom_prices)
                                              ? selectedDetailsFinal.custom_prices.reduce(
                                                  (acc, item) => acc + (parseFloat(item?.custom_price ?? 0) || 0),
                                                  0
                                                )
                                              : 0;

                                            const productEx = (qtyData?.price ?? 0)?.toFixed(2) * (isSample ? sampleQty : qty);
                                            const setupEtcEx = setupCost + changeCost + productCost + customPrices;
                                            const vatPercent = Number(selectedDetailsFinal?.product_vat ?? 0);

                                            // Convert all amounts to cents
                                            const productExCents = toCents(productEx);
                                            const setupEtcExCents = toCents(setupEtcEx);

                                            let vat21Cents = 0;
                                            let vatOtherCents = 0;

                                            if (vatPercent === 21) {
                                              // Everything at 21%
                                              vat21Cents = Math.round(productExCents * 0.21 + setupEtcExCents * 0.21);
                                            } else {
                                              // Setup/etc at 21%
                                              vat21Cents = Math.round(setupEtcExCents * 0.21);
                                              // Product at product VAT
                                              vatOtherCents = Math.round(productExCents * (vatPercent / 100));
                                            }

                                            const subtotalCents = productExCents + setupEtcExCents;
                                            const grandTotalCents = subtotalCents + vat21Cents + vatOtherCents;

                                            return (
                                              <td className="no-translate notranslate">
                                                {euroCurrency(toEuros(grandTotalCents)).trim()}
                                              </td>
                                            );
                                          })()}
                                      </>
                                      )}
                                    </tr>
                                  </tbody>
                                </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              {isSample ? (
                <React.Fragment>
                  <div className='flex w-1/1 top-1 action'>
                    <div className='flex-1'></div>
                    <div className='flex-0 tr'>
                      <button  aria-label="button" className='text-nowrap fw-300' onClick={() => setExpandPrice(!expandPrice)}>{expandPrice ? <span className='no-translate notranslate'>{t("Verberg prijsdetails")}</span> : <span className='no-translate notranslate'>{t("Bekijk prijsdetails")}</span>}</button>
                    </div>
                  </div>
                  <div className='flex w-1/1 top-1 priceFinal'>
                    <div className='flex-1 no-translate notranslate'>{t("Totaal (excl. BTW)")}</div>
                   <div className='flex-0 tr no-translate notranslate'>{
                      sampleProductPrice?.condtion_one && data?.settings?.sample_product_shipping?.value ? `${euroCurrency(data?.settings?.sample_product_shipping?.value)}` : sampleProductPrice?.condtion_one ? "Gratis"
                        : sampleProductPrice?.condition_two ?
                          `${euroCurrency(
                            (sampleProductPrice?.highest_tier)
                          )}`
                          : sampleProductPrice?.condtion_three ?
                            `${euroCurrency(
                              (sampleProductPrice?.highest_tier)
                            )}`
                            : <span>{t("Gratis")}</span>

                    }</div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className='flex w-1/1 top-1 action'>
                    <div className='flex-1'></div>
                    <div className='flex-0 tr'>
                      <button aria-label="button" className='text-nowrap fw-300' onClick={() => setExpandPrice(!expandPrice)}>{expandPrice ? <span className='no-translate notranslate'>{t("Verberg prijsdetails")}</span> : <span className='no-translate notranslate'>{t("Bekijk prijsdetails")}</span>}</button>
                    </div>
                  </div>
                  <div className='flex w-1/1 top-1 priceFinal'>
                    <div className='flex-1 no-translate notranslate'>{t("Totaal (excl. BTW)")}</div>
                    {isCustomQty ?
                      <div className='flex-0 tr no-translate notranslate'>{`${euroCurrency(
                        ((qtyData?.price?.toFixed(2) * qtyTemp) + selectedDetailsFinal.setup_costs * (isCpkerLength ? isCpkerLength : 1) + selectedDetailsFinal.change_costs + (selectedDetailsFinal?.amount_per_piece === "1" ? qtyTemp * selectedDetailsFinal?.product_cost_value : selectedDetailsFinal?.product_cost_value))
                      )}`}</div>
                      :
                       <div className='flex-0 tr no-translate notranslate'>
                        {`${euroCurrency(
                          parseFloat(
                            (
                              (parseFloat((qtyData?.price ?? 0)?.toFixed(2)) * (isSample ? sampleQty : qty)) + // Round price before multiplying
                              (parseFloat((selectedDetailsFinal?.setup_costs ?? 0).toFixed(2)) * (isCpkerLength ? isCpkerLength : 1)) + // Round setup costs
                              parseFloat((selectedDetailsFinal?.change_costs ?? 0).toFixed(2)) + // Round change costs
                              (selectedDetailsFinal?.amount_per_piece === "1"
                                ? (parseFloat((selectedDetailsFinal?.product_cost_value ?? 0).toFixed(2)) * qty) // Round before multiplying qty
                                : parseFloat((selectedDetailsFinal?.product_cost_value ?? 0).toFixed(2)) // Just round product cost
                              ) + (Array.isArray(selectedDetailsFinal?.custom_prices)
                              ? selectedDetailsFinal.custom_prices.reduce(
                                  (acc, item) => acc + parseFloat(item?.custom_price ?? 0),
                                  0
                                )
                              : 0)
                            ).toFixed(2) // Final rounding before currency conversion
                          ) || 0 // Prevents errors
                        )}`.trim()}
                      </div>
                    }
                  </div>
                </React.Fragment>
              )}
            </div>
            {errorCart &&
            <Grow in={true} direction="up" mountOnEnter >
              <div className='alertBox error'>
                <div className="msg">{errorCart}</div>
              </div>
            </Grow> }
            <div className="action__blocks pt-2 flex col gap-y-6">
                <React.Fragment>
                <div style={{ display : isSample ? "block" : "none"}}>
                  <Button
                    className={`fs-20 line-8 fw-700 r-9 py-5 px-5 ${isProcessing ? 'rotateUpdate' : ''}`}
                    fullWidth
                    disabled={isProcessing}
                    onClick={() => {
                      const hasExactlyOneOptionVariant = allData?.[lastVariantKey]?.thisType === "variant" && Array.isArray(allData?.[lastVariantKey]?.options) && allData[lastVariantKey].options.length === 1;
                      const shouldSetNextClicked = hasExactlyOneOptionVariant && isSample;

                      // if(showError === false && samplenextNav === true && lastVariantKey){
                      if(showError === false && (shouldSetNextClicked || isNextClicked) && lastVariantKey){
                      isLoggedUser ? customerAddToCart(1) : guestAddToCart(1);
                      triggerHotjarEvent('order_button_click');
                      } 
                       else {
                        // isLoggedUser ? customerAddToCart(1) : guestAddToCart(1);
                        // triggerHotjarEvent('order_button_click');
                        setShowError(true);
                        setIsNextClicked(false);
                        setExpanded(`${allData[lastVariantKey]?.variantPosition}`);
                         setTimeout(() => {
                          const errorEl = document.querySelector(".error-container");
                          if (errorEl) {
                            errorEl.scrollIntoView({ behavior: "smooth", block: "center" });
                          }
                        }, 0);
                      }
                    }}
                    style={{ minHeight: 72 }}
                  >{isProcessing ? <AutorenewIcon /> : <> <div className='flex middle no-translate notranslate'>{t("Vraagsampleaan")}</div><span className='flex middle'><KeyboardArrowRightIcon /></span></>}
                  </Button>
                  </div>
                </React.Fragment>
                <React.Fragment>
                    <div style={{ display : !isSample ? "block" : "none"}}>
                  <Button
                    className={`fs-20 line-8 fw-700 r-9 py-5 px-5 mb-3 ${isProcessing ? 'rotateUpdate' : ''}`}
                    fullWidth disabled={isProcessing || isProcessing1} style={{ minHeight: 72 }}
                    onClick={() => {
                      if(qty > 0 && completed === false){
                        setShowError(false)
                        setcompleted(true)
                      } else if ( completed === true && qty) {
                        setShowError(true); 
                      }
                      else {
                        setShowError(true); 
                      }
                      if (cmsError == "") {
                        setCmsError("false")
                      }
                      triggerHotjarEvent('order_button_click');
                      isLoggedUser ? customerAddToCart(1) : guestAddToCart(1);

                      if(isCustomQty){
                        const selectedD = { ...selectedData };
                          setSelectedData(selectedD);
                        setReqExpanded(true);
                        UpdateTextQty(qtyTemp, selectedDetailsFinal, setQty, setQtyTemp, getDeliveryDate, getApiCartOptions);
                        if (selectedDetailsFinal?.tier_prices?.length) {
                          setIsCustomQty(true)
                        }
                      }
                    }}
                  >
                    {isProcessing ? <AutorenewIcon /> : <><div className='flex middle no-translate notranslate'>{t("Bestellen")} <span className='flex middle'><KeyboardArrowRightIcon /></span></div></>}
                  </Button>
                  {storeId == 1 ?
                    <Button className={`fs-20 line-8 fw-700 r-9 py-5 px-5 ${isProcessing1 ? 'rotateUpdate' : ''}`}
                      fullWidth disabled={isProcessing || isProcessing1} style={{ minHeight: 72 }}
                      onClick={() => {
                        if (cmsError == "") {
                          setCmsError("false")
                        }
                        triggerHotjarEvent('quote_request_click');
                        isLoggedUser ? customerAddToCart(0) : guestAddToCart(0);
                      }}
                    >
                      {isProcessing1 ? <AutorenewIcon /> : <span className='no-translate notranslate'  role="heading" aria-level="2">{t("Vrijblijvende_offerte")}</span>}
                    </Button> : ""
                  }
                </div>
                </React.Fragment>
              <div className="share flex col lg-flex lg-row gap-3 center pb-2 lg-pb-0">
                {data?.settings?.stock_status ? <React.Fragment>
                  {
                    wishItem?.length ?
                      <div
                        className="flex middle gap-2 pointer center"
                        onClick={() => removeWishlist(baseURL, token, dispatch, wishItem?.[0]?.itemId, productSku, wishlistAddedData, customerId, storeId, () => { }, navigate, isSessionExpired)}
                        role='button'
                        tabIndex="0"
                        aria-label="remove-wishlist"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            removeWishlist(baseURL, token, dispatch, wishItem?.[0]?.itemId, productSku, wishlistAddedData, customerId, storeId, () => { }, navigate, isSessionExpired);
                          }
                        }}
                      >
                        <FullWishlist role="presentation" />
                        <span className='fs-15 line-6 no-translate notranslate'>{t("Bewaard in favorieten")}</span>
                      </div> :
                      <div
                        className="flex middle gap-2 pointer center"
                        onClick={() => {
                          if (!isLoggedUser) {
                            dispatch(ACTION_OPEN__LOGIN(true));
                            dispatch(ACTION_OPEN__FORGOTPASSWORD(false));
                            dispatch(ACTION_WISHLISTPRODUCTID({ id: productId, sku: productSku }));
                            dispatch(ACTION_GET__URLTYPE('pdp'));
                          } else {

                            if (!wishItem?.length) {
                              addToWishlist__gtm(productSku, productName)
                              addWishList(defaultURL, dispatch, token, customerId, { id: productId, sku: productSku }, wishlistAddedData, storeId, navigate, isSessionExpired);
                            }
                          }
                        }}
                        role='button'
                        tabIndex="0"
                        aria-label="add-wishlist"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            if (!isLoggedUser) {
                              dispatch(ACTION_OPEN__LOGIN(true));
                              dispatch(ACTION_OPEN__FORGOTPASSWORD(false));
                              dispatch(ACTION_WISHLISTPRODUCTID({ id: productId, sku: productSku }));
                              dispatch(ACTION_GET__URLTYPE('pdp'));
                            } else {
                              if (!wishItem?.length) {
                                addToWishlist__gtm(productSku, productName)
                                addWishList(defaultURL, dispatch, token, customerId, { id: productId, sku: productSku }, wishlistAddedData, storeId, navigate, isSessionExpired);
                              }
                            }
                          }
                        }}
                      >
                        <WishIcon className="pointer" color="#222" role="presentation" />
                        <span className='fs-15 line-6 no-translate notranslate'>{t("Toevoegen in favorieten")}</span>
                      </div>
                  }
                  <div className='arrow hide lg-block'></div>
                </React.Fragment> : null}
                <div className="flex middle gap-2 pointer center" onClick={() => setOpenCopyURLModel(true)} 
                role='button' 
                tabIndex={0} 
                aria-label="copy-url"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setOpenCopyURLModel(true);
                  }
                }}
                 >
                  <CopyUrl role="presentation" />
                  <span className='fs-15 line-6 no-translate notranslate'>{t("Deeluwconfiguratiemetuniekelink")}</span>
                </div>
              </div>
              <div className="ups__content flex col gap-3">
                <div
                  className="flex middle space-between pointer"
                  onClick={() => {
                    uspHandler(productDetailsStaticData?.feature_content?.[0]?.menu?.tag_url);
                    // purposely commented
                    // setOpenModelUPS(true)
                    // setServicesDetailsData(data?.settings?.feature_content && data?.settings?.feature_content?.[2]?.menu ? data?.settings?.feature_content?.[2]?.menu : null)
                  }}
                   role='button' 
                   tabIndex={0}
                   aria-label="usp-content" 
                   onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      uspHandler(productDetailsStaticData?.feature_content?.[0]?.menu?.tag_url);
                    }
                  }} 
                  Fragment  >
                  <div className="flex middle gap-3 lg-gap-2">
                    <ValidSuccesArrow role="presentation"  />
                    {
                      storeId === 1 ?
                        <span className='fs-15 line-6 no-translate notranslate'>{t("Ervaar onze")} <b className='fw-700'>{t("snelle topservice!")}</b></span>
                        :
                        <span className='fs-15 line-6 no-translate notranslate'><b className='fw-700'>{t("High level service")} </b><span className='hide lg-inline-block'>{t("met een vast contact persoon")}</span></span>
                    }
                  </div>
                  <KeyboardArrowRightIcon />
                </div>
                <div
                  className="flex middle space-between pointer"
                  onClick={() => {
                    uspHandler(productDetailsStaticData?.feature_content?.[1]?.menu?.tag_url);
                    // purposely commented
                    // setOpenModelUPS(true)
                    // setServicesDetailsData(data?.settings?.feature_content && data?.settings?.feature_content?.[1]?.menu ? data?.settings?.feature_content?.[1]?.menu : null)
                  }}
                  role='button' 
                  tabIndex={0}
                  aria-label="usp-content" 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      uspHandler(productDetailsStaticData?.feature_content?.[1]?.menu?.tag_url);
                    }
                  }}

                >
                  <div className="flex middle gap-3 lg-gap-2">
                    <ValidSuccesArrow role="presentation" />
                    {
                      storeId === 1 ?
                        <span className='fs-15 line-6 no-translate notranslate'><b className='fw-700'>{t("Laagste prijsgarantie")}<b className='hide lg-inline'>:</b></b> <span className='hide lg-inline-block'>{t("elders goedkoper? Wij matchen!")}</span></span>
                        :
                        <span className='fs-15 line-6 no-translate notranslate'><b className='fw-700'>{t("Beste prijs-kwaliteitverhouding")}</b></span>
                    }
                  </div>
                  <KeyboardArrowRightIcon />
                </div>
                <div
                  className="flex middle space-between pointer"
                  onClick={() => {
                    uspHandler(productDetailsStaticData?.feature_content?.[2]?.menu?.tag_url);
                    // purposely commented
                    // setOpenModelUPS(true)
                    // setServicesDetailsData(data?.settings?.feature_content && data?.settings?.feature_content?.[0]?.menu ? data?.settings?.feature_content?.[0]?.menu : null)
                  }}
                  role='button' 
                  tabIndex={0}
                  aria-label="usp-content" 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      uspHandler(productDetailsStaticData?.feature_content?.[2]?.menu?.tag_url);
                    }
                  }}
                  >
                  <div className="flex middle gap-3 lg-gap-2">
                    <ValidSuccesArrow role="presentation"  />
                    {
                      storeId === 1 ?
                        <span className='fs-15 line-6 no-translate notranslate'><b className='fw-700'>{t("Gratis digitaal voorbeeld")}</b> <span className='hide lg-inline-block'>{t("binnen enkele uren in uw e-mail!")}</span></span>
                        :
                        <span className='fs-15 line-6 no-translate notranslate'><b className='fw-700'>{t("Eigen productie")}</b> <span className='hide lg-inline-block'>{t("dus snel geleverd")}</span></span>
                    }
                  </div>
                  <KeyboardArrowRightIcon />
                </div>
                <div
                  className="flex middle space-between pointer"
                  onClick={() => {
                    uspHandler(productDetailsStaticData?.feature_content?.[3]?.menu?.tag_url);
                    // purposely commented
                    // setOpenModelUPS(true)
                    // setServicesDetailsData(data?.settings?.feature_content && data?.settings?.feature_content?.[3]?.menu ? data?.settings?.feature_content?.[3]?.menu : null)
                  }}
                  role='button' 
                  tabIndex={0}
                  aria-label="usp-content" 
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      uspHandler(productDetailsStaticData?.feature_content?.[3]?.menu?.tag_url);
                    }
                  }}
                >
                  <div className="flex middle gap-3 lg-gap-2">
                    <ValidSuccesArrow role="presentation"  />
                    {
                      storeId === 1 ?

                        <span className='fs-15 line-6'><b className='fw-700'>{t("Veilig betalen")}</b> <span className='hide lg-inline-block'>{t("o.a. iDeal, Bancontact, ook achteraf!")}</span></span>
                        :
                        <span className='fs-15 line-6'><b className='fw-700'>{t("Veilig betalen")}</b> <span className='hide lg-inline-block'>{t("o.a. iDeal, Bancontact, ook achteraf!")}</span></span>
                    }
                  </div>
                  <KeyboardArrowRightIcon />
                </div>
              </div>
            </div>
          </div>}
        <ModelNew
          from="top"
          hideScroll={false}
          zindex={11}
          open={openModelQty}
          shadow={true}
          setOpen={setOpenModelQty}
          className="pdp_quantity_popup"
        >
          <div className='qtyTable_popup'>
            <div className='flex py-2 px-2'>
              <div className=" tr flex left w-1/1 middle">
                <h2 className='fw-700 fs-20 no-translate notranslate'>
                  {t("Prijstabel")}
                </h2>
              </div>
              <div className="close__block tr flex right w-1/1">
                <CloseButton onClickFunction={() => setOpenModelQty(false)} />
              </div>
            </div>

            <div className="flex w-1/1 qtyTable1 ">
              <div className="table-head">
                <div className="table-row table-row-title">
                  <div className="item-cell no-translate notranslate">{t("Aantal")}</div>
                  <div className="item-cell no-translate notranslate"><i>{t("Bespaar")}</i></div>
                  <div className="item-cell no-translate notranslate">{t("Stuksprijs")}</div>

                  {width <= 768 ?
                    <div className="item-cell no-translate notranslate">{t("Totaalprijs")}</div>
                    :
                    <div className="item-cell no-translate notranslate">{t("Totaal (excl. BTW)")}</div>
                  }
                </div>
              </div>
              <div className="table-body">
                {selectedDetailsFinal?.tier_prices?.length || initialTierPricePopup?.tier_prices?.length ? (
                  selectedDetailsFinal?.tier_prices?.length ? 
                  selectedDetailsFinal.tier_prices
                   : initialTierPricePopup?.tier_prices).map((item, i) => (
                    <div key={`qty_${i}`} className={`relative table-row`} onClick={() => { setReqExpanded(true); setQty(item.qty) }}>
                      <div className="item-cell " data-label="Quantity">
                        <div className='flex middle gap-4'>
                          <span>{item?.qty}</span>
                        </div>
                      </div>
                      {
                        !item.hide && item.qty > 1 ?
                          <div className="item-cell no-translate notranslate" data-label="Save">
                            <i>
                              <>
                                {Math.round(((((selectedDetailsFinal?.tier_prices?.length ? selectedDetailsFinal.tier_prices[0].price 
                                : initialTierPricePopup?.tier_prices[0].price || 0) + qtyData.addOnPrice) - ((item?.price
                                  || 0) + qtyData.addOnPrice)) / ((selectedDetailsFinal?.tier_prices?.length ? selectedDetailsFinal.tier_prices[0].price 
                                    : initialTierPricePopup?.tier_prices[0].price || 0) + qtyData.addOnPrice))
                                  * 100) || <span className='hypen'>-</span>}
                                <span>%</span>
                              </>
                            </i>
                          </div>
                          :
                          <div className="item-cell fs-12 flex middle" data-label="Save">
                            <i className='no-translate notranslate'>
                              {t("Anderaantal")}
                             </i>
                          </div>
                      }
                      <div className="item-cell flex middle no-translate notranslate" data-label="Price">{`${item.hide ? "-" : euroCurrency((item?.price || 0) +
                        qtyData.addOnPrice)}`}</div>
                      <div className="item-cell flex middle no-translate notranslate" data-label="Total">{`${item.hide ? "-" : euroCurrency(((item?.price || 0) +
                        qtyData.addOnPrice) * item.qty)}`}</div>
                    </div>
                  )) :
                  <div><div className="item-cell " style={{ height: 12 }}></div></div>}
              </div>

            </div>
          </div>
        </ModelNew>
      </div>
      {<ColorPicker
        selectedColorData={selectedColorData}
        selectedColorItem={selectedColorItem}
        setSelectedColorItem={setSelectedColorItem}
        openColorModel={openColorModel}
        setOpenColorModel={setOpenColorModel}
        data={[{ color_picker: translateData?.color_picker || { totalRecords: 0, items: [] } }]} />}
      {/* MODEL */}
      <ServicesDetails openModel={openModelUPS} setOpenModel={setOpenModelUPS} servicesDetailsData={servicesDetailsData} translate={translateData?.translations} />
      <InfoDetails openModel={openModelInfo} setOpenModel={setOpenModelInfo} servicesDetailsData={servicesDetailsData} translate={translateData?.translations} />
      <AccordionSidebar openModel={openFreeSample} setOpenModel={setOpenFreeSample} isSampleCalled={isSampleCalled} setIsSampleCalled={setIsSampleCalled} tagUrl="sample" />
      <AccordionSidebar openModel={openModelUPSNew} setOpenModel={setOpenModelUPSNew} isSampleCalled={isUpsCalled} setIsSampleCalled={setIsUpsCalled} tagUrl={tagUrl} />
    </React.Fragment>
  );
};
export default ProductVariant;